export const OTP_TYPES = [
  { value: "AADHAAR_OTP", text: "AADHAAR OTP" },
  { value: "MOBILE_OTP", text: "MOBILE OTP" },
];
export const PURPOSE = [
  { value: "KYC_AND_LINK", text: "KYC AND LINK" },
  { value: "KYC", text: "KYC" },
  { value: "LINK", text: "LINK" },
];
export const REQUESTER_TYPES = [
  { value: "HIP", text: "HIP" },
  { value: "HIU", text: "HIU" },
];
export const HIP_REQUESTER_ID = "SSKM_HIP"; //"MEDePAL_22022022_HIP"
export const HIU_REQUESTER_ID = "Bankura_HIU"; //"MEDePAL_22022022_HIU"
export const RESEND_OTP_TIMEOUT = 60;
export const RESEND_OTP_CHANCE = 2;

export const DIAGNOSTIC_REPORT = {
  resourceType: "Bundle",
  id: "a9756eeb-3799-4c50-8f3a-f3ff411d0f0e",
  meta: {
    lastUpdated: "Wed Feb 02 23:13:39 IST 2022",
    profile: [],
  },
  identifier: {
    system: "http://hip.in",
    value: "6c14bc73-0eea-46eb-b02e-fbf68b10ea3b",
  },
  entry: [
    {
      fullUrl: "Composition/1",
      resource: {
        compositon: {
          resourceType: "Composition",
          id: "Composition/1",
          status: "FINAL",
          date: "Wed Feb 02 23:13:39 IST 2022",
          title: "Diagnostic Report Document",
          confidentiality: "null",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          identifier: {
            system: "http://hip.in",
            value: "1",
          },
          type: {
            coding: [
              {
                system: "https://ndhm.gov.in/sct",
                code: "721981007",
                display: "Diagnostic Report",
              },
            ],
          },
          subject: {
            reference: "Patient/1",
          },
          encounter: {},
          author: [
            {
              reference: "Practitioner/1",
            },
            {
              reference: "Organization/1",
            },
          ],
          custodian: {},
          section: [
            {
              title: "# Diagnostic Report",
              code: {
                coding: [
                  {
                    system: "https://projecteka.in/sct",
                    code: "721981007",
                    display: "Diagnostic Report",
                  },
                ],
              },
              entry: [
                {
                  reference: "DiagnosticReport/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
          ],
        },
      },
    },
    {
      fullUrl: "Practitioner/1",
      resource: {
        practitioner: {
          resourceType: "Practitioner",
          id: "Practitioner/1",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          identifier: [
            {
              system: "https://www.mciindia.in/doctor",
              value: "1",
              type: {
                coding: [],
              },
            },
          ],
          name: [
            {
              text: "LAB",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Organization/1",
      resource: {
        organization: {
          resourceType: "Organization",
          id: "Organization/1",
          name: "IPGMER & SSKMH",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          identifier: [
            {
              system: "https://facilitysbx.ndhm.gov.in",
              value: "1112423338",
              type: {
                coding: [],
              },
            },
          ],
          telcom: [
            {
              system: "PHONE",
              value: "9732240514",
              use: "null",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Patient/1",
      resource: {
        patient: {
          resourceType: "Patient",
          id: "Patient/1",
          gender: "MALE",
          birthDate: "null",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          identifier: [],
          name: [
            {
              text: "RAFIKUL HASAN",
            },
          ],
          telcom: [],
        },
      },
    },
    {
      fullUrl: "DiagnosticReport/1",
      resource: {
        diagnostic: {
          resourceType: "DiagnosticReport",
          id: "DiagnosticReport/1",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          identifier: [],
          basedOn: [],
          status: "FINAL",
          category: [],
          code: {
            coding: [],
          },
          subject: {
            reference: "Patient/1",
          },
          issued: "Wed Feb 02 23:13:39 IST 2022",
          performer: [
            {
              reference: "Organization/1",
            },
          ],
          resultsInterpreter: [
            {
              reference: "Practitioner/1",
            },
          ],
          specimen: [],
          result: [],
          conclusionCode: [],
          presentedForm: [],
        },
      },
    },
    {
      fullUrl: "DocumentReference/1",
      resource: {
        documentReference: {
          resourceType: "DocumentReference",
          id: "DocumentReference/1",
          status: "CURRENT",
          docStatus: "null",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          type: {
            coding: [
              {
                system: "https://projecteka.in/sct",
                code: "721981007",
                display: "Diagnostic Report",
              },
            ],
          },
          subject: {
            reference: "Patient/1",
          },
          content: [
            {
              attachment: {
                contentType: "application/pdf",
                data: [
                  37, 80, 68, 70, 45, 49, 46, 52, 10, 37, -30, -29, -49, -45,
                  10, 50, 32, 48, 32, 111, 98, 106, 10, 60, 60, 47, 84, 121,
                  112, 101, 47, 88, 79, 98, 106, 101, 99, 116, 47, 83, 117, 98,
                  116, 121, 112, 101, 47, 73, 109, 97, 103, 101, 47, 87, 105,
                  100, 116, 104, 32, 50, 48, 48, 47, 72, 101, 105, 103, 104,
                  116, 32, 49, 57, 56, 47, 76, 101, 110, 103, 116, 104, 32, 55,
                  51, 55, 53, 47, 67, 111, 108, 111, 114, 83, 112, 97, 99, 101,
                  91, 47, 73, 110, 100, 101, 120, 101, 100, 47, 68, 101, 118,
                  105, 99, 101, 82, 71, 66, 32, 54, 51, 40, -48, -48, -48, -22,
                  -22, -22, -77, -77, -77, -66, -66, -66, -20, -20, -20, -76,
                  -76, -76, -30, -30, -30, -70, -70, -70, -52, -52, -52, -68,
                  -68, -68, -16, -16, -16, -73, -73, -73, -45, -45, -45, -72,
                  -72, -72, -34, -34, -34, -43, -43, -43, -37, -37, -37, -50,
                  -50, -50, -54, -54, -54, -24, -24, -24, -64, -64, -64, -58,
                  -58, -58, -32, -32, -32, -60, -60, -60, -38, -38, -38, -62,
                  -62, -62, -40, -40, -40, -42, -42, -42, -1, -1, -1, -93, -93,
                  -93, -83, -83, -83, -87, -87, -87, -84, -84, -84, -86, -86,
                  -86, -88, -88, -88, -85, -85, -85, -89, -89, -89, -2, -2, -2,
                  -90, -90, -90, -4, -4, -4, -3, -3, -3, -80, -80, -80, -79,
                  -79, -79, -28, -28, -28, -81, -81, -81, -91, -91, -91, -82,
                  -82, -82, -5, -5, -5, -55, -55, -55, -11, -11, -11, -12, -12,
                  -12, -10, -10, -10, -9, -9, -9, -7, -7, -7, -17, -17, -17, -6,
                  -6, -6, -8, -8, -8, -13, -13, -13, -25, -25, -25, -27, -27,
                  -27, -92, -92, -92, -14, -14, -14, -26, -26, -26, -56, -56,
                  -56, 41, 93, 47, 68, 101, 99, 111, 100, 101, 80, 97, 114, 109,
                  115, 60, 60, 47, 66, 105, 116, 115, 80, 101, 114, 67, 111,
                  109, 112, 111, 110, 101, 110, 116, 32, 56, 47, 80, 114, 101,
                  100, 105, 99, 116, 111, 114, 32, 49, 53, 47, 67, 111, 108,
                  117, 109, 110, 115, 32, 50, 48, 48, 47, 67, 111, 108, 111,
                  114, 115, 32, 49, 62, 62, 47, 66, 105, 116, 115, 80, 101, 114,
                  67, 111, 109, 112, 111, 110, 101, 110, 116, 32, 56, 47, 70,
                  105, 108, 116, 101, 114, 47, 70, 108, 97, 116, 101, 68, 101,
                  99, 111, 100, 101, 62, 62, 115, 116, 114, 101, 97, 109, 10,
                  120, -38, -36, 93, 9, 119, -94, -56, 22, 102, -111, 69, 65,
                  52, 10, -63, -123, 80, 27, -94, 16, 112, 95, -93, -47, -1, -1,
                  -81, 94, 21, -117, -128, 73, 79, 79, 79, 39, -35, -6, 56, 115,
                  -50, -76, -119, -127, -6, -22, 110, -33, -67, 117, -85, -32,
                  -100, -17, -67, 120, 78, 108, -38, 106, -69, -74, -5, -26,
                  -25, 56, -36, -73, -34, 125, -87, -62, 19, 118, 35, 97, -118,
                  -102, -57, -47, -29, 2, 25, 25, -95, 15, -25, -35, -27, 122,
                  -68, -86, -75, 36, 107, -4, -80, 64, -34, -128, -89, -15, -7,
                  -121, -99, -91, 108, 30, 20, -56, 65, -13, -60, 117, -15, 113,
                  -46, 42, 127, 122, 36, 32, -99, 88, 104, 84, 126, 32, 114,
                  119, 15, 100, -76, 88, 46, 87, -73, -2, -118, -72, -14, -115,
                  -120, 36, -7, -98, -127, -116, -34, 13, 75, -119, -90, 110,
                  -88, -12, -71, -73, -110, 25, -88, 113, -3, -10, -85, -13,
                  105, -83, -14, 121, 93, 59, -66, -67, -67, 117, -33, -57, 127,
                  31, -56, -90, -90, -37, 4, 69, 26, -67, -22, -86, -86, 68, 26,
                  -9, -98, -1, -54, -118, 63, -36, -5, 24, -101, -41, 49, 79,
                  22, -49, -105, 16, 64, -49, -9, 125, 36, 114, -37, -47, -33,
                  4, -78, 122, -75, 66, -12, 18, 112, -115, -11, -104, 94, 19,
                  -90, 97, -42, -53, -76, -97, 58, -86, 69, -120, 63, 40, -46,
                  33, -16, -78, -25, -19, -37, 10, 4, -54, -45, -79, -15, 42,
                  31, 123, -106, 2, 113, -67, 93, -5, 75, 64, 102, -57, -117,
                  116, 58, -71, -74, -79, -88, -24, -103, 28, 121, -112, 99, 97,
                  124, 37, -32, -73, -37, -65, 89, 4, 4, 25, -20, 31, 114, 19,
                  -5, 98, -23, -41, 13, 78, 120, 33, -94, -50, -17, -2, 56,
                  -112, -123, -34, -60, 39, -46, 55, -74, 31, 126, 35, 35, -120,
                  21, 62, 81, -83, 15, 18, 89, 6, -112, 68, 53, 103, -95, 34,
                  -124, -26, -77, -86, -114, -10, 20, 28, 3, 77, 109, -4, 81,
                  32, 7, 53, -16, 61, -115, -85, 125, -86, -40, 115, -20, 34,
                  -46, -90, -58, 126, 106, 59, 31, 29, -103, 11, -60, 55, 9,
                  -69, 88, -100, 124, 16, 49, -49, 73, -66, 63, 85, 15, 127, 12,
                  -56, -69, 30, -6, 68, 49, 126, -92, 6, 123, 5, -71, 16, -11,
                  -100, -34, -55, -70, -3, 85, 15, -72, -82, 11, 93, -30, 34,
                  101, -7, -39, -97, -82, 57, -119, -60, -111, 90, -5, 35, 64,
                  -34, -71, -24, 20, 23, -52, -29, 51, -62, 11, -95, 11, 65,
                  123, -31, 106, -73, 110, -43, 100, 64, -24, 69, -92, -59,
                  -113, 44, -113, 23, -35, 19, 124, 58, 124, 59, -112, -102,
                  -27, -98, -48, 69, 23, -33, -1, -31, 59, 59, -115, 106, 16,
                  68, -78, -18, -33, -24, -106, 76, -91, -111, 92, 64, -4, -121,
                  -80, -44, 80, 65, -20, -86, -53, 111, 5, -62, -9, -31, -117,
                  -64, -67, -113, -50, 66, 56, -84, -56, -65, 81, 49, 122, -117,
                  77, 60, 17, 26, 22, -88, -104, -5, -69, 64, 82, 28, 46, -4,
                  -57, 8, -33, -74, 91, -54, 41, 50, 95, 71, -33, 4, 100, 84,
                  -21, -96, 88, -46, 23, 78, 87, -12, -6, -106, -21, 93, -114,
                  44, 91, 90, 111, -69, -100, 40, 10, -45, 115, -23, -101, 58,
                  102, -93, -59, -22, 90, -16, 94, 75, -114, 78, 4, 57, -114,
                  105, -39, 55, 53, -28, -118, -41, -83, 89, 90, -41, -103, 13,
                  -123, -109, 103, -14, -33, 1, 100, -4, 108, -30, -109, -46,
                  30, 59, -68, -24, -117, 116, 120, -53, -74, -126, -119, 38,
                  -118, 18, 68, 126, -20, 67, -44, -100, -35, 2, 33, -31, -5,
                  66, 68, 122, -58, 120, 39, -49, 90, -114, -61, -123, 97, -119,
                  6, 111, 35, 122, 31, -85, 45, 31, -106, -53, 69, -61, 24, -52,
                  -95, 100, -71, 54, -17, -84, -122, -38, 9, 89, -37, -81, 6,
                  50, 57, 43, 49, 54, -27, -103, -45, 16, 125, 65, 78, 60, 103,
                  -61, 6, 104, -22, 6, 1, -126, -30, -45, -36, -123, -80, 118,
                  11, -124, -118, -60, 25, -21, -127, -48, 122, 91, 53, 100, 93,
                  65, -56, 45, -128, -108, 8, -90, -123, 93, -120, 125, 15, 5,
                  83, -41, -115, 0, -76, -70, 27, 103, 43, -94, -2, -63, -39,
                  -11, -124, 19, -28, -34, -65, 16, -56, -2, -84, 75, -34, -44,
                  -22, -46, -63, 95, -112, -42, -38, 51, 96, 76, -51, 52, 99,
                  -65, -110, -91, -112, 90, -12, 70, 34, -32, 82, -4, -127,
                  -111, -50, 61, -94, -92, 113, 44, 98, 63, 118, -119, -25, 99,
                  -73, -72, -120, -74, 41, 123, 6, 100, 30, -19, 0, -69, -118,
                  88, 119, -127, 36, 51, -55, -114, -70, 10, -28, 14, -50, 94,
                  -105, 78, 80, -3, -105, 52, -20, -89, 64, 38, -122, -28, -57,
                  2, 71, -67, 8, 111, 122, -62, 115, 34, -115, 55, 17, -99, -62,
                  -34, -58, -39, 116, -56, -100, 57, -46, -111, 5, 32, 44, 52,
                  -6, 53, 5, 66, -102, 99, 103, 25, 17, 75, -25, 44, -83, -39,
                  -116, 10, 32, 96, 94, 1, -115, -88, -23, 47, -98, -90, -26,
                  -127, -118, -62, -13, -92, 36, -71, -97, 60, 75, -98, -75,
                  116, 102, 109, -19, 68, 46, -25, -55, -17, 3, 89, 13, -22, 30,
                  -42, -38, 84, 10, -17, 23, 4, -11, 68, 37, 120, 11, -6, 68,
                  125, 119, 70, -125, -88, 121, 76, -20, -89, 67, 35, 7, 82,
                  -82, 86, 34, 23, 64, 22, 1, -90, 95, 25, -115, 39, -101, 38,
                  -7, 12, -56, 66, 34, -39, 20, 28, -93, -87, -111, -52, 26, 17,
                  19, -57, -79, 105, -71, -47, 112, -26, 108, 6, 2, 85, 106,
                  126, -4, 123, 64, 26, 86, -24, -57, -54, -111, 41, -62, 54,
                  -60, 92, 98, -94, 43, -43, -11, -68, 62, 101, 39, 124, -109,
                  12, 18, 119, -13, 42, 33, 68, -111, 16, 37, -9, 69, -61, 84,
                  -113, 16, -115, 22, -115, 8, -89, -114, 107, 92, 2, 66, -76,
                  -36, 77, -83, 76, 106, 57, 36, 72, -120, -28, 90, 71, -54,
                  -42, 89, 61, 33, -33, 77, -115, 124, 57, 71, 97, 111, -20,
                  -84, 123, 20, -100, -58, -83, -2, 59, -112, -102, 26, 122,
                  -40, 58, -17, 50, 39, -103, 12, -13, 93, 21, -80, 23, 26, 99,
                  103, -49, 97, 51, -7, -55, -84, 53, -11, 73, -37, 0, -56, 5,
                  -118, -68, 77, 30, -41, -49, 108, -60, 100, -62, 1, 31, -127,
                  -64, 105, 22, -71, -113, 18, -96, -111, 51, -60, -128, 75,
                  -92, -7, 38, -96, -42, -124, -50, -117, -25, 77, -11, 125,
                  -30, -47, -52, -109, 68, -59, 53, 27, 70, -79, 47, -76, 54,
                  -1, 9, -56, 110, 96, -70, 0, 73, -43, -88, -44, 80, 3, -20,
                  69, -6, -69, 51, -23, 9, 90, -22, -68, -74, -90, -25, -119,
                  -12, 97, 93, 26, 37, 8, 112, 5, -13, -23, -35, -31, -16, -49,
                  -127, -20, -27, -63, -109, 25, 33, 23, -71, -19, -11, -112,
                  -8, 98, -94, 94, 27, 42, -108, -77, -77, 27, 6, 30, -106, 122,
                  -77, -60, 84, -20, 68, 90, -53, -127, -30, -5, 82, 103, -5,
                  -53, 64, 118, -49, -12, 15, 1, 65, 21, 42, -47, 120, -94, 15,
                  -128, 22, -11, -77, 93, 5, 112, -23, -4, 60, 83, -2, -88, 38,
                  -77, -73, 55, 9, 101, -125, 16, -8, -30, 104, 45, -111, 28,
                  -56, -21, 103, 64, 64, -53, 49, 36, 26, 126, 0, 116, -127, 32,
                  39, -110, 57, 5, 105, -80, -81, 53, 125, 117, -25, 108, 109,
                  -126, -127, 102, 84, 105, -66, 4, -64, 84, 93, -1, 18, -112,
                  -102, 42, -8, 126, 36, 14, 44, 66, 90, -123, 89, -86, 84, 66,
                  -128, 101, 67, -53, 57, 48, -45, -71, 89, 93, -128, 39, 24,
                  -41, -22, 15, 118, -27, 30, 38, 96, -24, -76, -63, 7, 32, 124,
                  -50, -77, 40, 14, 101, -76, 117, 17, 82, 108, -22, -22, -84,
                  116, 100, 75, -47, 3, 106, 50, 53, 59, 14, 9, -58, -120, 2, 5,
                  0, -103, -35, -78, 62, -20, -26, 52, -45, 9, -11, -38, -8, 95,
                  2, 25, -55, 22, 121, 65, 98, -17, -64, 50, 83, 66, -20, 39,
                  -93, -47, -32, 117, 110, 46, 1, 72, 36, 106, 28, -108, -36,
                  10, 25, 85, 58, 75, -40, -69, -46, -57, -125, -115, -101, 111,
                  -50, 100, 64, -1, -122, 119, 108, -100, 25, -5, 21, -56, -7,
                  26, -41, -111, -48, 24, -119, -128, -124, -68, -93, 2, -92,
                  -114, -14, -94, 23, -12, -107, -12, 86, -44, 7, -45, 108, 121,
                  -93, 79, 1, 34, -107, 60, 75, 69, 100, -22, 121, 68, -108, 71,
                  63, 7, 50, 89, 25, -74, 31, 75, -22, 27, -45, -1, -122, 78,
                  80, 52, -123, 83, 66, 103, 2, 3, -106, 19, 13, -46, -78, 116,
                  -22, 64, 38, 109, -120, 73, 103, -97, -29, 80, 98, 97, -101,
                  102, -120, 88, 28, -17, -21, -52, 27, 105, -77, -62, 70, -34,
                  -14, -64, 14, 105, -46, 53, -64, -96, -50, -20, 93, -59, -64,
                  -54, -107, -59, -104, -6, -31, 49, -5, 39, -62, 84, -52, 103,
                  -123, -72, -64, 29, 46, -42, -55, -72, 71, -109, 22, -128, 42,
                  -81, 74, -64, -57, -42, 103, 49, -78, 4, 100, -51, -85, 90,
                  20, 71, 28, -49, -18, -67, 24, 42, -60, -85, 63, 47, -10, -21,
                  21, -81, 66, 72, 9, 6, 77, -121, -114, -27, 44, 81, 4, 88,
                  -72, -78, 88, -102, -86, 103, 19, 74, -51, -58, -77, -100, 67,
                  72, 37, 64, 6, 116, -46, 111, -128, -80, -92, -67, 27, 120,
                  74, -110, -112, -116, 84, -116, -107, 60, 53, -95, -20, 7, 13,
                  82, -67, 121, 111, -75, 19, 41, -47, 12, -115, 68, -126, 104,
                  -102, -94, -40, -108, 16, 116, -87, 124, -10, -78, 25, -58,
                  -92, 46, -49, 126, 0, 100, -68, 109, 91, 18, 62, 1, -13, -103,
                  77, -9, -122, -65, 68, 49, -20, -16, 25, -16, -115, -119, -21,
                  -58, 86, 69, -72, 87, -118, -56, 33, -10, -20, -85, 111, -105,
                  -89, -66, 116, -43, 2, 126, -118, 57, 58, 44, 12, 73, 48, -80,
                  81, 5, 8, -60, -46, -39, -31, 5, -96, 102, -127, 100, -44,
                  -63, -32, -118, 100, 55, -9, -79, 89, -26, 86, 53, -106, -96,
                  33, 72, -128, 15, 53, -91, -82, 33, 108, 26, 76, 1, 22, 3,
                  -51, -117, -75, -42, 97, 116, 11, 100, 82, 107, -85, -118,
                  -21, -59, 72, -45, -109, 44, -68, -90, 107, -98, -33, 28, 46,
                  -82, 41, 97, -35, 102, 106, 121, 36, 64, -53, -44, 115, 36,
                  -37, 16, 65, -18, 106, 118, 58, -15, -52, 43, -114, -75, 5, 8,
                  86, 39, 19, 46, 34, -66, 55, 117, 11, 32, 8, 97, 119, -66,
                  114, -38, 17, 32, -41, 25, -103, 116, -128, -89, -28, 124,
                  115, 50, -120, 98, -23, 88, 6, 2, 3, 83, -93, -26, -60, 45,
                  -88, -86, -113, -113, 22, 124, -111, 116, -10, -100, -79, 108,
                  77, 99, 98, 25, 101, 31, -58, -43, -84, 38, -60, -108, -44,
                  73, 92, -78, 24, -77, -46, 69, 114, 2, 125, 57, 31, 36, 111,
                  55, -109, 28, -70, 97, -61, 122, -24, 33, 69, 100, 87, 19, 81,
                  -121, 115, -11, -114, -101, 39, -32, -39, 87, 81, -65, 107,
                  113, -109, 114, 72, -27, -24, 108, -28, 39, 17, 22, 64, -96,
                  34, 82, 46, -69, -66, 80, 107, 11, 81, -69, 88, 122, 112, -15,
                  -12, 74, -45, 120, -102, 27, 92, -25, 103, -36, 65, -64, 112,
                  -10, -125, 48, 28, -52, -14, 106, -127, -16, 66, -84, -60,
                  -105, 45, 41, 119, -118, 3, -37, -72, -50, 31, -57, -99, -88,
                  -1, 15, -83, -41, 68, -91, -114, -106, 16, -57, -126, -102,
                  -105, 71, 14, -122, 41, 14, -106, 44, -89, -102, -45, 72, 53,
                  58, -24, 116, 86, 17, 77, 68, -107, -44, 37, -27, -118, -25,
                  97, -5, -102, 26, 109, 21, 95, 56, 80, -31, 33, -92, -78, 59,
                  -38, 87, 27, -15, -22, 116, -128, -101, -74, 68, -59, -91,
                  -41, -90, -96, 16, 39, -11, 25, -62, -75, -60, -75, 17, 1,
                  106, 62, 25, -20, -22, 41, 30, 37, -58, 20, -29, -46, 80, 4,
                  125, -103, 14, 105, 53, 84, 124, -84, -76, -104, -75, -113,
                  120, 85, 56, -59, -127, -88, -97, 15, -52, 53, 113, -116, 126,
                  -38, -103, -116, -26, 62, -75, -93, 94, -10, 97, -76, -27, 20,
                  -101, -7, 91, -89, 102, 123, 90, -14, 15, 71, -89, 10, 2, -43,
                  6, -27, -34, -64, -52, 71, 94, -57, -40, -70, -54, -125, -50,
                  47, 43, 93, 119, 77, 64, -128, 112, 105, -105, -68, 86, -36,
                  118, -106, 106, -124, 8, 18, -38, 52, 76, 16, 95, -67, 82,
                  -38, 103, 23, 68, 87, -123, 26, 96, -105, 78, -107, 7, -24,
                  69, 20, -125, 18, -18, 57, -99, -13, 113, 91, -103, 90, -39,
                  -36, 79, -114, 52, 60, -64, -53, -37, 56, -87, 87, -118, 36,
                  -10, 80, 100, -75, 106, 59, -114, -26, 18, 88, -49, -18, -46,
                  39, 125, 62, -69, -1, -120, -17, -69, 86, 70, -81, 0, 124,
                  -38, -28, -123, 41, -84, -80, -127, -51, 65, 78, 118, -33, 4,
                  -54, -108, -82, 99, 58, 83, -45, 49, 82, 117, 23, 32, -114,
                  -61, -39, -7, 10, -60, 63, -49, -126, 19, 117, 67, 98, 82, 86,
                  -96, -18, -22, 105, 84, 80, 121, -124, -14, -56, -37, 102, 74,
                  59, 8, 48, -43, 73, -106, -31, 76, -122, 0, 13, 88, 49, -10,
                  92, 103, 25, 74, 102, 59, 115, 120, -62, 98, -102, -71, -68,
                  81, -14, 7, 16, 6, 29, -50, 121, 70, -64, -50, -18, -71, 63,
                  100, 83, -69, -18, 41, 84, 126, -119, 44, 57, 2, 58, -39, 29,
                  26, 23, 74, -79, 19, 72, 50, 77, -21, -108, -50, 124, 62, 23,
                  -87, 63, 29, 94, 71, -92, 79, -81, -109, -78, -96, -7, 68,
                  109, 81, 4, -60, 55, -1, -43, -23, -74, 5, 79, 75, 125, -56,
                  -40, -92, 72, -118, 114, -125, 75, 99, 95, -6, 16, 106, 66,
                  116, -118, -74, 42, 1, -80, -101, 62, 84, 71, 18, -107, -95,
                  51, 62, -101, -110, -51, -25, -54, 50, -108, 98, 95, 83, -109,
                  -47, 46, -115, 58, 116, -79, -55, 57, 19, -86, -106, -43, -70,
                  77, -29, 73, 82, -116, 73, -86, -110, 97, 92, -49, -100, -54,
                  94, 39, 87, -85, -37, 75, 30, -90, 100, 12, 48, -25, -88, -20,
                  -118, 20, -105, -96, 76, 99, 38, 118, 108, 77, -100, 82, 100,
                  55, -110, 2, -22, -69, 24, -25, 64, 5, -112, -111, -110, -28,
                  -73, 4, -126, -88, -61, 113, 92, -97, -114, 41, -7, -58, -85,
                  -120, -59, 108, -40, -68, -24, -43, 19, -43, 107, -52, -89,
                  98, -18, -123, 54, 109, -123, -44, -77, -47, 60, 3, 23, -73,
                  57, -26, 80, -120, 59, 44, -4, -9, -71, 47, -12, -45, -55, 88,
                  -21, -45, 23, 37, 37, -71, -50, 120, 16, 77, -71, -94, -38,
                  81, -109, 117, 74, 94, -103, 77, -125, -68, -98, -72, 83, 9,
                  68, -7, 7, 61, 22, -45, 92, 37, 7, -46, -114, -109, -1, 111,
                  -91, -20, -77, -45, 13, 17, -72, -42, 27, 103, 77, -58, 55,
                  -79, 23, -5, -40, 35, -37, -116, 56, 104, 32, 47, 62, 60, 75,
                  -79, -59, 103, 80, -108, 118, 54, -4, -15, 106, 118, -99, 64,
                  -92, 108, 88, 64, -28, 48, -99, -113, -70, -56, -23, -70, -82,
                  42, -51, 124, -119, 99, -63, 5, 39, 45, 47, -116, -74, -123,
                  107, 61, -28, 42, 55, 27, -123, 70, -115, -61, -47, 50, -97,
                  55, 42, -99, 77, 78, 50, -126, -44, 54, 7, -24, 42, -111, 65,
                  22, 27, -124, -27, -75, 92, 7, -102, -39, -65, 39, 10, -99,
                  17, 4, 37, -111, 74, 101, -112, 91, -36, -116, 58, -55, 108,
                  -18, 54, -100, -121, 47, 73, -8, 93, 15, -125, -16, -87, 90,
                  -89, -28, 5, 66, -70, 73, 100, 31, -51, 89, 126, -125, 48,
                  -10, 78, -98, -42, 78, -57, 50, -42, -35, -105, 32, -69, -51,
                  -92, 102, -110, 126, -19, 54, -107, -97, -98, -60, 6, 83, 17,
                  108, -67, -54, -25, -95, 56, -91, 60, 49, -81, 64, 80, -113,
                  -102, -124, -68, 9, 7, 97, 14, 4, 103, 11, 113, 106, -100,
                  -81, -119, -46, 68, 31, 43, -35, -43, 122, -58, 106, 66, -24,
                  -87, 107, -29, -48, -88, 70, -21, -91, -27, 105, -35, 89, 90,
                  84, -21, -5, -111, -66, 75, -11, 36, 20, 6, -85, -30, -117,
                  53, 1, 1, 115, -108, 82, -108, 125, 51, 101, 66, -48, -22, 22,
                  -45, -95, -22, 25, -16, 119, -45, 19, 111, -117, -79, 11, -45,
                  67, -83, -28, 17, 61, 55, -94, -76, -110, 58, 14, -115, 70,
                  -77, 102, -17, -80, 92, -55, 38, -126, -128, -7, -82, 85, 31,
                  95, 3, -94, 1, 32, 72, -98, -59, 97, -44, 52, -40, -70, -48,
                  -50, 4, -127, 75, -61, 118, -92, -52, 45, -31, 36, -114, -100,
                  -47, -128, -110, -112, -101, -36, -87, 102, -57, 74, -6, -93,
                  -47, 89, -14, -123, 84, 90, -109, 87, 5, -102, 79, -6, 121,
                  -75, -20, -23, -6, 83, 68, -120, -76, -52, -71, -42, 54, 96,
                  72, -56, -13, 103, 57, -106, -118, -102, 111, 55, 57, -64,
                  -40, -112, 78, 97, 70, 24, 39, -21, -11, 126, 69, 121, 24, 21,
                  79, 27, 16, -54, 73, 92, 76, -7, 34, -91, -6, -5, -82, -62,
                  -56, -4, 21, -120, 11, -31, 112, 76, -115, -124, -110, 79, 32,
                  105, -51, -90, -28, 122, -67, -41, 16, -64, 40, 8, 45, 43, 53,
                  -127, 87, -31, 69, 59, 126, 40, -30, 32, 61, 85, -110, 93,
                  -49, 61, -91, 86, 79, 57, -118, -23, -67, -64, 48, -96, 90,
                  68, -35, 53, 43, -61, -28, -92, -111, -102, 30, -115, -42,
                  -22, -57, 5, 29, 46, -112, 62, 44, 32, -48, -12, -42, -73, 74,
                  -103, -62, 104, 16, -126, -60, 21, 90, -66, -90, -120, -70,
                  33, 18, 0, 48, 10, -35, 68, -52, 5, 16, -86, -66, 77, 81, -64,
                  -44, -75, 104, 74, -24, -5, 84, -21, 39, 14, -81, -127, -32,
                  105, 95, 80, -22, 57, 6, -13, -3, 77, 33, 71, 39, 66, 59, -99,
                  -55, 70, 123, 112, -66, 22, 112, 85, -120, -45, 92, 45, 117,
                  115, 57, -115, 127, -101, -46, 41, 115, 59, 85, 75, -40, 25,
                  -47, 116, -8, 97, 29, -92, 71, -103, -15, -80, -92, -52, -101,
                  39, -33, 75, -29, -39, -42, -40, -116, 88, 76, 11, -38, 61,
                  81, -56, 50, -87, 18, 16, 42, 115, -97, 40, -94, -26, -43, 23,
                  107, 121, -96, -102, -52, 86, 86, 34, -51, -107, 75, -100,
                  124, 64, 98, -27, -74, -26, -69, -75, 125, -27, -109, 58, 112,
                  -83, -109, 100, -49, -40, 30, 87, -14, -111, -93, 70, 1, -30,
                  -87, -91, -22, -70, 113, 124, 101, -41, 81, 86, 62, 41, -17,
                  31, 40, 95, 21, -53, -14, -33, -9, 79, 97, 57, -67, 30, -8,
                  26, -45, -22, -122, 66, 62, 2, -95, 25, -1, -40, 89, 88, -79,
                  88, -52, -6, -34, 2, -34, -91, 52, 89, 103, 37, -122, -83,
                  -37, 108, 67, 22, -15, -57, -107, -84, -111, -54, 68, -114,
                  -83, -35, 77, 98, 117, -24, 83, 93, -128, 84, 41, 48, -56, 46,
                  95, -7, -72, 30, 99, 8, 62, -79, -54, 66, -30, 37, 95, 43, 45,
                  107, -114, -12, -109, -12, -98, -101, 55, -92, -78, -49, -106,
                  22, 18, 32, 48, 74, 126, 53, -30, 98, -91, 84, -90, -30, 40,
                  -109, 47, -51, -41, -2, -126, -3, -6, -19, 82, -30, -92, 39,
                  -111, 97, -75, -32, -72, 126, -62, 44, -63, -55, 121, 94, 57,
                  -43, -27, 21, 64, 74, 37, 90, 56, -3, 32, -49, 37, -99, -66,
                  -80, -78, -72, -15, 28, -7, 98, 105, 80, 51, 53, -9, 50, 52,
                  57, 12, -126, -128, -26, 35, 106, -74, -22, -58, -26, -120,
                  100, -112, -97, 78, 37, -103, 56, 6, -84, -70, -59, -98, -21,
                  7, 31, -4, -50, 76, 37, -30, -37, -106, 94, 93, -103, 106,
                  -117, 108, 41, 2, -77, 106, 112, -27, -98, -107, -100, 125,
                  102, 8, 37, 36, 68, -70, 45, -119, -47, -76, 16, -104, -27,
                  71, -114, 105, 74, 53, 47, -71, -76, -115, -8, -110, 119, 51,
                  13, 79, -61, -3, 114, 81, 71, 89, 108, -31, 124, -115, 82,
                  115, 41, 95, 3, -27, 78, 101, 105, -53, 83, 28, -107, -89,
                  103, 91, -9, -111, -11, -95, -14, 115, 80, -68, 100, 88, -119,
                  -74, 32, -60, -46, 71, -23, -7, 71, 85, -108, 30, 40, 85, -1,
                  -93, -86, 83, 95, -87, 4, -125, 86, 69, -66, 106, -116, 7, 37,
                  -77, 31, -51, 95, -14, 104, -57, 67, 105, -97, 68, -20, -84,
                  -48, -53, -59, 44, -127, 25, -60, -83, -30, -101, 37, -103,
                  -44, 66, 63, -22, -106, 31, -43, -57, -98, -8, 65, 31, -38,
                  24, 38, -38, -102, -105, -107, 72, -55, -33, 125, 40, 7, 81,
                  -90, 113, -123, 2, -84, 114, -63, -75, 45, 96, 44, 85, -68,
                  -4, 66, -12, 42, 19, -71, -77, 79, -71, -7, -84, -76, 100, 1,
                  113, 29, -62, 10, -112, 81, -33, 123, -50, 115, -36, 23, -77,
                  52, 5, -115, -66, -17, -22, 101, 81, 15, -90, 30, 81, 111,
                  -62, -105, 12, -54, -118, -113, -98, 42, -59, -108, 15, 117,
                  45, -102, -60, -48, 32, -112, 41, 87, -40, 121, 61, 44, 119,
                  73, -49, 9, -115, 121, -72, 42, -18, -102, -106, 84, 102,
                  -117, -65, -76, 95, -14, -116, 119, 98, -5, 98, -110, -110,
                  -71, 85, 32, -50, 17, 100, 36, -116, -6, -100, 88, 45, 73,
                  119, 102, -5, 64, 31, 87, -18, -18, 97, -79, 26, 13, 58, 37,
                  32, -91, -68, -1, -121, -107, -58, -79, -15, 84, -121, -87,
                  -118, -47, -1, 5, -111, -40, -103, 119, 40, -87, -125, -62,
                  96, 114, -29, -65, -60, -78, 115, 94, 91, -66, -98, 103, 101,
                  28, 32, 124, -26, -85, 114, 32, -66, -108, -52, 66, -25, 36,
                  -114, 115, 36, 47, 106, 105, 74, 103, -44, 121, -39, 101, -93,
                  92, 119, -112, 23, -74, -81, 14, 114, 124, -80, -82, -10, 11,
                  1, 49, -49, -1, -86, -10, 59, -90, 105, 46, 73, 93, 24, 101,
                  0, 44, -19, -92, 62, -84, 58, 61, 67, 47, -26, -54, -64, 26,
                  -110, -41, 43, 116, 32, -53, -81, -84, 2, 8, 78, -120, -124,
                  -45, 8, -4, -100, 63, 80, 47, 92, -95, 18, 109, 24, -37, -107,
                  -24, 107, -48, 121, 20, -44, -18, -37, -37, -101, 97, 112, 82,
                  -124, -14, 10, 31, 22, -84, -73, -47, -65, 94, 86, 24, 119,
                  91, -118, 91, -42, -55, -96, 28, 84, 102, 28, 14, -12, 10, 14,
                  13, 11, -14, -7, 85, -106, 101, -22, -100, -126, 56, 74, 20,
                  -88, 54, -123, 5, 16, 96, 103, -55, 3, -108, -9, -117, -43,
                  106, -75, -34, -20, 45, -97, 43, 15, 72, 14, 61, -91, 18, 64,
                  -50, 18, 33, -120, 93, 108, 42, 97, -118, 2, 68, 26, -73, -4,
                  -43, -123, 30, -43, 43, 1, 113, 75, 62, 108, 89, 7, 88, -81,
                  -84, -95, 75, 116, -66, -128, 31, -109, 105, 104, 91, 22, 119,
                  105, -15, 45, -18, 73, 85, -112, 91, 0, -127, -111, -54, -87,
                  -12, -65, 41, 9, 53, 41, 12, 3, -41, 13, 5, -73, -108, -17,
                  50, 7, -37, -12, -101, 21, 79, -87, -29, -54, 92, 2, -32, 42,
                  122, 99, -4, -21, 43, 86, 123, -77, 116, 35, -92, -18, -78,
                  -14, -36, -2, -103, 14, -69, 2, -28, -96, 0, 23, -95, 64, 124,
                  -38, -18, -9, -71, 74, 111, 13, 75, -93, 4, -15, 10, -60, 37,
                  -79, -85, 88, 70, 109, -69, 61, -84, -106, -37, -122, -84, 90,
                  18, 35, -105, 79, -109, 74, 107, 17, -86, -8, 65, -75, -20,
                  -89, 72, 104, 15, 27, -77, -1, -74, -122, 56, -77, 112, -31,
                  -73, -95, 80, 55, -25, -13, 14, -117, -87, -84, -94, -35, -71,
                  106, -107, 110, -121, -124, -32, -70, -68, -68, 85, -36, -39,
                  -71, 9, 10, -43, -46, -116, 27, -58, -77, -87, -55, 106, 116,
                  42, -13, -63, 55, 86, 98, -26, -82, -47, -127, 15, 97, 73, 30,
                  -16, -8, 27, -117, -95, 99, -50, -59, 8, 94, 93, 55, 74, -126,
                  106, -6, 25, -86, -53, -3, 122, -39, -88, -51, -89, 24, 16,
                  32, -75, 43, 18, 127, 86, -46, -56, -9, -34, -12, 82, 32, 29,
                  47, 33, -69, 78, -125, -81, -94, 89, 114, -82, 107, 14, -9,
                  -91, -123, 109, 26, -81, -97, 56, -114, 111, -16, -100, 94,
                  71, 37, 121, 84, 117, -7, -41, -105, -89, -87, -1, -126, -116,
                  17, 32, -24, -34, 92, 40, 72, 52, -99, 113, 5, 100, -35, -84,
                  85, 118, 59, 122, -86, 4, -105, 56, 1, -78, 14, -92, 100, -80,
                  27, 75, -71, 125, -30, -62, -14, -23, -48, -97, -113, -116,
                  110, 107, 36, 29, 51, 102, 42, -115, 113, 105, -75, 14, 71,
                  -19, -33, 110, 24, -104, -44, -38, 118, 93, 20, 67, 116, -117,
                  4, -62, -116, 50, -128, 31, 78, -42, 49, 76, 37, -78, -114,
                  -78, -98, -89, -47, -24, -29, -38, -122, -18, -95, -116, 111,
                  -61, -14, -67, -81, -1, 34, 8, 79, -71, -97, -75, -42, -3, -5,
                  -90, -102, -125, -118, -35, -49, 47, -84, -2, -96, 13, -25,
                  93, -89, 20, 47, 5, 18, -110, 31, 119, 4, -115, 6, 83, -14,
                  -7, -99, 1, -10, 96, 32, 53, -83, -25, -97, -9, -94, -3, 66,
                  -101, -45, -69, 6, 62, 127, -102, -99, -101, -57, -82, -120,
                  103, -77, 5, 63, -80, 92, -112, -57, -111, -75, -128, -124,
                  127, -80, 85, 25, -62, -49, -18, 12, 85, -99, -109, 87, -5,
                  127, -45, -8, -16, 75, -3, 90, -17, -118, -9, -47, 82, 104,
                  -128, -31, -81, 62, 78, -29, -12, -31, -85, -95, -21, -70,
                  -87, 4, 46, 78, 52, 37, -105, 8, 36, 80, -20, -43, -10, -29,
                  -44, -127, 55, 94, -37, 122, -65, 68, 10, -11, -49, -92, -3,
                  73, -29, -29, 23, 53, -98, -19, 123, 74, 4, 110, -75, -96, 48,
                  -112, -117, 71, -119, 37, 102, 57, 38, 70, 4, 86, -6, 53, 40,
                  16, -22, 18, -80, 27, 54, -39, -6, 74, 93, -104, -46, 111,
                  -47, 20, 119, 82, -84, 114, -35, -50, 16, 36, -98, -16, 43,
                  13, 91, -65, -40, 10, 56, 89, -75, 89, -11, -101, 20, -86, 80,
                  68, -4, -61, -12, 51, -3, 40, -128, -92, -61, 75, 40, 71, -10,
                  -25, 94, -31, 36, 108, 80, -115, -31, 40, -110, -12, 95, 106,
                  7, -4, -11, 46, -45, 67, -53, 22, 21, 72, -77, 76, -60, -30,
                  98, -119, -125, -55, -56, -3, 41, -112, -22, 69, -126, 109,
                  -111, -47, 93, 37, 65, 16, 8, 76, 99, -7, -117, -69, 77, -2,
                  91, 3, -13, 110, -69, 61, -97, 57, -118, 7, -112, -94, 26,
                  -81, -126, 95, 5, -30, 122, 92, -91, 53, -118, 121, 96, -73,
                  -87, -88, -25, -9, 95, 31, -46, 111, 53, -7, 79, 120, 93, 42,
                  -58, 82, -72, 103, -124, 19, 2, 0, 75, -58, 46, -64, 74, -16,
                  -55, 62, 33, 49, -113, 42, 60, 13, 23, -118, 97, -76, -27,
                  -38, -8, -65, -11, -5, -1, -18, -74, 11, -39, -69, -74, -61,
                  -43, 114, -105, 6, -19, -127, 58, -17, -104, 81, 16, 80, -1,
                  -101, 2, 97, -51, -28, -119, 117, -112, -128, 93, -126, -112,
                  55, 60, -27, -114, 107, 75, 17, 10, -117, -33, 24, -56, 111,
                  3, -63, -45, -85, 30, 112, 36, 37, 21, 48, 89, -115, -104, 29,
                  -106, -117, 26, 111, -91, 20, 101, -21, 34, -99, -89, 25, -46,
                  27, -65, -92, -41, -98, 23, -55, -115, 68, 40, 16, 23, -76,
                  -1, 34, 16, 30, 22, -51, -67, -93, -102, 42, 64, -58, 49, 33,
                  22, -72, 70, 58, 68, -11, -108, 1, 41, 111, -62, 120, 87, 50,
                  -65, 80, 16, 65, -102, -35, -69, -104, -5, -117, 64, -58, 77,
                  -49, 46, 51, -13, 51, 87, -113, 88, 40, -15, -89, -106, -15,
                  78, 121, -94, -104, 73, 4, 10, -17, 5, -34, 102, -26, 22, 80,
                  -47, 0, 124, 100, -27, -74, -6, -20, -17, 1, -95, 89, -92, 80,
                  37, 66, -29, 70, 75, -67, -120, -118, -21, -7, 36, -44, -115,
                  38, 54, 25, -19, -35, -78, 6, -57, -44, 63, 24, 23, -104, 42,
                  32, 42, 87, -27, 116, 70, -32, -93, -43, 95, 4, -14, 30, 120,
                  -30, 39, 19, 57, 105, -16, 45, 37, 60, -99, 0, 68, -126, -40,
                  -37, -14, 80, -110, -113, -14, -15, -71, -81, 64, 15, -109,
                  36, -81, 17, -60, -94, 109, 33, -39, 24, -32, 2, -21, 47, -86,
                  -106, -29, 12, 1, -80, 126, -96, 18, -53, 87, -67, -82, 69,
                  36, -10, -119, 52, 101, 9, 55, -120, 99, -102, -43, 7, -126,
                  98, 27, -14, 91, 57, 110, -49, -110, 118, -13, -65, 106, 35,
                  116, -18, 77, -20, -87, -1, 16, 59, 23, 60, 39, 78, 61, -22,
                  3, -96, 104, 119, 116, -18, -75, -79, -38, 127, 28, 69, 18,
                  -126, -2, -86, -41, 74, 74, 20, 30, 81, -1, 81, -69, 71, -17,
                  50, 103, 6, -64, -125, -54, -16, -77, -17, 77, -12, 36, 64,
                  86, 123, -1, -1, 2, 16, 103, 115, 1, -66, -14, -45, -44, -25,
                  -3, 56, 16, -15, 41, -68, 124, -96, -76, -117, -84, -62, 1,
                  -52, -47, 95, 6, -62, 86, -29, -4, -87, -54, -1, 116, 28,
                  -109, -41, -66, 123, 34, -13, 74, -23, 106, 100, 104, 41, -75,
                  33, -112, 119, -2, 58, 16, -89, 38, 98, -97, 88, -49, -5, -97,
                  125, 111, -44, 80, -123, -109, 59, -68, 102, 84, -77, 87, 43,
                  75, 112, 8, 108, 59, 119, 0, -124, 77, -84, -25, 97, 109, 46,
                  -13, 63, -37, 31, -11, -34, -57, -98, 98, 36, 126, -18, -67,
                  -91, -128, 124, -51, 52, -4, -51, 125, -68, 95, -73, -95, 121,
                  51, -48, -120, -121, 1, 9, -6, -100, -47, 125, 95, 110, 126,
                  -100, -90, -10, 4, -33, -77, -58, -29, -18, 37, -54, -41, 47,
                  92, -92, -4, -26, -58, -48, 47, -35, 6, 62, 59, -38, 52, -19,
                  0, -66, 79, -13, -69, 64, 18, -71, 31, -18, -12, -36, 95, 0,
                  48, 21, 114, -83, -2, 16, -49, -102, 57, 119, 4, -124, 50, 17,
                  -115, 96, -45, 110, -78, 70, 31, -102, -110, 99, 34, -119, 98,
                  -85, -5, -103, 15, -48, -63, 53, -9, -121, 4, 71, -125, -33,
                  -58, -15, -75, 64, -116, 0, -96, -7, -38, -39, -43, -50, 109,
                  78, 20, 2, -42, -27, -117, 48, 20, -97, 62, -39, 66, -86, -89,
                  -30, 0, 24, 5, 90, -85, -15, 5, -49, -2, 74, 32, 124, 4, 96,
                  -47, 8, -69, -37, -85, 105, 1, -108, -46, 18, -13, -55, 24,
                  127, 8, -26, -108, -18, 71, 29, -3, 121, -7, 53, -121, 90,
                  124, 33, -112, -125, -124, 64, -85, 100, -4, 58, 75, 111, 97,
                  52, -32, 108, 33, -58, 72, -71, -103, -9, 17, 13, -25, -112,
                  53, 106, 126, -47, -11, 117, 64, 70, 54, 101, -113, -59, -72,
                  70, -106, 15, -13, 106, -47, -78, 55, 101, 101, 42, -75, -70,
                  -36, -51, 121, 46, -12, -38, -9, 7, -92, -117, -120, 84, -118,
                  33, 45, 80, 42, 123, 45, 2, -56, -118, -20, -45, 75, -73, -28,
                  -108, 119, 108, -17, -52, 111, -27, -23, -33, 3, -60, 70, -27,
                  21, 12, 57, 43, 53, -90, 64, -106, 1, -52, -42, -50, -54, 11,
                  -71, 13, -6, 83, -64, -35, 27, -112, -79, -122, 72, 65, -106,
                  38, 121, 86, 94, 1, -110, -20, 55, 46, -15, 95, -107, -119,
                  100, 117, 103, 64, 102, 26, 46, -79, -41, 107, -43, -15, 22,
                  -120, -21, -107, 54, 33, -78, 86, 6, -16, 122, 103, 64, -106,
                  -127, 87, -70, -41, -75, -70, -2, 1, 8, -111, -118, -10, -119,
                  26, -4, -51, 108, -22, 59, -128, -84, -124, 82, 73, -70, 4,
                  36, -39, -60, 91, 2, 82, -34, 78, -77, -110, -56, -17, -27,
                  -73, -33, 98, 35, 77, -65, 4, -92, -40, 27, -106, -108, -67,
                  22, 37, 32, -96, -108, 23, -117, -24, 46, -127, -108, 70, 56,
                  -50, -115, 61, -75, -127, 109, 105, -59, 1, -108, -70, 97,
                  -98, -16, -3, 1, 25, 41, 64, 42, 59, 36, 92, 6, 82, -20, 121,
                  -85, 102, -26, 125, 112, 127, 64, -40, -66, 48, -71, 28, 35,
                  72, 9, -56, 91, -79, 116, 2, -6, 37, 82, 19, 64, -9, 39, -53,
                  -25, 127, 1, 72, 99, 90, -87, 30, -68, 78, -55, -25, 64, 74,
                  -35, -118, -20, -57, -40, -72, 55, 32, -114, 9, 42, -5, -5,
                  -98, 9, -7, 8, 4, 122, -27, 106, -30, -128, 106, 28, 58, -33,
                  29, 16, 25, 33, -79, 76, -55, -27, 68, 38, 21, 32, -112, 88,
                  -91, 21, -75, -125, 64, -110, 93, -105, -9, 6, 100, 36, 2, 84,
                  -71, -35, 17, -78, 25, 31, 20, 64, -96, 95, -7, -3, 5, 36, 27,
                  -112, -17, 14, 8, -37, 42, 0, 43, -3, -70, -68, 5, 1, -124,
                  34, -97, 1, 1, 81, -91, -103, -16, -115, -14, -54, 123, 100,
                  -65, -52, -53, -46, -79, 86, -85, 108, -68, -115, -128, 7,
                  -25, 3, -42, -92, 11, -108, 110, -27, 119, 108, -1, 62, 48,
                  -100, 123, 4, -30, -12, 16, -72, 61, 86, 72, -74, 37, -20,
                  -69, 83, 40, 88, -81, 21, 107, -104, -24, -16, -57, 93, 44,
                  127, 29, -120, -45, 35, 52, 109, -65, 73, 95, 87, 3, 5, 1, 82,
                  -65, 1, -88, -78, 77, 50, -26, -20, 94, -127, 56, 109, -128,
                  74, -69, -39, 114, -118, 47, 91, -48, 71, 79, -21, -118, -117,
                  -125, 46, 18, -74, -50, -35, 2, 113, -28, -128, 53, -3, -35,
                  -42, 20, 70, -68, 37, -100, 4, 61, 71, 56, -29, 92, -122,
                  -125, 119, -18, 24, -120, -77, -75, -112, -121, 76, -7, 67, 7,
                  -58, -62, 66, 47, 89, 107, 117, -51, 100, 123, 85, -92, -83,
                  115, -41, 64, 40, 59, -87, 83, 23, -91, 13, 62, -108, -26,
                  -73, -74, 79, -72, -103, 115, -72, -48, -8, -126, -80, -8,
                  -91, 56, -66, 3, -56, -126, 83, 32, -37, 78, 47, -88, -81, 55,
                  -75, -33, 73, 87, 58, -43, 91, 2, -122, 16, 40, -49, 95, 124,
                  2, -16, -41, 3, -39, -120, 62, 112, 21, -127, 65, 65, -110,
                  -66, -83, -42, 17, 15, 125, -113, 45, 79, -123, -6, -20, -85,
                  31, -5, -11, 64, 44, -116, 104, 44, 89, -85, -124, -99, -6, 0,
                  -56, -19, -71, 63, 108, -35, 19, 13, -65, 94, 15, -66, 28, 72,
                  -51, 69, 97, -94, -3, -68, -56, -102, 108, -88, -110, -27,
                  -37, 125, 51, -1, -43, -15, 40, 83, 92, -36, 63, 16, -42, -60,
                  -97, -91, -69, -81, 73, -109, 22, 68, -92, -87, -105, 114,
                  -57, 49, -121, 92, -44, 92, -34, 61, 16, 51, 126, 42, 72, 36,
                  76, -102, -73, -24, 37, -76, 75, 82, -23, -48, 76, -35, 26,
                  -35, 57, -112, -115, 68, 114, -73, -38, 72, -6, -86, -119,
                  -38, -70, 40, 83, 4, -6, 69, 33, 110, 66, -7, -5, -41, -79,
                  -59, 111, 2, 82, 67, 74, -66, -83, 71, 76, -37, 25, -114, 73,
                  62, -17, 2, 84, 12, 125, 83, 71, 36, -38, -34, 55, -112, -34,
                  75, 126, -57, 46, 42, -22, 90, -84, -35, 17, -110, 98, 7,
                  -112, -116, 110, 118, -114, -36, 31, -112, -73, 107, -67, 113,
                  -112, 22, -124, -110, -19, 25, -55, -74, 3, 88, -112, -10,
                  -111, -119, -120, 112, -72, 107, 32, 11, -88, -106, 2, 70,
                  -34, -100, 41, -90, 91, -49, -118, -82, 65, 3, 124, 89, -7,
                  -28, -69, -128, 76, -107, 81, -111, -111, 103, 64, 118, 90,
                  86, 26, -70, 22, -84, -105, 2, -60, -36, 93, 3, 25, 41, -45,
                  69, -98, 57, 93, -127, -84, -78, -82, -33, -46, -40, 47, -32,
                  -50, -127, 56, 118, -100, -43, 118, -7, 116, -51, -118, 1, 89,
                  -28, 64, -38, 37, -90, 82, 62, -83, -15, 46, 19, -85, 56, 111,
                  -127, -43, -67, 116, 83, 6, -27, -11, 89, 53, 40, 60, -108,
                  -128, 16, 109, 124, -41, 64, 54, 74, -34, 24, -69, 75, -6,
                  -80, -46, 3, -36, -46, -59, -86, 82, -87, 65, 5, 68, -71, 111,
                  32, 78, 23, -25, 111, 34, -104, 89, -120, 36, 64, -46, -35,
                  -62, 25, -103, 76, -82, -67, 70, -128, 122, -33, -86, -27, 56,
                  -13, -72, -98, -27, -71, -109, -77, -122, -127, 96, 56, 45,
                  118, 22, 0, 8, 75, 41, -70, -4, 117, -21, 9, -33, 7, 100, -89,
                  -8, -41, -30, -42, -38, 104, -30, -109, -90, 80, 21, 19, -44,
                  50, 117, 55, -111, -5, 117, -67, 2, -33, -106, -77, 47, 21,
                  63, 48, 74, -91, 32, -41, -93, -44, -86, 18, -2, 100, -90,
                  114, -5, -69, 7, 66, -7, -69, -121, -20, 107, 39, -39, -24,
                  -48, 19, 93, 64, -20, -62, 66, 26, -62, -51, 17, -125, -9, 10,
                  -60, -39, 90, 46, -98, -106, -6, 73, 39, -37, -106, 114, 114,
                  123, -103, -101, 98, 91, 125, -47, -81, 108, 4, -5, 123, 64,
                  28, 62, 36, 52, 103, -25, 26, -59, 104, -57, -122, 18, 91,
                  -75, 25, 59, 35, -100, -83, 0, -31, 123, -49, 71, -78, 96,
                  -94, -31, -56, -59, 8, 64, -69, 87, 36, -71, 35, 29, 120, -13,
                  25, -121, -64, 77, 72, -71, 103, 32, 67, 79, 105, -44, 56, 1,
                  35, -124, -91, -42, -78, -12, 99, 40, -63, -92, 79, 104, 62,
                  126, 8, 32, 51, 5, -77, -107, -63, -43, -96, -55, 26, 47, -93,
                  -4, 124, 43, 118, 72, 14, 113, 33, 2, 82, -17, -21, 95, 106,
                  -11, 45, 64, 106, 40, 76, -57, 126, -90, -13, 31, 4, -123,
                  -103, -17, -102, 4, 74, -26, -13, 119, -68, 102, -20, 91,
                  -128, -68, -6, -39, -38, 109, 7, 80, -9, -76, -20, 41, 88, 57,
                  -26, -59, 34, -12, 77, -18, -27, 123, -128, -92, -5, -111,
                  -100, -79, 70, -14, 83, 127, -89, -23, -78, 27, 63, 37, -31,
                  -14, -127, -128, -8, -26, 36, -49, 18, 51, -10, 11, -92, -12,
                  39, 34, 32, -58, -29, 0, -71, -18, -23, 99, 7, 122, 38, 64,
                  32, -52, 122, 0, 69, -124, -76, -51, -61, 0, 57, 35, -108,
                  -98, 63, -59, 67, -56, 14, -73, -110, -79, -108, -19, -55, 88,
                  55, -119, 75, -74, 15, 3, 100, 25, 101, -107, 31, 86, -92, 3,
                  103, 71, -9, -77, 61, 111, -50, 17, -72, -92, -71, 123, 24,
                  32, 35, -47, -53, 122, 46, -73, 2, -96, -62, -47, -3, 60, -83,
                  -91, -70, 86, 110, 15, -70, -5, -56, 110, 92, 15, -1, -112,
                  35, -113, 2, -119, -77, 67, 117, -57, 34, -86, 52, -98, -35,
                  63, 105, -20, -8, -7, -103, 73, -81, -45, 78, 67, 63, -91,
                  -113, 89, 89, -44, -117, -43, 39, -113, 4, 100, -95, 121, 90,
                  -106, -71, 31, 108, -105, 53, -96, 78, -58, 43, -125, -67, 74,
                  -63, -5, 30, -17, -5, 109, -17, 67, -28, 35, 95, -86, 93, -77,
                  19, -84, 112, 117, 45, 100, -91, 8, -94, 78, 30, 11, -120,
                  -77, 85, -30, 96, -112, 115, -36, -93, 24, 123, -84, 94, -121,
                  -76, 111, 123, 35, -30, -9, -67, 52, 114, -91, 2, 112, 93, 62,
                  -100, -68, -118, 8, 34, -111, -1, -66, -105, 109, 126, 31,
                  -112, -115, -51, -114, 95, -67, 92, 75, 12, 108, -5, -25, -39,
                  121, 64, 32, -100, 79, 88, -17, 101, -47, -32, -48, -62, -43,
                  86, -63, 7, 1, -62, 7, -72, 63, 103, -83, 101, -45, 124, 31,
                  -17, 50, 32, -24, -19, -15, -128, 88, 39, 113, 55, 97, 47, 75,
                  67, -66, -110, -67, -27, 88, 71, -104, 123, 56, 32, 27, 9,
                  -15, 108, -3, -106, 64, 77, -13, 113, -38, -127, 57, 86, 60,
                  -21, -31, -128, 44, 97, -62, 74, 12, -124, 59, -29, 33, 68,
                  105, 90, 101, 122, -38, -22, -31, -128, 36, 111, -59, -103,
                  105, -20, 44, -45, 101, -112, 109, 100, 80, 49, 58, 63, 26,
                  -112, 69, -78, 35, 113, 21, 64, 96, -77, 87, 14, -92, -92,
                  -111, -117, -107, -15, -61, 25, -69, -94, -90, -103, 45, -51,
                  16, 13, 76, -92, -92, -83, 73, -12, -51, 7, -12, 90, -55,
                  -104, -69, -82, 71, -127, -128, -12, 124, -115, -38, -44,
                  -101, 63, 30, 16, 35, 125, -23, -95, -31, 74, 99, 29, -89,
                  110, -21, 2, -128, -15, 120, 64, 86, -111, -107, -47, 96, -51,
                  68, -20, 8, -23, -99, 78, -128, -76, 127, 60, 32, 78, 47, 59,
                  -49, -73, 33, 122, 68, 91, 117, 117, 9, 32, -9, -82, -33, 6,
                  -2, -29, 90, 74, -104, 46, 74, 109, -6, 88, 96, -67, -40, 32,
                  -6, 70, 28, -33, 9, -124, 29, 82, -100, -40, -55, -124, 99,
                  -57, 83, 35, -79, -31, 60, 38, 16, 3, 66, 36, 37, -57, -108,
                  78, 84, -105, 32, 123, -26, 60, 38, -112, -119, -126, 8, 70,
                  -72, 121, 100, -106, 34, 67, -12, 13, 13, -103, 127, 6, 72,
                  13, 34, 69, -41, 48, 72, 15, 108, 53, 8, -18, 79, 30, 19, 72,
                  15, 99, -35, -39, -9, 4, 8, -92, -77, 83, 46, 117, 61, 92,
                  -122, -120, -109, -111, 115, -40, 69, -55, 54, 31, -54, 24,
                  -7, 71, -107, 8, -69, -7, 51, 107, -56, 22, -72, 13, 59, -122,
                  110, -2, -112, 64, 120, -126, 89, 108, -97, -79, -41, -26, 16,
                  -81, -34, -40, 75, 8, -42, 30, 17, -120, 99, 123, 17, 27, -72,
                  -111, -100, -91, 79, -90, -94, 0, -65, -45, 74, -66, 17, -56,
                  -94, -119, 19, -105, 43, -77, 87, -76, -72, -112, -64, 47,
                  111, -111, -3, 83, -111, -99, -121, -34, -100, -107, 29, 54,
                  -7, 9, -53, 94, -21, 49, -127, -80, 119, -15, -39, 73, 24, 60,
                  39, 111, 101, 66, -51, -11, -125, 2, 25, -103, 8, -89, 47,
                  -120, -31, 5, -86, 88, -56, 112, 30, 20, -56, -126, -75, 51,
                  -123, -55, 59, -85, 91, -40, 85, -65, 51, -116, 124, 47, -112,
                  -28, 69, -63, -48, 103, -121, 127, 27, -40, -35, 58, 15, 11,
                  36, -21, 42, 103, -127, -16, -1, 2, 8, -92, -36, -92, -9, 127,
                  1, 4, -14, 108, 23, -49, -1, 1, -112, 96, -67, 14, 72, -80,
                  120, 92, 32, -67, 28, -56, -90, 75, -120, -80, 121, 92, 32,
                  -37, -4, -68, -102, 87, 19, 21, -17, 43, 121, 64, 32, -55, 33,
                  2, 76, 36, 82, -11, 24, -111, -57, 3, -110, -97, 78, 69, 92,
                  34, 45, 30, 25, 72, 113, 92, 124, 126, -108, -12, -125, 2,
                  113, -22, -59, 25, -97, -93, -121, 6, 98, 92, 15, 117, 18,
                  -99, -121, 6, 50, 81, -14, -109, -43, 47, -113, 13, -60, 57,
                  102, 30, -8, -85, -114, -102, -5, 107, 64, 28, -82, 56, 119,
                  -14, -79, -127, -116, -11, 8, 35, -28, -117, -50, -93, 3, 97,
                  47, 120, 87, 20, 107, -5, 127, 0, -28, -49, 92, -1, 19, 96, 0,
                  -125, -71, 26, 66, 10, 101, 110, 100, 115, 116, 114, 101, 97,
                  109, 10, 101, 110, 100, 111, 98, 106, 10, 52, 32, 48, 32, 111,
                  98, 106, 10, 60, 60, 47, 84, 121, 112, 101, 47, 88, 79, 98,
                  106, 101, 99, 116, 47, 83, 117, 98, 116, 121, 112, 101, 47,
                  73, 109, 97, 103, 101, 47, 87, 105, 100, 116, 104, 32, 49, 50,
                  48, 47, 72, 101, 105, 103, 104, 116, 32, 49, 50, 48, 47, 76,
                  101, 110, 103, 116, 104, 32, 52, 50, 57, 47, 67, 111, 108,
                  111, 114, 83, 112, 97, 99, 101, 47, 68, 101, 118, 105, 99,
                  101, 71, 114, 97, 121, 47, 66, 105, 116, 115, 80, 101, 114,
                  67, 111, 109, 112, 111, 110, 101, 110, 116, 32, 49, 47, 70,
                  105, 108, 116, 101, 114, 47, 67, 67, 73, 84, 84, 70, 97, 120,
                  68, 101, 99, 111, 100, 101, 47, 68, 101, 99, 111, 100, 101,
                  80, 97, 114, 109, 115, 60, 60, 47, 75, 32, 45, 49, 47, 66,
                  108, 97, 99, 107, 73, 115, 49, 32, 116, 114, 117, 101, 47, 67,
                  111, 108, 117, 109, 110, 115, 32, 49, 50, 48, 47, 82, 111,
                  119, 115, 32, 49, 50, 48, 62, 62, 62, 62, 115, 116, 114, 101,
                  97, 109, 10, 38, -96, 120, 20, 127, -1, -1, -1, -1, -1, -4,
                  -122, 94, -121, -103, -36, -69, 46, 101, -23, -1, -1, 46, 18,
                  69, -77, -71, 46, 36, -14, -31, 63, -1, -1, -97, -78, -34, 16,
                  65, 22, -14, -20, -69, -25, -17, -1, -1, -1, -1, -61, -61, 14,
                  33, 127, -1, -1, -1, -2, 28, 35, -97, -1, -1, -1, -15, -62,
                  47, -124, 16, 65, 23, 97, -29, -1, -1, -1, 24, 65, 4, 17, -36,
                  -17, -31, 23, -53, -8, -1, -1, -1, -15, -121, 16, -1, -57, -1,
                  -4, -122, 93, -98, -50, -31, -27, -36, 40, 97, 103, 114, 17,
                  -1, -1, -1, -14, 13, 54, 16, 65, -105, 5, -62, 60, -53, -79,
                  -1, -1, 33, -106, -16, -126, 12, -10, 91, -97, -126, 47, -122,
                  123, 59, -119, 111, -1, -1, -1, -8, -120, -122, 16, 81, -124,
                  39, 115, -33, -1, -1, -119, 118, 93, -124, 16, 69, -16, -50,
                  -31, -98, 32, -65, -1, -1, 12, -37, 8, -13, 61, -28, -84, 103,
                  -125, 47, -1, -1, 12, 50, -7, 126, 28, 32, -117, -30, 44, -57,
                  -1, -1, -62, -124, 16, 92, 32, -126, -53, -111, 114, 47, -103,
                  -122, 111, -1, -1, -14, 13, 54, 25, 118, 34, 22, 25, 119,
                  -123, -1, -1, -112, -53, -29, -72, 101, -39, -74, 103, -105,
                  -4, -65, -1, -1, -1, -122, 16, 71, 114, 83, 8, 51, -40, 65, 5,
                  19, -65, -1, -1, -13, 121, -18, 17, 124, 35, -71, 39, 12, 98,
                  119, 31, -1, -1, -61, -122, 25, -36, 40, -60, 56, 65, 4, 119,
                  -1, -1, -16, -95, -124, 25, 118, 92, 56, 101, -40, 65, 4, 31,
                  -1, -1, -62, 45, -25, -77, -52, -97, 12, 48, -62, 47, -1, -1,
                  -1, -62, 12, 34, -20, 48, -61, 37, 112, -126, 31, -1, -1, -60,
                  -65, 59, -58, 17, 124, -65, 12, 68, -69, -1, -1, -2, 34, 50,
                  -30, -123, 12, -73, -105, 40, 69, -1, -1, -1, -112, -53, -48,
                  56, 69, -40, 71, -68, -17, -120, -1, -1, -4, -72, 72, 102,
                  -40, 97, -122, 20, 115, -71, -33, -1, -1, -4, -3, -99, -31,
                  28, -31, 66, 24, 127, -1, -1, -1, -61, 55, -105, 32, -126, 61,
                  -105, -62, 61, -1, -1, -1, -1, -122, 95, 8, 32, -114, -4, -69,
                  17, -99, -1, -1, -1, -4, 112, -79, -8, -49, 16, -1, -1, -2,
                  56, 67, -121, 8, -37, 60, 13, 127, -1, -60, 68, 68, 127, -1,
                  -1, -1, -1, -1, -2, 0, 32, 2, 10, 101, 110, 100, 115, 116,
                  114, 101, 97, 109, 10, 101, 110, 100, 111, 98, 106, 10, 53,
                  32, 48, 32, 111, 98, 106, 10, 60, 60, 47, 76, 101, 110, 103,
                  116, 104, 32, 49, 55, 50, 51, 47, 70, 105, 108, 116, 101, 114,
                  47, 70, 108, 97, 116, 101, 68, 101, 99, 111, 100, 101, 62, 62,
                  115, 116, 114, 101, 97, 109, 10, 120, -100, -83, 89, -35, 115,
                  26, 55, 16, 127, -25, -81, -48, 83, 39, 121, 56, -95, -113,
                  -109, 116, -41, 55, 108, 99, 76, 108, 32, -127, 115, 50, -103,
                  -55, 11, 53, -60, -95, -59, 92, -115, -23, -76, -7, -17, -69,
                  -70, 47, -93, 93, -31, -60, -45, -58, 97, 24, 107, 37, -3,
                  -10, -73, -69, -38, 93, -55, -113, -67, 71, 38, -107, 96, -2,
                  -57, 127, 107, -63, 92, 42, -40, -35, 3, -21, 111, 30, -18,
                  37, -69, 40, -39, -121, -34, -121, -34, 99, -17, -84, -24, 73,
                  -63, 50, -83, 88, -79, -22, 9, -106, 40, -83, 120, 106, -3,
                  47, -61, -94, -102, -32, 63, -118, -67, 3, -39, -120, 124, 62,
                  84, -53, 107, 16, 38, -13, -100, 27, -55, 50, -103, 114, -93,
                  89, -15, 112, 90, 32, 88, 113, -41, -21, 95, -126, 4, 80, -65,
                  -10, -34, -116, 102, 31, -121, -13, -23, 100, 56, 45, -40,
                  -20, -110, 125, 26, 46, 10, 118, 54, -100, -114, 6, 55, 111,
                  -117, -33, -69, 93, 116, 110, -72, 73, -15, 46, -119, -52, 45,
                  23, 26, 102, -128, -58, 29, -96, -107, 92, 58, -106, 9, -63,
                  101, -88, 9, 22, 84, 123, -68, -71, 24, -66, 31, -52, -117,
                  22, -1, 106, 56, -72, 41, -82, -40, 47, -20, 114, 48, 25, -33,
                  124, 6, 125, 110, 46, 7, -13, -31, -79, 46, -87, -42, 60, -53,
                  -16, 62, -119, 114, -118, 59, 25, -22, -94, 82, -61, 101, -58,
                  92, 102, -72, 11, 116, 33, -126, 90, -105, -15, -5, -47, 100,
                  56, 7, -12, -59, -30, 122, 114, 21, 24, 32, -51, 121, -26,
                  -16, -126, 68, -118, -108, -37, 28, -127, 42, -32, 105, -103,
                  115, -110, -21, 16, 20, 11, 106, -48, 1, 127, -57, -49, -39,
                  89, -7, -76, 102, -13, 114, -71, 98, -41, -27, -10, -113, -27,
                  97, -103, 40, 17, 40, -32, -128, 117, -114, 23, 39, -46, 0,
                  -21, -76, 86, 0, 98, -26, -111, -39, -52, 19, -13, 107, -84,
                  -29, -122, -91, -71, -28, 2, -120, 90, -59, -107, 105, 35, 80,
                  -44, 17, 120, 20, 62, -31, -76, 118, -9, 118, -81, 42, 56, 61,
                  -38, -47, -128, 7, 123, 49, 60, -1, -13, -121, 59, -61, -2,
                  -122, 47, 35, 32, -52, 24, -2, -98, -113, 122, 57, -73, -102,
                  57, 99, 124, 52, 60, -44, -65, -39, 92, -78, 109, 111, -15,
                  -77, -117, -3, -12, -121, -98, 1, -89, -22, -20, 21, 107,
                  -113, 22, 116, -85, 27, 61, 94, -75, 65, -88, -5, -15, 14,
                  -28, 120, 27, -17, 23, -105, 106, -18, -14, -32, 76, -95, -15,
                  -18, 112, -25, -43, -39, -98, 46, 31, -42, -20, -41, -32, -16,
                  -92, 92, 89, -68, 32, 81, 57, 23, -78, -13, -21, 49, -82, -54,
                  -72, -54, -114, -26, -9, 47, 85, -77, -9, 124, 112, 57, -66,
                  -66, -67, 97, 87, -125, -59, 96, -22, 33, -62, -107, 42, -53,
                  -72, 80, 17, -107, -119, 0, -23, 60, -72, 71, 42, 107, 1, -38,
                  -91, 84, 103, -23, -73, -119, -24, -100, 74, -104, 31, 51, 22,
                  17, 32, 100, -99, -78, -49, -21, -27, 30, 126, -101, -108,
                  -69, -61, 55, -90, -39, -59, -14, -5, -45, -79, 42, 70, 90,
                  46, -119, 38, -71, -13, -37, -58, -84, 87, 123, -89, 73, -22,
                  -60, 107, -35, 56, -46, 99, -76, -34, -83, -42, -5, -48, 8,
                  70, 112, -27, -16, -110, 68, -101, 19, 54, 104, -3, 70, -95,
                  -79, 0, 97, 79, -106, -37, -11, 49, -82, 76, -99, -25, -118,
                  -127, -63, -110, 81, -58, -83, 115, 9, 46, 17, 32, -36, -13,
                  114, -69, 93, -33, 29, 54, -27, 14, -116, 126, -64, 17, 96,
                  -46, -54, 113, 72, 9, 107, 127, 16, 1, 68, 11, 34, 64, 90, 8,
                  -43, -121, -1, 74, 40, 21, -100, 25, 11, -16, -44, 6, 80, 66,
                  68, -6, -126, -37, 125, -74, 79, 35, 110, -17, -58, 17, -8,
                  -89, -27, 126, -43, -97, -3, 117, 88, -107, -27, 62, -96, -17,
                  -46, -54, -9, -31, -70, -60, -28, 63, -16, 61, -59, -57, 2,
                  -92, -64, -112, 79, 121, -63, 3, -17, -101, 42, -46, 49, -76,
                  50, -66, -91, 120, -63, -3, 4, -102, 8, 16, -12, -19, 110,
                  115, -24, 95, -108, 119, -121, 114, -49, 124, -46, 10, -35,
                  15, 85, -55, 39, 0, -92, 5, -104, -27, 101, -9, 19, 45, -120,
                  0, 27, 96, 90, -124, -115, -122, -117, 76, 79, -114, 42, 32,
                  117, 58, -28, -86, 76, 70, -100, -34, -115, 35, -56, -7, -6,
                  -49, 114, 127, -40, -20, -18, -85, -80, 15, -35, 94, 123, 43,
                  92, -103, 88, -35, 117, 92, 113, -73, 83, 13, -80, -32, -89,
                  -126, 94, 66, -65, 1, 125, 41, -122, 63, 25, -12, -83, -121,
                  9, 60, 17, 16, 11, -36, -77, 105, -55, 67, -113, 43, -19, -37,
                  77, 12, -82, 79, -59, 93, -21, 88, 2, 78, 4, 8, -36, -9, 121,
                  -3, -7, 72, 41, -31, -1, 73, -111, -123, -39, 94, 112, 75,
                  -108, -128, 78, -55, -68, -112, -19, 109, -98, -15, 52, 82,
                  -93, -97, -57, -79, 10, -21, -3, 102, -71, 5, 19, -124, -7,
                  62, -27, -50, -30, 69, -119, -50, 79, 24, -96, -15, 113, 4,
                  28, 11, 98, 6, -104, -51, 27, 3, 8, -93, -113, -107, 80, 96,
                  -67, 76, 19, 45, 78, 90, -96, 113, 53, -43, -126, 8, -112, 22,
                  55, -53, -33, -40, -8, -126, -19, 112, 24, 64, -58, 21, -60,
                  116, 9, -12, 48, 71, 71, -32, 127, -18, 66, 127, -78, 113,
                  -52, -108, -97, -40, 116, 110, 6, -18, 88, -81, 107, 60, -101,
                  21, 93, -9, -8, -86, 29, -62, 53, -49, -3, 107, -83, -45, -21,
                  90, -40, -128, -57, -15, 14, -15, 14, -44, 26, -53, -13, 88,
                  116, 119, -29, -49, -41, 75, 64, -85, -100, 59, -98, 126,
                  -124, 75, -27, 120, 52, 40, -58, -77, -23, -79, 123, -31, -14,
                  -88, -55, -46, 36, -125, 108, 27, 15, -15, -100, 75, -55, 44,
                  36, 64, -123, 66, 28, 9, -88, 10, -109, -11, -31, 91, -71, 42,
                  -73, -27, 125, -112, -30, 50, -51, -13, 12, 47, 76, -32, -24,
                  101, -106, -123, 119, -38, 6, 2, -70, 48, 27, -59, -18, 4,
                  -11, -107, -18, 123, 0, -93, 83, -82, 45, -98, -109, 84, 118,
                  -117, -15, -52, 1, -33, -60, 120, 98, 1, -27, 121, -67, 57,
                  60, -123, 7, 88, 85, 38, 70, 12, -91, 107, -69, 55, -68, 55,
                  37, -120, 5, 53, -63, -37, -89, -11, 10, 103, 10, 77, -90, 37,
                  42, 61, -43, 40, -92, -46, -73, 84, -108, 36, 17, 80, -110,
                  -13, -31, -30, 54, 120, -100, 80, -50, 119, -27, -104, -92,
                  -17, -115, -55, 115, 64, -67, 57, 97, 73, 4, 53, -53, -96, 27,
                  80, -48, 9, 27, -30, -22, -60, -14, 52, -38, -124, -8, -108,
                  -89, -46, 24, 67, 44, -96, 12, -89, -77, -7, 4, -67, -65, 104,
                  -19, -97, 14, 48, 71, -56, -124, -71, 66, 28, -101, -19, 41,
                  71, 44, -88, 57, -50, 7, -45, -47, 48, -84, -67, 80, 101, 51,
                  -62, 19, 122, 33, 29, 45, -4, -38, -118, -86, 72, 88, -88, 77,
                  1, 32, 17, 80, -94, 103, -5, -51, -6, 43, -69, -37, 110, 118,
                  -101, -69, -27, 54, -24, -67, -32, -90, -107, -91, 120, 113,
                  2, -71, 2, 59, -75, -123, 33, -103, -119, 8, 106, -62, -69,
                  -14, -80, 126, 98, -27, 87, 118, -8, -74, 14, 17, -115, 127,
                  63, -62, -23, -56, 103, 3, 23, 71, 4, -21, -21, 40, 98, 39,
                  -88, 17, -17, -106, 79, 1, -110, -122, -68, 3, 44, -48, -76,
                  68, 41, 30, 111, 45, -3, -125, 87, -102, 69, 66, -119, 8, 34,
                  -121, -91, -22, 47, 99, 116, -31, 96, 75, -102, -4, -128, 1,
                  98, -37, -126, -112, -128, 34, -126, -102, -19, -16, -97, -27,
                  -61, 102, -73, -12, 87, -71, 16, 79, -42, -123, 2, 101, 65,
                  -72, 94, -70, 24, 105, -93, -85, 78, -109, -110, 38, -126, 72,
                  88, -63, 37, -2, -68, 92, 5, 124, -115, -53, 57, 89, -27, 15,
                  -112, 70, -87, -80, -35, -97, -16, 37, -126, -102, -17, -76,
                  12, -5, -74, -52, 95, 18, 49, 77, -87, 79, -92, -119, -90,
                  124, 42, -25, -11, -96, 101, -75, 27, -57, 79, 21, 23, -20,
                  -68, 96, -117, -13, -63, -44, 63, -102, 126, 121, 115, 54, 43,
                  -82, -66, -68, 13, -86, 14, 36, 121, 101, -15, 14, -119, 20,
                  -118, -100, -96, 6, 11, 78, -100, -119, -23, -48, -115, 55,
                  -2, -67, 57, -101, 125, 10, 60, -21, -86, 86, 53, -100, -106,
                  64, -21, 118, -86, 85, -83, 75, 38, -36, -86, -14, 16, 14, 11,
                  -16, -45, 68, -71, -30, -48, 37, -98, -97, -29, 107, -118, 85,
                  120, -111, -9, -21, 9, -12, -90, -98, 81, -125, 99, 1, 110,
                  -108, -57, -61, -55, 48, 104, 95, -108, -86, 107, 30, -78,
                  -80, 126, -122, -58, 123, 83, 11, 99, 65, 109, -30, 69, 0, 35,
                  68, 100, 78, 98, 95, 42, -85, -60, -74, 68, -128, -40, 21,
                  -21, -89, 67, 0, 106, 50, 110, -119, 85, -91, 59, 97, -43, 54,
                  -15, -23, -86, 127, -116, 100, -60, 78, -128, 112, 95, 40, 0,
                  34, -85, 10, 64, -72, 50, -127, -29, 117, -86, 0, 16, -46, 68,
                  -16, -125, 2, 32, -100, 79, -11, 36, -108, 28, -7, 19, 71,
                  -69, -79, -124, 86, 53, -118, -40, 9, -98, 11, 0, -124, 119,
                  112, -73, -46, 121, 21, 54, 104, 106, -94, -63, -53, -15, 71,
                  -115, 38, -37, -110, -64, 37, -126, -24, 11, 67, -116, 111,
                  86, 93, -89, 113, -4, 26, 69, -8, -74, 16, 36, 126, -119,
                  -128, -108, 0, 76, -37, 64, 52, 3, 65, 18, -51, -18, -60, -85,
                  70, -101, 116, 9, 109, 34, 64, -76, -31, 70, 11, 63, -13,
                  -117, -80, 6, 64, -12, -48, -100, -104, -22, -18, 33, 9, -17,
                  78, 24, 19, 65, -51, 88, -123, 53, 64, 84, -41, 86, -60, -15,
                  -71, -37, -1, 23, -51, -119, -75, -57, 10, 101, 110, 100, 115,
                  116, 114, 101, 97, 109, 10, 101, 110, 100, 111, 98, 106, 10,
                  55, 32, 48, 32, 111, 98, 106, 10, 60, 60, 47, 84, 121, 112,
                  101, 47, 80, 97, 103, 101, 47, 77, 101, 100, 105, 97, 66, 111,
                  120, 91, 48, 32, 48, 32, 53, 57, 53, 32, 56, 52, 50, 93, 47,
                  82, 101, 115, 111, 117, 114, 99, 101, 115, 60, 60, 47, 70,
                  111, 110, 116, 60, 60, 47, 70, 49, 32, 49, 32, 48, 32, 82, 47,
                  70, 50, 32, 51, 32, 48, 32, 82, 62, 62, 47, 88, 79, 98, 106,
                  101, 99, 116, 60, 60, 47, 105, 109, 103, 48, 32, 50, 32, 48,
                  32, 82, 47, 105, 109, 103, 49, 32, 52, 32, 48, 32, 82, 62, 62,
                  62, 62, 47, 67, 111, 110, 116, 101, 110, 116, 115, 32, 53, 32,
                  48, 32, 82, 47, 80, 97, 114, 101, 110, 116, 32, 54, 32, 48,
                  32, 82, 62, 62, 10, 101, 110, 100, 111, 98, 106, 10, 49, 32,
                  48, 32, 111, 98, 106, 10, 60, 60, 47, 84, 121, 112, 101, 47,
                  70, 111, 110, 116, 47, 83, 117, 98, 116, 121, 112, 101, 47,
                  84, 121, 112, 101, 49, 47, 66, 97, 115, 101, 70, 111, 110,
                  116, 47, 72, 101, 108, 118, 101, 116, 105, 99, 97, 47, 69,
                  110, 99, 111, 100, 105, 110, 103, 47, 87, 105, 110, 65, 110,
                  115, 105, 69, 110, 99, 111, 100, 105, 110, 103, 62, 62, 10,
                  101, 110, 100, 111, 98, 106, 10, 51, 32, 48, 32, 111, 98, 106,
                  10, 60, 60, 47, 84, 121, 112, 101, 47, 70, 111, 110, 116, 47,
                  83, 117, 98, 116, 121, 112, 101, 47, 84, 121, 112, 101, 49,
                  47, 66, 97, 115, 101, 70, 111, 110, 116, 47, 72, 101, 108,
                  118, 101, 116, 105, 99, 97, 45, 66, 111, 108, 100, 47, 69,
                  110, 99, 111, 100, 105, 110, 103, 47, 87, 105, 110, 65, 110,
                  115, 105, 69, 110, 99, 111, 100, 105, 110, 103, 62, 62, 10,
                  101, 110, 100, 111, 98, 106, 10, 54, 32, 48, 32, 111, 98, 106,
                  10, 60, 60, 47, 84, 121, 112, 101, 47, 80, 97, 103, 101, 115,
                  47, 67, 111, 117, 110, 116, 32, 49, 47, 75, 105, 100, 115, 91,
                  55, 32, 48, 32, 82, 93, 62, 62, 10, 101, 110, 100, 111, 98,
                  106, 10, 56, 32, 48, 32, 111, 98, 106, 10, 60, 60, 47, 84,
                  121, 112, 101, 47, 67, 97, 116, 97, 108, 111, 103, 47, 80, 97,
                  103, 101, 115, 32, 54, 32, 48, 32, 82, 62, 62, 10, 101, 110,
                  100, 111, 98, 106, 10, 57, 32, 48, 32, 111, 98, 106, 10, 60,
                  60, 47, 80, 114, 111, 100, 117, 99, 101, 114, 40, 105, 84,
                  101, 120, 116, 83, 104, 97, 114, 112, -110, 32, 53, 46, 53,
                  46, 49, 51, 46, 50, 32, -87, 50, 48, 48, 48, 45, 50, 48, 50,
                  48, 32, 105, 84, 101, 120, 116, 32, 71, 114, 111, 117, 112,
                  32, 78, 86, 32, 92, 40, 65, 71, 80, 76, 45, 118, 101, 114,
                  115, 105, 111, 110, 92, 41, 41, 47, 67, 114, 101, 97, 116,
                  105, 111, 110, 68, 97, 116, 101, 40, 68, 58, 50, 48, 50, 50,
                  48, 51, 48, 57, 49, 51, 51, 53, 50, 48, 43, 48, 53, 39, 51,
                  48, 39, 41, 47, 77, 111, 100, 68, 97, 116, 101, 40, 68, 58,
                  50, 48, 50, 50, 48, 51, 48, 57, 49, 51, 51, 53, 50, 48, 43,
                  48, 53, 39, 51, 48, 39, 41, 62, 62, 10, 101, 110, 100, 111,
                  98, 106, 10, 120, 114, 101, 102, 10, 48, 32, 49, 48, 10, 48,
                  48, 48, 48, 48, 48, 48, 48, 48, 48, 32, 54, 53, 53, 51, 53,
                  32, 102, 32, 10, 48, 48, 48, 48, 48, 49, 48, 52, 49, 50, 32,
                  48, 48, 48, 48, 48, 32, 110, 32, 10, 48, 48, 48, 48, 48, 48,
                  48, 48, 49, 53, 32, 48, 48, 48, 48, 48, 32, 110, 32, 10, 48,
                  48, 48, 48, 48, 49, 48, 53, 48, 48, 32, 48, 48, 48, 48, 48,
                  32, 110, 32, 10, 48, 48, 48, 48, 48, 48, 55, 56, 50, 50, 32,
                  48, 48, 48, 48, 48, 32, 110, 32, 10, 48, 48, 48, 48, 48, 48,
                  56, 52, 54, 54, 32, 48, 48, 48, 48, 48, 32, 110, 32, 10, 48,
                  48, 48, 48, 48, 49, 48, 53, 57, 51, 32, 48, 48, 48, 48, 48,
                  32, 110, 32, 10, 48, 48, 48, 48, 48, 49, 48, 50, 53, 55, 32,
                  48, 48, 48, 48, 48, 32, 110, 32, 10, 48, 48, 48, 48, 48, 49,
                  48, 54, 52, 52, 32, 48, 48, 48, 48, 48, 32, 110, 32, 10, 48,
                  48, 48, 48, 48, 49, 48, 54, 56, 57, 32, 48, 48, 48, 48, 48,
                  32, 110, 32, 10, 116, 114, 97, 105, 108, 101, 114, 10, 60, 60,
                  47, 83, 105, 122, 101, 32, 49, 48, 47, 82, 111, 111, 116, 32,
                  56, 32, 48, 32, 82, 47, 73, 110, 102, 111, 32, 57, 32, 48, 32,
                  82, 47, 73, 68, 32, 91, 60, 56, 102, 97, 55, 55, 54, 53, 56,
                  55, 48, 55, 48, 50, 57, 98, 49, 99, 54, 52, 100, 100, 100, 51,
                  55, 50, 99, 54, 100, 56, 50, 57, 55, 62, 60, 56, 102, 97, 55,
                  55, 54, 53, 56, 55, 48, 55, 48, 50, 57, 98, 49, 99, 54, 52,
                  100, 100, 100, 51, 55, 50, 99, 54, 100, 56, 50, 57, 55, 62,
                  93, 62, 62, 10, 37, 105, 84, 101, 120, 116, 45, 53, 46, 53,
                  46, 49, 51, 46, 50, 10, 115, 116, 97, 114, 116, 120, 114, 101,
                  102, 10, 49, 48, 56, 53, 52, 10, 37, 37, 69, 79, 70, 10,
                ],
                title: "Diagnostic Report",
                creation: "null",
              },
            },
          ],
        },
      },
    },
  ],
};

export const PRESCRIPTION = {
  resourceType: "Bundle",
  id: "2d38fcff-fefa-4579-b455-cd0b4ee4afce",
  meta: {
    lastUpdated: "Tue Feb 15 19:02:21 IST 2022",
    profile: [],
    security: [],
  },
  identifier: {
    system: "http://hip.in",
    value: "062df3f5-216d-4f28-b766-3b92c57396be",
  },
  type: "DOCUMENT",
  timestamp: "Tue Feb 15 19:02:21 IST 2022",
  entry: [
    {
      fullUrl: "Composition/1",
      resource: {
        compositon: {
          resourceType: "Composition",
          id: "Composition/1",
          status: "FINAL",
          date: "Tue Feb 15 19:02:21 IST 2022",
          title: "Prescription",
          confidentiality: "null",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          identifier: {
            system: "http://hip.in",
            value: "1",
          },
          type: {
            coding: [
              {
                system: "https://projecteka.in/sct",
                code: "440545006",
                display: "Prescription record",
              },
            ],
          },
          subject: {
            reference: "Patient/1",
          },
          encounter: {},
          author: [
            {
              reference: "Practitioner/1",
            },
          ],
          custodian: {},
          section: [
            {
              title: "OPD Prescription",
              code: {
                coding: [
                  {
                    system: "https://projecteka.in/sct",
                    code: "440545006",
                    display: "Prescription record",
                  },
                ],
              },
              entry: [
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
          ],
        },
      },
    },
    {
      fullUrl: "Practitioner/1",
      resource: {
        practitioner: {
          resourceType: "Practitioner",
          id: "Practitioner/1",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          identifier: [
            {
              system: "https://www.mciindia.in/doctor",
              value: "1",
              type: {
                coding: [],
              },
            },
          ],
          name: [
            {
              text: "ENT",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Patient/1",
      resource: {
        patient: {
          resourceType: "Patient",
          id: "Patient/1",
          gender: "MALE",
          birthDate: "null",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          identifier: [],
          name: [
            {
              text: "GOURAB BANERJEE",
            },
          ],
          telcom: [],
        },
      },
    },
    {
      fullUrl: "DocumentReference/1",
      resource: {
        documentReference: {
          resourceType: "DocumentReference",
          id: "DocumentReference/1",
          status: "CURRENT",
          docStatus: "null",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          type: {
            coding: [
              {
                system: "https://projecteka.in/sct",
                code: "440545006",
                display: "Prescription record",
              },
            ],
          },
          subject: {
            reference: "Patient/1",
          },
          content: [
            {
              attachment: {
                contentType: "application/pdf",
                data: [
                  37, 80, 68, 70, 45, 49, 46, 52, 10, 37, -30, -29, -49, -45,
                  10, 50, 32, 48, 32, 111, 98, 106, 10, 60, 60, 47, 84, 121,
                  112, 101, 47, 88, 79, 98, 106, 101, 99, 116, 47, 83, 117, 98,
                  116, 121, 112, 101, 47, 73, 109, 97, 103, 101, 47, 87, 105,
                  100, 116, 104, 32, 50, 48, 48, 47, 72, 101, 105, 103, 104,
                  116, 32, 49, 57, 56, 47, 76, 101, 110, 103, 116, 104, 32, 55,
                  51, 55, 53, 47, 67, 111, 108, 111, 114, 83, 112, 97, 99, 101,
                  91, 47, 73, 110, 100, 101, 120, 101, 100, 47, 68, 101, 118,
                  105, 99, 101, 82, 71, 66, 32, 54, 51, 40, -48, -48, -48, -22,
                  -22, -22, -77, -77, -77, -66, -66, -66, -20, -20, -20, -76,
                  -76, -76, -30, -30, -30, -70, -70, -70, -52, -52, -52, -68,
                  -68, -68, -16, -16, -16, -73, -73, -73, -45, -45, -45, -72,
                  -72, -72, -34, -34, -34, -43, -43, -43, -37, -37, -37, -50,
                  -50, -50, -54, -54, -54, -24, -24, -24, -64, -64, -64, -58,
                  -58, -58, -32, -32, -32, -60, -60, -60, -38, -38, -38, -62,
                  -62, -62, -40, -40, -40, -42, -42, -42, -1, -1, -1, -93, -93,
                  -93, -83, -83, -83, -87, -87, -87, -84, -84, -84, -86, -86,
                  -86, -88, -88, -88, -85, -85, -85, -89, -89, -89, -2, -2, -2,
                  -90, -90, -90, -4, -4, -4, -3, -3, -3, -80, -80, -80, -79,
                  -79, -79, -28, -28, -28, -81, -81, -81, -91, -91, -91, -82,
                  -82, -82, -5, -5, -5, -55, -55, -55, -11, -11, -11, -12, -12,
                  -12, -10, -10, -10, -9, -9, -9, -7, -7, -7, -17, -17, -17, -6,
                  -6, -6, -8, -8, -8, -13, -13, -13, -25, -25, -25, -27, -27,
                  -27, -92, -92, -92, -14, -14, -14, -26, -26, -26, -56, -56,
                  -56, 41, 93, 47, 68, 101, 99, 111, 100, 101, 80, 97, 114, 109,
                  115, 60, 60, 47, 66, 105, 116, 115, 80, 101, 114, 67, 111,
                  109, 112, 111, 110, 101, 110, 116, 32, 56, 47, 80, 114, 101,
                  100, 105, 99, 116, 111, 114, 32, 49, 53, 47, 67, 111, 108,
                  117, 109, 110, 115, 32, 50, 48, 48, 47, 67, 111, 108, 111,
                  114, 115, 32, 49, 62, 62, 47, 66, 105, 116, 115, 80, 101, 114,
                  67, 111, 109, 112, 111, 110, 101, 110, 116, 32, 56, 47, 70,
                  105, 108, 116, 101, 114, 47, 70, 108, 97, 116, 101, 68, 101,
                  99, 111, 100, 101, 62, 62, 115, 116, 114, 101, 97, 109, 10,
                  120, -38, -36, 93, 9, 119, -94, -56, 22, 102, -111, 69, 65,
                  52, 10, -63, -123, 80, 27, -94, 16, 112, 95, -93, -47, -1, -1,
                  -81, 94, 21, -117, -128, 73, 79, 79, 79, 39, -35, -6, 56, 115,
                  -50, -76, -119, -127, -6, -22, 110, -33, -67, 117, -85, -32,
                  -100, -17, -67, 120, 78, 108, -38, 106, -69, -74, -5, -26,
                  -25, 56, -36, -73, -34, 125, -87, -62, 19, 118, 35, 97, -118,
                  -102, -57, -47, -29, 2, 25, 25, -95, 15, -25, -35, -27, 122,
                  -68, -86, -75, 36, 107, -4, -80, 64, -34, -128, -89, -15, -7,
                  -121, -99, -91, 108, 30, 20, -56, 65, -13, -60, 117, -15, 113,
                  -46, 42, 127, 122, 36, 32, -99, 88, 104, 84, 126, 32, 114,
                  119, 15, 100, -76, 88, 46, 87, -73, -2, -118, -72, -14, -115,
                  -120, 36, -7, -98, -127, -116, -34, 13, 75, -119, -90, 110,
                  -88, -12, -71, -73, -110, 25, -88, 113, -3, -10, -85, -13,
                  105, -83, -14, 121, 93, 59, -66, -67, -67, 117, -33, -57, 127,
                  31, -56, -90, -90, -37, 4, 69, 26, -67, -22, -86, -86, 68, 26,
                  -9, -98, -1, -54, -118, 63, -36, -5, 24, -101, -41, 49, 79,
                  22, -49, -105, 16, 64, -49, -9, 125, 36, 114, -37, -47, -33,
                  4, -78, 122, -75, 66, -12, 18, 112, -115, -11, -104, 94, 19,
                  -90, 97, -42, -53, -76, -97, 58, -86, 69, -120, 63, 40, -46,
                  33, -16, -78, -25, -19, -37, 10, 4, -54, -45, -79, -15, 42,
                  31, 123, -106, 2, 113, -67, 93, -5, 75, 64, 102, -57, -117,
                  116, 58, -71, -74, -79, -88, -24, -103, 28, 121, -112, 99, 97,
                  124, 37, -32, -73, -37, -65, 89, 4, 4, 25, -20, 31, 114, 19,
                  -5, 98, -23, -41, 13, 78, 120, 33, -94, -50, -17, -2, 56,
                  -112, -123, -34, -60, 39, -46, 55, -74, 31, 126, 35, 35, -120,
                  21, 62, 81, -83, 15, 18, 89, 6, -112, 68, 53, 103, -95, 34,
                  -124, -26, -77, -86, -114, -10, 20, 28, 3, 77, 109, -4, 81,
                  32, 7, 53, -16, 61, -115, -85, 125, -86, -40, 115, -20, 34,
                  -46, -90, -58, 126, 106, 59, 31, 29, -103, 11, -60, 55, 9,
                  -69, 88, -100, 124, 16, 49, -49, 73, -66, 63, 85, 15, 127, 12,
                  -56, -69, 30, -6, 68, 49, 126, -92, 6, 123, 5, -71, 16, -11,
                  -100, -34, -55, -70, -3, 85, 15, -72, -82, 11, 93, -30, 34,
                  101, -7, -39, -97, -82, 57, -119, -60, -111, 90, -5, 35, 64,
                  -34, -71, -24, 20, 23, -52, -29, 51, -62, 11, -95, 11, 65,
                  123, -31, 106, -73, 110, -43, 100, 64, -24, 69, -92, -59,
                  -113, 44, -113, 23, -35, 19, 124, 58, 124, 59, -112, -102,
                  -27, -98, -48, 69, 23, -33, -1, -31, 59, 59, -115, 106, 16,
                  68, -78, -18, -33, -24, -106, 76, -91, -111, 92, 64, -4, -121,
                  -80, -44, 80, 65, -20, -86, -53, 111, 5, -62, -9, -31, -117,
                  -64, -67, -113, -50, 66, 56, -84, -56, -65, 81, 49, 122, -117,
                  77, 60, 17, 26, 22, -88, -104, -5, -69, 64, 82, 28, 46, -4,
                  -57, 8, -33, -74, 91, -54, 41, 50, 95, 71, -33, 4, 100, 84,
                  -21, -96, 88, -46, 23, 78, 87, -12, -6, -106, -21, 93, -114,
                  44, 91, 90, 111, -69, -100, 40, 10, -45, 115, -23, -101, 58,
                  102, -93, -59, -22, 90, -16, 94, 75, -114, 78, 4, 57, -114,
                  105, -39, 55, 53, -28, -118, -41, -83, 89, 90, -41, -103, 13,
                  -123, -109, 103, -14, -33, 1, 100, -4, 108, -30, -109, -46,
                  30, 59, -68, -24, -117, 116, 120, -53, -74, -126, -119, 38,
                  -118, 18, 68, 126, -20, 67, -44, -100, -35, 2, 33, -31, -5,
                  66, 68, 122, -58, 120, 39, -49, 90, -114, -61, -123, 97, -119,
                  6, 111, 35, 122, 31, -85, 45, 31, -106, -53, 69, -61, 24, -52,
                  -95, 100, -71, 54, -17, -84, -122, -38, 9, 89, -37, -81, 6,
                  50, 57, 43, 49, 54, -27, -103, -45, 16, 125, 65, 78, 60, 103,
                  -61, 6, 104, -22, 6, 1, -126, -30, -45, -36, -123, -80, 118,
                  11, -124, -118, -60, 25, -21, -127, -48, 122, 91, 53, 100, 93,
                  65, -56, 45, -128, -108, 8, -90, -123, 93, -120, 125, 15, 5,
                  83, -41, -115, 0, -76, -70, 27, 103, 43, -94, -2, -63, -39,
                  -11, -124, 19, -28, -34, -65, 16, -56, -2, -84, 75, -34, -44,
                  -22, -46, -63, 95, -112, -42, -38, 51, 96, 76, -51, 52, 99,
                  -65, -110, -91, -112, 90, -12, 70, 34, -32, 82, -4, -127,
                  -111, -50, 61, -94, -92, 113, 44, 98, 63, 118, -119, -25, 99,
                  -73, -72, -120, -74, 41, 123, 6, 100, 30, -19, 0, -69, -118,
                  88, 119, -127, 36, 51, -55, -114, -70, 10, -28, 14, -50, 94,
                  -105, 78, 80, -3, -105, 52, -20, -89, 64, 38, -122, -28, -57,
                  2, 71, -67, 8, 111, 122, -62, 115, 34, -115, 55, 17, -99, -62,
                  -34, -58, -39, 116, -56, -100, 57, -46, -111, 5, 32, 44, 52,
                  -6, 53, 5, 66, -102, 99, 103, 25, 17, 75, -25, 44, -83, -39,
                  -116, 10, 32, 96, 94, 1, -115, -88, -23, 47, -98, -90, -26,
                  -127, -118, -62, -13, -92, 36, -71, -97, 60, 75, -98, -75,
                  116, 102, 109, -19, 68, 46, -25, -55, -17, 3, 89, 13, -22, 30,
                  -42, -38, 84, 10, -17, 23, 4, -11, 68, 37, 120, 11, -6, 68,
                  125, 119, 70, -125, -88, 121, 76, -20, -89, 67, 35, 7, 82,
                  -82, 86, 34, 23, 64, 22, 1, -90, 95, 25, -115, 39, -101, 38,
                  -7, 12, -56, 66, 34, -39, 20, 28, -93, -87, -111, -52, 26, 17,
                  19, -57, -79, 105, -71, -47, 112, -26, 108, 6, 2, 85, 106,
                  126, -4, 123, 64, 26, 86, -24, -57, -54, -111, 41, -62, 54,
                  -60, 92, 98, -94, 43, -43, -11, -68, 62, 101, 39, 124, -109,
                  12, 18, 119, -13, 42, 33, 68, -111, 16, 37, -9, 69, -61, 84,
                  -113, 16, -115, 22, -115, 8, -89, -114, 107, 92, 2, 66, -76,
                  -36, 77, -83, 76, 106, 57, 36, 72, -120, -28, 90, 71, -54,
                  -42, 89, 61, 33, -33, 77, -115, 124, 57, 71, 97, 111, -20,
                  -84, 123, 20, -100, -58, -83, -2, 59, -112, -102, 26, 122,
                  -40, 58, -17, 50, 39, -103, 12, -13, 93, 21, -80, 23, 26, 99,
                  103, -49, 97, 51, -7, -55, -84, 53, -11, 73, -37, 0, -56, 5,
                  -118, -68, 77, 30, -41, -49, 108, -60, 100, -62, 1, 31, -127,
                  -64, 105, 22, -71, -113, 18, -96, -111, 51, -60, -128, 75,
                  -92, -7, 38, -96, -42, -124, -50, -117, -25, 77, -11, 125,
                  -30, -47, -52, -109, 68, -59, 53, 27, 70, -79, 47, -76, 54,
                  -1, 9, -56, 110, 96, -70, 0, 73, -43, -88, -44, 80, 3, -20,
                  69, -6, -69, 51, -23, 9, 90, -22, -68, -74, -90, -25, -119,
                  -12, 97, 93, 26, 37, 8, 112, 5, -13, -23, -35, -31, -16, -49,
                  -127, -20, -27, -63, -109, 25, 33, 23, -71, -19, -11, -112,
                  -8, 98, -94, 94, 27, 42, -108, -77, -77, 27, 6, 30, -106, 122,
                  -77, -60, 84, -20, 68, 90, -53, -127, -30, -5, 82, 103, -5,
                  -53, 64, 118, -49, -12, 15, 1, 65, 21, 42, -47, 120, -94, 15,
                  -128, 22, -11, -77, 93, 5, 112, -23, -4, 60, 83, -2, -88, 38,
                  -77, -73, 55, 9, 101, -125, 16, -8, -30, 104, 45, -111, 28,
                  -56, -21, 103, 64, 64, -53, 49, 36, 26, 126, 0, 116, -127, 32,
                  39, -110, 57, 5, 105, -80, -81, 53, 125, 117, -25, 108, 109,
                  -126, -127, 102, 84, 105, -66, 4, -64, 84, 93, -1, 18, -112,
                  -102, 42, -8, 126, 36, 14, 44, 66, 90, -123, 89, -86, 84, 66,
                  -128, 101, 67, -53, 57, 48, -45, -71, 89, 93, -128, 39, 24,
                  -41, -22, 15, 118, -27, 30, 38, 96, -24, -76, -63, 7, 32, 124,
                  -50, -77, 40, 14, 101, -76, 117, 17, 82, 108, -22, -22, -84,
                  116, 100, 75, -47, 3, 106, 50, 53, 59, 14, 9, -58, -120, 2, 5,
                  0, -103, -35, -78, 62, -20, -26, 52, -45, 9, -11, -38, -8, 95,
                  2, 25, -55, 22, 121, 65, 98, -17, -64, 50, 83, 66, -20, 39,
                  -93, -47, -32, 117, 110, 46, 1, 72, 36, 106, 28, -108, -36,
                  10, 25, 85, 58, 75, -40, -69, -46, -57, -125, -115, -101, 111,
                  -50, 100, 64, -1, -122, 119, 108, -100, 25, -5, 21, -56, -7,
                  26, -41, -111, -48, 24, -119, -128, -124, -68, -93, 2, -92,
                  -114, -14, -94, 23, -12, -107, -12, 86, -44, 7, -45, 108, 121,
                  -93, 79, 1, 34, -107, 60, 75, 69, 100, -22, 121, 68, -108, 71,
                  63, 7, 50, 89, 25, -74, 31, 75, -22, 27, -45, -1, -122, 78,
                  80, 52, -123, 83, 66, 103, 2, 3, -106, 19, 13, -46, -78, 116,
                  -22, 64, 38, 109, -120, 73, 103, -97, -29, 80, 98, 97, -101,
                  102, -120, 88, 28, -17, -21, -52, 27, 105, -77, -62, 70, -34,
                  -14, -64, 14, 105, -46, 53, -64, -96, -50, -20, 93, -59, -64,
                  -54, -107, -59, -104, -6, -31, 49, -5, 39, -62, 84, -52, 103,
                  -123, -72, -64, 29, 46, -42, -55, -72, 71, -109, 22, -128, 42,
                  -81, 74, -64, -57, -42, 103, 49, -78, 4, 100, -51, -85, 90,
                  20, 71, 28, -49, -18, -67, 24, 42, -60, -85, 63, 47, -10, -21,
                  21, -81, 66, 72, 9, 6, 77, -121, -114, -27, 44, 81, 4, 88,
                  -72, -78, 88, -102, -86, 103, 19, 74, -51, -58, -77, -100, 67,
                  72, 37, 64, 6, 116, -46, 111, -128, -80, -92, -67, 27, 120,
                  74, -110, -112, -116, 84, -116, -107, 60, 53, -95, -20, 7, 13,
                  82, -67, 121, 111, -75, 19, 41, -47, 12, -115, 68, -126, 104,
                  -102, -94, -40, -108, 16, 116, -87, 124, -10, -78, 25, -58,
                  -92, 46, -49, 126, 0, 100, -68, 109, 91, 18, 62, 1, -13, -103,
                  77, -9, -122, -65, 68, 49, -20, -16, 25, -16, -115, -119, -21,
                  -58, 86, 69, -72, 87, -118, -56, 33, -10, -20, -85, 111, -105,
                  -89, -66, 116, -43, 2, 126, -118, 57, 58, 44, 12, 73, 48, -80,
                  81, 5, 8, -60, -46, -39, -31, 5, -96, 102, -127, 100, -44,
                  -63, -32, -118, 100, 55, -9, -79, 89, -26, 86, 53, -106, -96,
                  33, 72, -128, 15, 53, -91, -82, 33, 108, 26, 76, 1, 22, 3,
                  -51, -117, -75, -42, 97, 116, 11, 100, 82, 107, -85, -118,
                  -21, -59, 72, -45, -109, 44, -68, -90, 107, -98, -33, 28, 46,
                  -82, 41, 97, -35, 102, 106, 121, 36, 64, -53, -44, 115, 36,
                  -37, 16, 65, -18, 106, 118, 58, -15, -52, 43, -114, -75, 5, 8,
                  86, 39, 19, 46, 34, -66, 55, 117, 11, 32, 8, 97, 119, -66,
                  114, -38, 17, 32, -41, 25, -103, 116, -128, -89, -28, 124,
                  115, 50, -120, 98, -23, 88, 6, 2, 3, 83, -93, -26, -60, 45,
                  -88, -86, -113, -113, 22, 124, -111, 116, -10, -100, -79, 108,
                  77, 99, 98, 25, 101, 31, -58, -43, -84, 38, -60, -108, -44,
                  73, 92, -78, 24, -77, -46, 69, 114, 2, 125, 57, 31, 36, 111,
                  55, -109, 28, -70, 97, -61, 122, -24, 33, 69, 100, 87, 19, 81,
                  -121, 115, -11, -114, -101, 39, -32, -39, 87, 81, -65, 107,
                  113, -109, 114, 72, -27, -24, 108, -28, 39, 17, 22, 64, -96,
                  34, 82, 46, -69, -66, 80, 107, 11, 81, -69, 88, 122, 112, -15,
                  -12, 74, -45, 120, -102, 27, 92, -25, 103, -36, 65, -64, 112,
                  -10, -125, 48, 28, -52, -14, 106, -127, -16, 66, -84, -60,
                  -105, 45, 41, 119, -118, 3, -37, -72, -50, 31, -57, -99, -88,
                  -1, 15, -83, -41, 68, -91, -114, -106, 16, -57, -126, -102,
                  -105, 71, 14, -122, 41, 14, -106, 44, -89, -102, -45, 72, 53,
                  58, -24, 116, 86, 17, 77, 68, -107, -44, 37, -27, -118, -25,
                  97, -5, -102, 26, 109, 21, 95, 56, 80, -31, 33, -92, -78, 59,
                  -38, 87, 27, -15, -22, 116, -128, -101, -74, 68, -59, -91,
                  -41, -90, -96, 16, 39, -11, 25, -62, -75, -60, -75, 17, 1,
                  106, 62, 25, -20, -22, 41, 30, 37, -58, 20, -29, -46, 80, 4,
                  125, -103, 14, 105, 53, 84, 124, -84, -76, -104, -75, -113,
                  120, 85, 56, -59, -127, -88, -97, 15, -52, 53, 113, -116, 126,
                  -38, -103, -116, -26, 62, -75, -93, 94, -10, 97, -76, -27, 20,
                  -101, -7, 91, -89, 102, 123, 90, -14, 15, 71, -89, 10, 2, -43,
                  6, -27, -34, -64, -52, 71, 94, -57, -40, -70, -54, -125, -50,
                  47, 43, 93, 119, 77, 64, -128, 112, 105, -105, -68, 86, -36,
                  118, -106, 106, -124, 8, 18, -38, 52, 76, 16, 95, -67, 82,
                  -38, 103, 23, 68, 87, -123, 26, 96, -105, 78, -107, 7, -24,
                  69, 20, -125, 18, -18, 57, -99, -13, 113, 91, -103, 90, -39,
                  -36, 79, -114, 52, 60, -64, -53, -37, 56, -87, 87, -118, 36,
                  -10, 80, 100, -75, 106, 59, -114, -26, 18, 88, -49, -18, -46,
                  39, 125, 62, -69, -1, -120, -17, -69, 86, 70, -81, 0, 124,
                  -38, -28, -123, 41, -84, -80, -127, -51, 65, 78, 118, -33, 4,
                  -54, -108, -82, 99, 58, 83, -45, 49, 82, 117, 23, 32, -114,
                  -61, -39, -7, 10, -60, 63, -49, -126, 19, 117, 67, 98, 82, 86,
                  -96, -18, -22, 105, 84, 80, 121, -124, -14, -56, -37, 102, 74,
                  59, 8, 48, -43, 73, -106, -31, 76, -122, 0, 13, 88, 49, -10,
                  92, 103, 25, 74, 102, 59, 115, 120, -62, 98, -102, -71, -68,
                  81, -14, 7, 16, 6, 29, -50, 121, 70, -64, -50, -18, -71, 63,
                  100, 83, -69, -18, 41, 84, 126, -119, 44, 57, 2, 58, -39, 29,
                  26, 23, 74, -79, 19, 72, 50, 77, -21, -108, -50, 124, 62, 23,
                  -87, 63, 29, 94, 71, -92, 79, -81, -109, -78, -96, -7, 68,
                  109, 81, 4, -60, 55, -1, -43, -23, -74, 5, 79, 75, 125, -56,
                  -40, -92, 72, -118, 114, -125, 75, 99, 95, -6, 16, 106, 66,
                  116, -118, -74, 42, 1, -80, -101, 62, 84, 71, 18, -107, -95,
                  51, 62, -101, -110, -51, -25, -54, 50, -108, 98, 95, 83, -109,
                  -47, 46, -115, 58, 116, -79, -55, 57, 19, -86, -106, -43, -70,
                  77, -29, 73, 82, -116, 73, -86, -110, 97, 92, -49, -100, -54,
                  94, 39, 87, -85, -37, 75, 30, -90, 100, 12, 48, -25, -88, -20,
                  -118, 20, -105, -96, 76, 99, 38, 118, 108, 77, -100, 82, 100,
                  55, -110, 2, -22, -69, 24, -25, 64, 5, -112, -111, -110, -28,
                  -73, 4, -126, -88, -61, 113, 92, -97, -114, 41, -7, -58, -85,
                  -120, -59, 108, -40, -68, -24, -43, 19, -43, 107, -52, -89,
                  98, -18, -123, 54, 109, -123, -44, -77, -47, 60, 3, 23, -73,
                  57, -26, 80, -120, 59, 44, -4, -9, -71, 47, -12, -45, -55, 88,
                  -21, -45, 23, 37, 37, -71, -50, 120, 16, 77, -71, -94, -38,
                  81, -109, 117, 74, 94, -103, 77, -125, -68, -98, -72, 83, 9,
                  68, -7, 7, 61, 22, -45, 92, 37, 7, -46, -114, -109, -1, 111,
                  -91, -20, -77, -45, 13, 17, -72, -42, 27, 103, 77, -58, 55,
                  -79, 23, -5, -40, 35, -37, -116, 56, 104, 32, 47, 62, 60, 75,
                  -79, -59, 103, 80, -108, 118, 54, -4, -15, 106, 118, -99, 64,
                  -92, 108, 88, 64, -28, 48, -99, -113, -70, -56, -23, -70, -82,
                  42, -51, 124, -119, 99, -63, 5, 39, 45, 47, -116, -74, -123,
                  107, 61, -28, 42, 55, 27, -123, 70, -115, -61, -47, 50, -97,
                  55, 42, -99, 77, 78, 50, -126, -44, 54, 7, -24, 42, -111, 65,
                  22, 27, -124, -27, -75, 92, 7, -102, -39, -65, 39, 10, -99,
                  17, 4, 37, -111, 74, 101, -112, 91, -36, -116, 58, -55, 108,
                  -18, 54, -100, -121, 47, 73, -8, 93, 15, -125, -16, -87, 90,
                  -89, -28, 5, 66, -70, 73, 100, 31, -51, 89, 126, -125, 48,
                  -10, 78, -98, -42, 78, -57, 50, -42, -35, -105, 32, -69, -51,
                  -92, 102, -110, 126, -19, 54, -107, -97, -98, -60, 6, 83, 17,
                  108, -67, -54, -25, -95, 56, -91, 60, 49, -81, 64, 80, -113,
                  -102, -124, -68, 9, 7, 97, 14, 4, 103, 11, 113, 106, -100,
                  -81, -119, -46, 68, 31, 43, -35, -43, 122, -58, 106, 66, -24,
                  -87, 107, -29, -48, -88, 70, -21, -91, -27, 105, -35, 89, 90,
                  84, -21, -5, -111, -66, 75, -11, 36, 20, 6, -85, -30, -117,
                  53, 1, 1, 115, -108, 82, -108, 125, 51, 101, 66, -48, -22, 22,
                  -45, -95, -22, 25, -16, 119, -45, 19, 111, -117, -79, 11, -45,
                  67, -83, -28, 17, 61, 55, -94, -76, -110, 58, 14, -115, 70,
                  -77, 102, -17, -80, 92, -55, 38, -126, -128, -7, -82, 85, 31,
                  95, 3, -94, 1, 32, 72, -98, -59, 97, -44, 52, -40, -70, -48,
                  -50, 4, -127, 75, -61, 118, -92, -52, 45, -31, 36, -114, -100,
                  -47, -128, -110, -112, -101, -36, -87, 102, -57, 74, -6, -93,
                  -47, 89, -14, -123, 84, 90, -109, 87, 5, -102, 79, -6, 121,
                  -75, -20, -23, -6, 83, 68, -120, -76, -52, -71, -42, 54, 96,
                  72, -56, -13, 103, 57, -106, -118, -102, 111, 55, 57, -64,
                  -40, -112, 78, 97, 70, 24, 39, -21, -11, 126, 69, 121, 24, 21,
                  79, 27, 16, -54, 73, 92, 76, -7, 34, -91, -6, -5, -82, -62,
                  -56, -4, 21, -120, 11, -31, 112, 76, -115, -124, -110, 79, 32,
                  105, -51, -90, -28, 122, -67, -41, 16, -64, 40, 8, 45, 43, 53,
                  -127, 87, -31, 69, 59, 126, 40, -30, 32, 61, 85, -110, 93,
                  -49, 61, -91, 86, 79, 57, -118, -23, -67, -64, 48, -96, 90,
                  68, -35, 53, 43, -61, -28, -92, -111, -102, 30, -115, -42,
                  -22, -57, 5, 29, 46, -112, 62, 44, 32, -48, -12, -42, -73, 74,
                  -103, -62, 104, 16, -126, -60, 21, 90, -66, -90, -120, -70,
                  33, 18, 0, 48, 10, -35, 68, -52, 5, 16, -86, -66, 77, 81, -64,
                  -44, -75, 104, 74, -24, -5, 84, -21, 39, 14, -81, -127, -32,
                  105, 95, 80, -22, 57, 6, -13, -3, 77, 33, 71, 39, 66, 59, -99,
                  -55, 70, 123, 112, -66, 22, 112, 85, -120, -45, 92, 45, 117,
                  115, 57, -115, 127, -101, -46, 41, 115, 59, 85, 75, -40, 25,
                  -47, 116, -8, 97, 29, -92, 71, -103, -15, -80, -92, -52, -101,
                  39, -33, 75, -29, -39, -42, -40, -116, 88, 76, 11, -38, 61,
                  81, -56, 50, -87, 18, 16, 42, 115, -97, 40, -94, -26, -43, 23,
                  107, 121, -96, -102, -52, 86, 86, 34, -51, -107, 75, -100,
                  124, 64, 98, -27, -74, -26, -69, -75, 125, -27, -109, 58, 112,
                  -83, -109, 100, -49, -40, 30, 87, -14, -111, -93, 70, 1, -30,
                  -87, -91, -22, -70, 113, 124, 101, -41, 81, 86, 62, 41, -17,
                  31, 40, 95, 21, -53, -14, -33, -9, 79, 97, 57, -67, 30, -8,
                  26, -45, -22, -122, 66, 62, 2, -95, 25, -1, -40, 89, 88, -79,
                  88, -52, -6, -34, 2, -34, -91, 52, 89, 103, 37, -122, -83,
                  -37, 108, 67, 22, -15, -57, -107, -84, -111, -54, 68, -114,
                  -83, -35, 77, 98, 117, -24, 83, 93, -128, 84, 41, 48, -56, 46,
                  95, -7, -72, 30, 99, 8, 62, -79, -54, 66, -30, 37, 95, 43, 45,
                  107, -114, -12, -109, -12, -98, -101, 55, -92, -78, -49, -106,
                  22, 18, 32, 48, 74, 126, 53, -30, 98, -91, 84, -90, -30, 40,
                  -109, 47, -51, -41, -2, -126, -3, -6, -19, 82, -30, -92, 39,
                  -111, 97, -75, -32, -72, 126, -62, 44, -63, -55, 121, 94, 57,
                  -43, -27, 21, 64, 74, 37, 90, 56, -3, 32, -49, 37, -99, -66,
                  -80, -78, -72, -15, 28, -7, 98, 105, 80, 51, 53, -9, 50, 52,
                  57, 12, -126, -128, -26, 35, 106, -74, -22, -58, -26, -120,
                  100, -112, -97, 78, 37, -103, 56, 6, -84, -70, -59, -98, -21,
                  7, 31, -4, -50, 76, 37, -30, -37, -106, 94, 93, -103, 106,
                  -117, 108, 41, 2, -77, 106, 112, -27, -98, -107, -100, 125,
                  102, 8, 37, 36, 68, -70, 45, -119, -47, -76, 16, -104, -27,
                  71, -114, 105, 74, 53, 47, -71, -76, -115, -8, -110, 119, 51,
                  13, 79, -61, -3, 114, 81, 71, 89, 108, -31, 124, -115, 82,
                  115, 41, 95, 3, -27, 78, 101, 105, -53, 83, 28, -107, -89,
                  103, 91, -9, -111, -11, -95, -14, 115, 80, -68, 100, 88, -119,
                  -74, 32, -60, -46, 71, -23, -7, 71, 85, -108, 30, 40, 85, -1,
                  -93, -86, 83, 95, -87, 4, -125, 86, 69, -66, 106, -116, 7, 37,
                  -77, 31, -51, 95, -14, 104, -57, 67, 105, -97, 68, -20, -84,
                  -48, -53, -59, 44, -127, 25, -60, -83, -30, -101, 37, -103,
                  -44, 66, 63, -22, -106, 31, -43, -57, -98, -8, 65, 31, -38,
                  24, 38, -38, -102, -105, -107, 72, -55, -33, 125, 40, 7, 81,
                  -90, 113, -123, 2, -84, 114, -63, -75, 45, 96, 44, 85, -68,
                  -4, 66, -12, 42, 19, -71, -77, 79, -71, -7, -84, -76, 100, 1,
                  113, 29, -62, 10, -112, 81, -33, 123, -50, 115, -36, 23, -77,
                  52, 5, -115, -66, -17, -22, 101, 81, 15, -90, 30, 81, 111,
                  -62, -105, 12, -54, -118, -113, -98, 42, -59, -108, 15, 117,
                  45, -102, -60, -48, 32, -112, 41, 87, -40, 121, 61, 44, 119,
                  73, -49, 9, -115, 121, -72, 42, -18, -102, -106, 84, 102,
                  -117, -65, -76, 95, -14, -116, 119, 98, -5, 98, -110, -110,
                  -71, 85, 32, -50, 17, 100, 36, -116, -6, -100, 88, 45, 73,
                  119, 102, -5, 64, 31, 87, -18, -18, 97, -79, 26, 13, 58, 37,
                  32, -91, -68, -1, -121, -107, -58, -79, -15, 84, -121, -87,
                  -118, -47, -1, 5, -111, -40, -103, 119, 40, -87, -125, -62,
                  96, 114, -29, -65, -60, -78, 115, 94, 91, -66, -98, 103, 101,
                  28, 32, 124, -26, -85, 114, 32, -66, -108, -52, 66, -25, 36,
                  -114, 115, 36, 47, 106, 105, 74, 103, -44, 121, -39, 101, -93,
                  92, 119, -112, 23, -74, -81, 14, 114, 124, -80, -82, -10, 11,
                  1, 49, -49, -1, -86, -10, 59, -90, 105, 46, 73, 93, 24, 101,
                  0, 44, -19, -92, 62, -84, 58, 61, 67, 47, -26, -54, -64, 26,
                  -110, -41, 43, 116, 32, -53, -81, -84, 2, 8, 78, -120, -124,
                  -45, 8, -4, -100, 63, 80, 47, 92, -95, 18, 109, 24, -37, -107,
                  -24, 107, -48, 121, 20, -44, -18, -37, -37, -101, 97, 112, 82,
                  -124, -14, 10, 31, 22, -84, -73, -47, -65, 94, 86, 24, 119,
                  91, -118, 91, -42, -55, -96, 28, 84, 102, 28, 14, -12, 10, 14,
                  13, 11, -14, -7, 85, -106, 101, -22, -100, -126, 56, 74, 20,
                  -88, 54, -123, 5, 16, 96, 103, -55, 3, -108, -9, -117, -43,
                  106, -75, -34, -20, 45, -97, 43, 15, 72, 14, 61, -91, 18, 64,
                  -50, 18, 33, -120, 93, 108, 42, 97, -118, 2, 68, 26, -73, -4,
                  -43, -123, 30, -43, 43, 1, 113, 75, 62, 108, 89, 7, 88, -81,
                  -84, -95, 75, 116, -66, -128, 31, -109, 105, 104, 91, 22, 119,
                  105, -15, 45, -18, 73, 85, -112, 91, 0, -127, -111, -54, -87,
                  -12, -65, 41, 9, 53, 41, 12, 3, -41, 13, 5, -73, -108, -17,
                  50, 7, -37, -12, -101, 21, 79, -87, -29, -54, 92, 2, -32, 42,
                  122, 99, -4, -21, 43, 86, 123, -77, 116, 35, -92, -18, -78,
                  -14, -36, -2, -103, 14, -69, 2, -28, -96, 0, 23, -95, 64, 124,
                  -38, -18, -9, -71, 74, 111, 13, 75, -93, 4, -15, 10, -60, 37,
                  -79, -85, 88, 70, 109, -69, 61, -84, -106, -37, -122, -84, 90,
                  18, 35, -105, 79, -109, 74, 107, 17, -86, -8, 65, -75, -20,
                  -89, 72, 104, 15, 27, -77, -1, -74, -122, 56, -77, 112, -31,
                  -73, -95, 80, 55, -25, -13, 14, -117, -87, -84, -94, -35, -71,
                  106, -107, 110, -121, -124, -32, -70, -68, -68, 85, -36, -39,
                  -71, 9, 10, -43, -46, -116, 27, -58, -77, -87, -55, 106, 116,
                  42, -13, -63, 55, 86, 98, -26, -82, -47, -127, 15, 97, 73, 30,
                  -16, -8, 27, -117, -95, 99, -50, -59, 8, 94, 93, 55, 74, -126,
                  106, -6, 25, -86, -53, -3, 122, -39, -88, -51, -89, 24, 16,
                  32, -75, 43, 18, 127, 86, -46, -56, -9, -34, -12, 82, 32, 29,
                  47, 33, -69, 78, -125, -81, -94, 89, 114, -82, 107, 14, -9,
                  -91, -123, 109, 26, -81, -97, 56, -114, 111, -16, -100, 94,
                  71, 37, 121, 84, 117, -7, -41, -105, -89, -87, -1, -126, -116,
                  17, 32, -24, -34, 92, 40, 72, 52, -99, 113, 5, 100, -35, -84,
                  85, 118, 59, 122, -86, 4, -105, 56, 1, -78, 14, -92, 100, -80,
                  27, 75, -71, 125, -30, -62, -14, -23, -48, -97, -113, -116,
                  110, 107, 36, 29, 51, 102, 42, -115, 113, 105, -75, 14, 71,
                  -19, -33, 110, 24, -104, -44, -38, 118, 93, 20, 67, 116, -117,
                  4, -62, -116, 50, -128, 31, 78, -42, 49, 76, 37, -78, -114,
                  -78, -98, -89, -47, -24, -29, -38, -122, -18, -95, -116, 111,
                  -61, -14, -67, -81, -1, 34, 8, 79, -71, -97, -75, -42, -3, -5,
                  -90, -102, -125, -118, -35, -49, 47, -84, -2, -96, 13, -25,
                  93, -89, 20, 47, 5, 18, -110, 31, 119, 4, -115, 6, 83, -14,
                  -7, -99, 1, -10, 96, 32, 53, -83, -25, -97, -9, -94, -3, 66,
                  -101, -45, -69, 6, 62, 127, -102, -99, -101, -57, -82, -120,
                  103, -77, 5, 63, -80, 92, -112, -57, -111, -75, -128, -124,
                  127, -80, 85, 25, -62, -49, -18, 12, 85, -99, -109, 87, -5,
                  127, -45, -8, -16, 75, -3, 90, -17, -118, -9, -47, 82, 104,
                  -128, -31, -81, 62, 78, -29, -12, -31, -85, -95, -21, -70,
                  -87, 4, 46, 78, 52, 37, -105, 8, 36, 80, -20, -43, -10, -29,
                  -44, -127, 55, 94, -37, 122, -65, 68, 10, -11, -49, -92, -3,
                  73, -29, -29, 23, 53, -98, -19, 123, 74, 4, 110, -75, -96, 48,
                  -112, -117, 71, -119, 37, 102, 57, 38, 70, 4, 86, -6, 53, 40,
                  16, -22, 18, -80, 27, 54, -39, -6, 74, 93, -104, -46, 111,
                  -47, 20, 119, 82, -84, 114, -35, -50, 16, 36, -98, -16, 43,
                  13, 91, -65, -40, 10, 56, 89, -75, 89, -11, -101, 20, -86, 80,
                  68, -4, -61, -12, 51, -3, 40, -128, -92, -61, 75, 40, 71, -10,
                  -25, 94, -31, 36, 108, 80, -115, -31, 40, -110, -12, 95, 106,
                  7, -4, -11, 46, -45, 67, -53, 22, 21, 72, -77, 76, -60, -30,
                  98, -119, -125, -55, -56, -3, 41, -112, -22, 69, -126, 109,
                  -111, -47, 93, 37, 65, 16, 8, 76, 99, -7, -117, -69, 77, -2,
                  91, 3, -13, 110, -69, 61, -97, 57, -118, 7, -112, -94, 26,
                  -81, -126, 95, 5, -30, 122, 92, -91, 53, -118, 121, 96, -73,
                  -87, -88, -25, -9, 95, 31, -46, 111, 53, -7, 79, 120, 93, 42,
                  -58, 82, -72, 103, -124, 19, 2, 0, 75, -58, 46, -64, 74, -16,
                  -55, 62, 33, 49, -113, 42, 60, 13, 23, -118, 97, -76, -27,
                  -38, -8, -65, -11, -5, -1, -18, -74, 11, -39, -69, -74, -61,
                  -43, 114, -105, 6, -19, -127, 58, -17, -104, 81, 16, 80, -1,
                  -101, 2, 97, -51, -28, -119, 117, -112, -128, 93, -126, -112,
                  55, 60, -27, -114, 107, 75, 17, 10, -117, -33, 24, -56, 111,
                  3, -63, -45, -85, 30, 112, 36, 37, 21, 48, 89, -115, -104, 29,
                  -106, -117, 26, 111, -91, 20, 101, -21, 34, -99, -89, 25, -46,
                  27, -65, -92, -41, -98, 23, -55, -115, 68, 40, 16, 23, -76,
                  -1, 34, 16, 30, 22, -51, -67, -93, -102, 42, 64, -58, 49, 33,
                  22, -72, 70, 58, 68, -11, -108, 1, 41, 111, -62, 120, 87, 50,
                  -65, 80, 16, 65, -102, -35, -69, -104, -5, -117, 64, -58, 77,
                  -49, 46, 51, -13, 51, 87, -113, 88, 40, -15, -89, -106, -15,
                  78, 121, -94, -104, 73, 4, 10, -17, 5, -34, 102, -26, 22, 80,
                  -47, 0, 124, 100, -27, -74, -6, -20, -17, 1, -95, 89, -92, 80,
                  37, 66, -29, 70, 75, -67, -120, -118, -21, -7, 36, -44, -115,
                  38, 54, 25, -19, -35, -78, 6, -57, -44, 63, 24, 23, -104, 42,
                  32, 42, 87, -27, 116, 70, -32, -93, -43, 95, 4, -14, 30, 120,
                  -30, 39, 19, 57, 105, -16, 45, 37, 60, -99, 0, 68, -126, -40,
                  -37, -14, 80, -110, -113, -14, -15, -71, -81, 64, 15, -109,
                  36, -81, 17, -60, -94, 109, 33, -39, 24, -32, 2, -21, 47, -86,
                  -106, -29, 12, 1, -80, 126, -96, 18, -53, 87, -67, -82, 69,
                  36, -10, -119, 52, 101, 9, 55, -120, 99, -102, -43, 7, -126,
                  98, 27, -14, 91, 57, 110, -49, -110, 118, -13, -65, 106, 35,
                  116, -18, 77, -20, -87, -1, 16, 59, 23, 60, 39, 78, 61, -22,
                  3, -96, 104, 119, 116, -18, -75, -79, -38, 127, 28, 69, 18,
                  -126, -2, -86, -41, 74, 74, 20, 30, 81, -1, 81, -69, 71, -17,
                  50, 103, 6, -64, -125, -54, -16, -77, -17, 77, -12, 36, 64,
                  86, 123, -1, -1, 2, 16, 103, 115, 1, -66, -14, -45, -44, -25,
                  -3, 56, 16, -15, 41, -68, 124, -96, -76, -117, -84, -62, 1,
                  -52, -47, 95, 6, -62, 86, -29, -4, -87, -54, -1, 116, 28,
                  -109, -41, -66, 123, 34, -13, 74, -23, 106, 100, 104, 41, -75,
                  33, -112, 119, -2, 58, 16, -89, 38, 98, -97, 88, -49, -5, -97,
                  125, 111, -44, 80, -123, -109, 59, -68, 102, 84, -77, 87, 43,
                  75, 112, 8, 108, 59, 119, 0, -124, 77, -84, -25, 97, 109, 46,
                  -13, 63, -37, 31, -11, -34, -57, -98, 98, 36, 126, -18, -67,
                  -91, -128, 124, -51, 52, -4, -51, 125, -68, 95, -73, -95, 121,
                  51, -48, -120, -121, 1, 9, -6, -100, -47, 125, 95, 110, 126,
                  -100, -90, -10, 4, -33, -77, -58, -29, -18, 37, -54, -41, 47,
                  92, -92, -4, -26, -58, -48, 47, -35, 6, 62, 59, -38, 52, -19,
                  0, -66, 79, -13, -69, 64, 18, -71, 31, -18, -12, -36, 95, 0,
                  48, 21, 114, -83, -2, 16, -49, -102, 57, 119, 4, -124, 50, 17,
                  -115, 96, -45, 110, -78, 70, 31, -102, -110, 99, 34, -119, 98,
                  -85, -5, -103, 15, -48, -63, 53, -9, -121, 4, 71, -125, -33,
                  -58, -15, -75, 64, -116, 0, -96, -7, -38, -39, -43, -50, 109,
                  78, 20, 2, -42, -27, -117, 48, 20, -97, 62, -39, 66, -86, -89,
                  -30, 0, 24, 5, 90, -85, -15, 5, -49, -2, 74, 32, 124, 4, 96,
                  -47, 8, -69, -37, -85, 105, 1, -108, -46, 18, -13, -55, 24,
                  127, 8, -26, -108, -18, 71, 29, -3, 121, -7, 53, -121, 90,
                  124, 33, -112, -125, -124, 64, -85, 100, -4, 58, 75, 111, 97,
                  52, -32, 108, 33, -58, 72, -71, -103, -9, 17, 13, -25, -112,
                  53, 106, 126, -47, -11, 117, 64, 70, 54, 101, -113, -59, -72,
                  70, -106, 15, -13, 106, -47, -78, 55, 101, 101, 42, -75, -70,
                  -36, -51, 121, 46, -12, -38, -9, 7, -92, -117, -120, 84, -118,
                  33, 45, 80, 42, 123, 45, 2, -56, -118, -20, -45, 75, -73, -28,
                  -108, 119, 108, -17, -52, 111, -27, -23, -33, 3, -60, 70, -27,
                  21, 12, 57, 43, 53, -90, 64, -106, 1, -52, -42, -50, -54, 11,
                  -71, 13, -6, 83, -64, -35, 27, -112, -79, -122, 72, 65, -106,
                  38, 121, 86, 94, 1, -110, -20, 55, 46, -15, 95, -107, -119,
                  100, 117, 103, 64, 102, 26, 46, -79, -41, 107, -43, -15, 22,
                  -120, -21, -107, 54, 33, -78, 86, 6, -16, 122, 103, 64, -106,
                  -127, 87, -70, -41, -75, -70, -2, 1, 8, -111, -118, -10, -119,
                  26, -4, -51, 108, -22, 59, -128, -84, -124, 82, 73, -70, 4,
                  36, -39, -60, 91, 2, 82, -34, 78, -77, -110, -56, -17, -27,
                  -73, -33, 98, 35, 77, -65, 4, -92, -40, 27, -106, -108, -67,
                  22, 37, 32, -96, -108, 23, -117, -24, 46, -127, -108, 70, 56,
                  -50, -115, 61, -75, -127, 109, 105, -59, 1, -108, -70, 97,
                  -98, -16, -3, 1, 25, 41, 64, 42, 59, 36, 92, 6, 82, -20, 121,
                  -85, 102, -26, 125, 112, 127, 64, -40, -66, 48, -71, 28, 35,
                  72, 9, -56, 91, -79, 116, 2, -6, 37, 82, 19, 64, -9, 39, -53,
                  -25, 127, 1, 72, 99, 90, -87, 30, -68, 78, -55, -25, 64, 74,
                  -35, -118, -20, -57, -40, -72, 55, 32, -114, 9, 42, -5, -5,
                  -98, 9, -7, 8, 4, 122, -27, 106, -30, -128, 106, 28, 58, -33,
                  29, 16, 25, 33, -79, 76, -55, -27, 68, 38, 21, 32, -112, 88,
                  -91, 21, -75, -125, 64, -110, 93, -105, -9, 6, 100, 36, 2, 84,
                  -71, -35, 17, -78, 25, 31, 20, 64, -96, 95, -7, -3, 5, 36, 27,
                  -112, -17, 14, 8, -37, 42, 0, 43, -3, -70, -68, 5, 1, -124,
                  34, -97, 1, 1, 81, -91, -103, -16, -115, -14, -54, 123, 100,
                  -65, -52, -53, -46, -79, 86, -85, 108, -68, -115, -128, 7,
                  -25, 3, -42, -92, 11, -108, 110, -27, 119, 108, -1, 62, 48,
                  -100, 123, 4, -30, -12, 16, -72, 61, 86, 72, -74, 37, -20,
                  -69, 83, 40, 88, -81, 21, 107, -104, -24, -16, -57, 93, 44,
                  127, 29, -120, -45, 35, 52, 109, -65, 73, 95, 87, 3, 5, 1, 82,
                  -65, 1, -88, -78, 77, 50, -26, -20, 94, -127, 56, 109, -128,
                  74, -69, -39, 114, -118, 47, 91, -48, 71, 79, -21, -118, -117,
                  -125, 46, 18, -74, -50, -35, 2, 113, -28, -128, 53, -3, -35,
                  -42, 20, 70, -68, 37, -100, 4, 61, 71, 56, -29, 92, -122,
                  -125, 119, -18, 24, -120, -77, -75, -112, -121, 76, -7, 67, 7,
                  -58, -62, 66, 47, 89, 107, 117, -51, 100, 123, 85, -92, -83,
                  115, -41, 64, 40, 59, -87, 83, 23, -91, 13, 62, -108, -26,
                  -73, -74, 79, -72, -103, 115, -72, -48, -8, -126, -80, -8,
                  -91, 56, -66, 3, -56, -126, 83, 32, -37, 78, 47, -88, -81, 55,
                  -75, -33, 73, 87, 58, -43, 91, 2, -122, 16, 40, -49, 95, 124,
                  2, -16, -41, 3, -39, -120, 62, 112, 21, -127, 65, 65, -110,
                  -66, -83, -42, 17, 15, 125, -113, 45, 79, -123, -6, -20, -85,
                  31, -5, -11, 64, 44, -116, 104, 44, 89, -85, -124, -99, -6, 0,
                  -56, -19, -71, 63, 108, -35, 19, 13, -65, 94, 15, -66, 28, 72,
                  -51, 69, 97, -94, -3, -68, -56, -102, 108, -88, -110, -27,
                  -37, 125, 51, -1, -43, -15, 40, 83, 92, -36, 63, 16, -42, -60,
                  -97, -91, -69, -81, 73, -109, 22, 68, -92, -87, -105, 114,
                  -57, 49, -121, 92, -44, 92, -34, 61, 16, 51, 126, 42, 72, 36,
                  76, -102, -73, -24, 37, -76, 75, 82, -23, -48, 76, -35, 26,
                  -35, 57, -112, -115, 68, 114, -73, -38, 72, -6, -86, -119,
                  -38, -70, 40, 83, 4, -6, 69, 33, 110, 66, -7, -5, -41, -79,
                  -59, 111, 2, 82, 67, 74, -66, -83, 71, 76, -37, 25, -114, 73,
                  62, -17, 2, 84, 12, 125, 83, 71, 36, -38, -34, 55, -112, -34,
                  75, 126, -57, 46, 42, -22, 90, -84, -35, 17, -110, 98, 7,
                  -112, -116, 110, 118, -114, -36, 31, -112, -73, 107, -67, 113,
                  -112, 22, -124, -110, -19, 25, -55, -74, 3, 88, -112, -10,
                  -111, -119, -120, 112, -72, 107, 32, 11, -88, -106, 2, 70,
                  -34, -100, 41, -90, 91, -49, -118, -82, 65, 3, 124, 89, -7,
                  -28, -69, -128, 76, -107, 81, -111, -111, 103, 64, 118, 90,
                  86, 26, -70, 22, -84, -105, 2, -60, -36, 93, 3, 25, 41, -45,
                  69, -98, 57, 93, -127, -84, -78, -82, -33, -46, -40, 47, -32,
                  -50, -127, 56, 118, -100, -43, 118, -7, 116, -51, -118, 1, 89,
                  -28, 64, -38, 37, -90, 82, 62, -83, -15, 46, 19, -85, 56, 111,
                  -127, -43, -67, 116, 83, 6, -27, -11, 89, 53, 40, 60, -108,
                  -128, 16, 109, 124, -41, 64, 54, 74, -34, 24, -69, 75, -6,
                  -80, -46, 3, -36, -46, -59, -86, 82, -87, 65, 5, 68, -71, 111,
                  32, 78, 23, -25, 111, 34, -104, 89, -120, 36, 64, -46, -35,
                  -62, 25, -103, 76, -82, -67, 70, -128, 122, -33, -86, -27, 56,
                  -13, -72, -98, -27, -71, -109, -77, -122, -127, 96, 56, 45,
                  118, 22, 0, 8, 75, 41, -70, -4, 117, -21, 9, -33, 7, 100, -89,
                  -8, -41, -30, -42, -38, 104, -30, -109, -90, 80, 21, 19, -44,
                  50, 117, 55, -111, -5, 117, -67, 2, -33, -106, -77, 47, 21,
                  63, 48, 74, -91, 32, -41, -93, -44, -86, 18, -2, 100, -90,
                  114, -5, -69, 7, 66, -7, -69, -121, -20, 107, 39, -39, -24,
                  -48, 19, 93, 64, -20, -62, 66, 26, -62, -51, 17, -125, -9, 10,
                  -60, -39, 90, 46, -98, -106, -6, 73, 39, -37, -106, 114, 114,
                  123, -103, -101, 98, 91, 125, -47, -81, 108, 4, -5, 123, 64,
                  28, 62, 36, 52, 103, -25, 26, -59, 104, -57, -122, 18, 91,
                  -75, 25, 59, 35, -100, -83, 0, -31, 123, -49, 71, -78, 96,
                  -94, -31, -56, -59, 8, 64, -69, 87, 36, -71, 35, 29, 120, -13,
                  25, -121, -64, 77, 72, -71, 103, 32, 67, 79, 105, -44, 56, 1,
                  35, -124, -91, -42, -78, -12, 99, 40, -63, -92, 79, 104, 62,
                  126, 8, 32, 51, 5, -77, -107, -63, -43, -96, -55, 26, 47, -93,
                  -4, 124, 43, 118, 72, 14, 113, 33, 2, 82, -17, -21, 95, 106,
                  -11, 45, 64, 106, 40, 76, -57, 126, -90, -13, 31, 4, -123,
                  -103, -17, -102, 4, 74, -26, -13, 119, -68, 102, -20, 91,
                  -128, -68, -6, -39, -38, 109, 7, 80, -9, -76, -20, 41, 88, 57,
                  -26, -59, 34, -12, 77, -18, -27, 123, -128, -92, -5, -111,
                  -100, -79, 70, -14, 83, 127, -89, -23, -78, 27, 63, 37, -31,
                  -14, -127, -128, -8, -26, 36, -49, 18, 51, -10, 11, -92, -12,
                  39, 34, 32, -58, -29, 0, -71, -18, -23, 99, 7, 122, 38, 64,
                  32, -52, 122, 0, 69, -124, -76, -51, -61, 0, 57, 35, -108,
                  -98, 63, -59, 67, -56, 14, -73, -110, -79, -108, -19, -55, 88,
                  55, -119, 75, -74, 15, 3, 100, 25, 101, -107, 31, 86, -92, 3,
                  103, 71, -9, -77, 61, 111, -50, 17, -72, -92, -71, 123, 24,
                  32, 35, -47, -53, 122, 46, -73, 2, -96, -62, -47, -3, 60, -83,
                  -91, -70, 86, 110, 15, -70, -5, -56, 110, 92, 15, -1, -112,
                  35, -113, 2, -119, -77, 67, 117, -57, 34, -86, 52, -98, -35,
                  63, 105, -20, -8, -7, -103, 73, -81, -45, 78, 67, 63, -91,
                  -113, 89, 89, -44, -117, -43, 39, -113, 4, 100, -95, 121, 90,
                  -106, -71, 31, 108, -105, 53, -96, 78, -58, 43, -125, -67, 74,
                  -63, -5, 30, -17, -5, 109, -17, 67, -28, 35, 95, -86, 93, -77,
                  19, -84, 112, 117, 45, 100, -91, 8, -94, 78, 30, 11, -120,
                  -77, 85, -30, 96, -112, 115, -36, -93, 24, 123, -84, 94, -121,
                  -76, 111, 123, 35, -30, -9, -67, 52, 114, -91, 2, 112, 93, 62,
                  -100, -68, -118, 8, 34, -111, -1, -66, -105, 109, 126, 31,
                  -112, -115, -51, -114, 95, -67, 92, 75, 12, 108, -5, -25, -39,
                  121, 64, 32, -100, 79, 88, -17, 101, -47, -32, -48, -62, -43,
                  86, -63, 7, 1, -62, 7, -72, 63, 103, -83, 101, -45, 124, 31,
                  -17, 50, 32, -24, -19, -15, -128, 88, 39, 113, 55, 97, 47, 75,
                  67, -66, -110, -67, -27, 88, 71, -104, 123, 56, 32, 27, 9,
                  -15, 108, -3, -106, 64, 77, -13, 113, -38, -127, 57, 86, 60,
                  -21, -31, -128, 44, 97, -62, 74, 12, -124, 59, -29, 33, 68,
                  105, 90, 101, 122, -38, -22, -31, -128, 36, 111, -59, -103,
                  105, -20, 44, -45, 101, -112, 109, 100, 80, 49, 58, 63, 26,
                  -112, 69, -78, 35, 113, 21, 64, 96, -77, 87, 14, -92, -92,
                  -111, -117, -107, -15, -61, 25, -69, -94, -90, -103, 45, -51,
                  16, 13, 76, -92, -92, -83, 73, -12, -51, 7, -12, 90, -55,
                  -104, -69, -82, 71, -127, -128, -12, 124, -115, -38, -44,
                  -101, 63, 30, 16, 35, 125, -23, -95, -31, 74, 99, 29, -89,
                  110, -21, 2, -128, -15, 120, 64, 86, -111, -107, -47, 96, -51,
                  68, -20, 8, -23, -99, 78, -128, -76, 127, 60, 32, 78, 47, 59,
                  -49, -73, 33, 122, 68, 91, 117, 117, 9, 32, -9, -82, -33, 6,
                  -2, -29, 90, 74, -104, 46, 74, 109, -6, 88, 96, -67, -40, 32,
                  -6, 70, 28, -33, 9, -124, 29, 82, -100, -40, -55, -124, 99,
                  -57, 83, 35, -79, -31, 60, 38, 16, 3, 66, 36, 37, -57, -108,
                  78, 84, -105, 32, 123, -26, 60, 38, -112, -119, -126, 8, 70,
                  -72, 121, 100, -106, 34, 67, -12, 13, 13, -103, 127, 6, 72,
                  13, 34, 69, -41, 48, 72, 15, 108, 53, 8, -18, 79, 30, 19, 72,
                  15, 99, -35, -39, -9, 4, 8, -92, -77, 83, 46, 117, 61, 92,
                  -122, -120, -109, -111, 115, -40, 69, -55, 54, 31, -54, 24,
                  -7, 71, -107, 8, -69, -7, 51, 107, -56, 22, -72, 13, 59, -122,
                  110, -2, -112, 64, 120, -126, 89, 108, -97, -79, -41, -26, 16,
                  -81, -34, -40, 75, 8, -42, 30, 17, -120, 99, 123, 17, 27, -72,
                  -111, -100, -91, 79, -90, -94, 0, -65, -45, 74, -66, 17, -56,
                  -94, -119, 19, -105, 43, -77, 87, -76, -72, -112, -64, 47,
                  111, -111, -3, 83, -111, -99, -121, -34, -100, -107, 29, 54,
                  -7, 9, -53, 94, -21, 49, -127, -80, 119, -15, -39, 73, 24, 60,
                  39, 111, 101, 66, -51, -11, -125, 2, 25, -103, 8, -89, 47,
                  -120, -31, 5, -86, 88, -56, 112, 30, 20, -56, -126, -75, 51,
                  -123, -55, 59, -85, 91, -40, 85, -65, 51, -116, 124, 47, -112,
                  -28, 69, -63, -48, 103, -121, 127, 27, -40, -35, 58, 15, 11,
                  36, -21, 42, 103, -127, -16, -1, 2, 8, -92, -36, -92, -9, 127,
                  1, 4, -14, 108, 23, -49, -1, 1, -112, 96, -67, 14, 72, -80,
                  120, 92, 32, -67, 28, -56, -90, 75, -120, -80, 121, 92, 32,
                  -37, -4, -68, -102, 87, 19, 21, -17, 43, 121, 64, 32, -55, 33,
                  2, 76, 36, 82, -11, 24, -111, -57, 3, -110, -97, 78, 69, 92,
                  34, 45, 30, 25, 72, 113, 92, 124, 126, -108, -12, -125, 2,
                  113, -22, -59, 25, -97, -93, -121, 6, 98, 92, 15, 117, 18,
                  -99, -121, 6, 50, 81, -14, -109, -43, 47, -113, 13, -60, 57,
                  102, 30, -8, -85, -114, -102, -5, 107, 64, 28, -82, 56, 119,
                  -14, -79, -127, -116, -11, 8, 35, -28, -117, -50, -93, 3, 97,
                  47, 120, 87, 20, 107, -5, 127, 0, -28, -49, 92, -1, 19, 96, 0,
                  -125, -71, 26, 66, 10, 101, 110, 100, 115, 116, 114, 101, 97,
                  109, 10, 101, 110, 100, 111, 98, 106, 10, 52, 32, 48, 32, 111,
                  98, 106, 10, 60, 60, 47, 84, 121, 112, 101, 47, 88, 79, 98,
                  106, 101, 99, 116, 47, 83, 117, 98, 116, 121, 112, 101, 47,
                  73, 109, 97, 103, 101, 47, 87, 105, 100, 116, 104, 32, 49, 50,
                  53, 47, 72, 101, 105, 103, 104, 116, 32, 49, 50, 53, 47, 76,
                  101, 110, 103, 116, 104, 32, 49, 48, 54, 51, 47, 67, 111, 108,
                  111, 114, 83, 112, 97, 99, 101, 47, 68, 101, 118, 105, 99,
                  101, 71, 114, 97, 121, 47, 66, 105, 116, 115, 80, 101, 114,
                  67, 111, 109, 112, 111, 110, 101, 110, 116, 32, 49, 47, 70,
                  105, 108, 116, 101, 114, 47, 67, 67, 73, 84, 84, 70, 97, 120,
                  68, 101, 99, 111, 100, 101, 47, 68, 101, 99, 111, 100, 101,
                  80, 97, 114, 109, 115, 60, 60, 47, 75, 32, 45, 49, 47, 66,
                  108, 97, 99, 107, 73, 115, 49, 32, 116, 114, 117, 101, 47, 67,
                  111, 108, 117, 109, 110, 115, 32, 49, 50, 53, 47, 82, 111,
                  119, 115, 32, 49, 50, 53, 62, 62, 62, 62, 115, 116, 114, 101,
                  97, 109, 10, 38, -96, 120, 45, 127, -1, -56, -102, 16, -106,
                  119, 59, -110, -77, -71, 110, 123, 61, -105, 100, -84, -106,
                  -97, -1, -1, -1, 46, 18, 123, -124, 48, -57, 8, 32, -16, -114,
                  -16, -113, 112, -27, -62, 127, -1, -1, -1, -4, -3, -121, 10,
                  91, -119, 115, 24, -122, 25, 124, 50, -33, 63, 127, -1, -1,
                  -1, -1, -123, 36, -13, 60, -69, -99, -49, -59, -72, 65, -105,
                  103, 127, -1, -1, -1, -1, -1, -4, 56, 65, 75, -112, 71, 120,
                  -119, 126, 20, 113, -1, -1, -1, -1, -1, -57, 8, 35, -39, -26,
                  22, 25, -36, -109, -116, 35, -39, 110, 17, 127, -113, -1, -1,
                  -1, -1, -15, -16, -126, 47, -105, -16, -126, 47, -13, -66,
                  119, -31, 29, -1, 59, -57, -1, -1, -1, -1, -1, -8, -120, -16,
                  -61, 8, 33, -116, 56, 97, 4, 16, -15, 31, -1, -1, -56, -121,
                  63, 4, 16, 80, -124, -69, 16, -55, 56, 69, -63, 114, -7, 124,
                  -66, 92, 63, -1, -1, -1, 12, 34, 45, -28, 87, 33, 44, -73, 60,
                  -62, 8, 50, -30, -101, -31, -120, 127, -1, -1, -2, 17, 126,
                  91, -116, -10, 25, 115, 8, 32, -62, 12, -66, 17, -36, -18, 28,
                  50, -7, -68, 47, -1, -1, -1, -1, -26, 121, 118, 108, 88, 70,
                  -40, -60, -18, 34, 25, -101, 12, -18, 63, -1, -1, -8, -62, 10,
                  69, -72, 103, -71, 112, 32, -66, 108, 88, 70, -40, 68, -97,
                  -1, -1, -1, -61, -110, 114, 18, -50, -31, 23, -61, 59, -106,
                  -25, -80, -71, 111, 12, -18, 17, 56, 127, -1, -1, -1, -7, 10,
                  -30, 119, -53, 112, -61, 12, 44, 67, 16, -126, -123, -105,
                  -31, -105, -62, -1, -1, -1, -1, -50, -31, 5, -122, 111, -99,
                  -61, 16, -62, 12, -18, 17, 126, 24, 65, 4, 17, 124, 35, -33,
                  -1, -1, -1, -1, -1, 14, 24, -110, -80, -115, -80, -117, 121,
                  -73, 14, 56, -121, -123, -1, -1, -1, -2, 16, -122, 17, 113,
                  77, -27, -62, 6, 24, -116, 78, 115, -68, 47, -1, -1, -2, 109,
                  -62, -99, -62, 8, 75, 112, -125, 12, -71, 27, 101, -14, -7,
                  -20, 32, -126, 59, -49, 3, -1, -1, -1, -1, -16, -30, 28, 97,
                  29, -50, -30, 69, -80, -53, -27, -40, 67, 24, -122, 92, 82,
                  -31, 63, -1, -1, -8, 83, -71, -26, 16, 65, 102, 108, -65, 8,
                  44, 57, -50, 91, -99, -61, 47, -1, -1, -1, -1, -4, 48, -27,
                  -15, -60, -71, 23, -61, 59, -122, 95, 12, 40, -124, 25, -36,
                  67, 11, -1, -1, -1, -8, 71, 112, -51, -31, 4, 116, 97, 8, 65,
                  7, 37, -57, 114, 17, -50, -31, 5, -1, -1, -1, -8, 65, 97, 23,
                  121, -68, -66, 22, 93, -99, -62, 8, -25, -98, -53, -80, -114,
                  -31, 4, 123, -1, -1, -1, -1, -1, 16, -60, 68, 50, -6, 33,
                  -124, 92, 33, 124, 32, -60, 48, -1, -1, -2, 66, -36, -71, 23,
                  102, -56, -72, -91, -39, 114, 19, 55, 19, -39, -36, -108, -1,
                  -1, -1, -4, 62, 119, -61, -100, -31, 7, -99, -26, 120, 115,
                  -60, 51, -68, 47, -1, -1, -1, -4, 56, -25, 112, -53, -65,
                  -116, 32, -126, 19, -68, -65, 24, 69, -65, -1, -1, -1, -7, 17,
                  -61, 17, 24, 70, -4, 40, -105, -61, 59, -98, -62, 8, 33, 16,
                  -126, 11, -1, -1, -1, -58, 93, -105, -53, -112, 98, 74, -49,
                  97, 120, 71, 120, -101, -49, 97, -1, -1, -1, -1, -28, 71, -62,
                  8, 32, -60, -117, 100, -100, 32, -93, 25, 113, 66, -121, -1,
                  -1, -1, -49, 48, -126, 47, -53, 115, -52, -73, 8, 32, -57,
                  -105, -57, 121, 118, 108, 39, -1, -1, -1, -7, 118, 16, 65,
                  -106, -29, 46, -31, 4, 25, -68, -34, 93, -124, 119, 8, 32,
                  -115, -15, 15, -1, -1, -1, -1, -30, 69, 114, 86, 123, -60, 48,
                  -120, -67, 8, 71, 12, -69, 54, 11, -1, -1, -1, 34, 57, 118,
                  123, -124, 16, 80, -50, -31, 27, 112, -31, -105, -49, 20, 44,
                  47, -1, -1, -1, -1, 10, 73, -62, 47, -113, 12, -13, 46, 65,
                  30, -56, -82, 123, -124, 119, -122, 91, -1, -1, -1, -1, -8,
                  102, -7, -33, -27, -40, -27, -13, -62, -122, 119, 63, 4, 95,
                  14, 24, 69, -8, 65, 127, -1, -1, -1, -1, -16, -61, 12, 34,
                  -20, 56, -105, 97, 9, 39, 12, 66, 8, 32, -126, -121, -1, -1,
                  -1, -31, 73, 60, -66, 34, 95, -53, -118, 123, 12, -10, 16, 71,
                  -78, 78, 16, 88, 65, 127, -1, -1, -1, -14, -4, -10, 22, 93,
                  -105, 113, 19, -16, 98, 16, 65, 7, 59, -60, 60, 63, -1, -1,
                  -1, -1, 16, -53, -20, 33, 51, 114, 86, 93, -99, -62, 8, 73,
                  56, 65, 30, -1, -1, -1, -4, 50, -7, -26, 33, -106, -25, -80,
                  -126, 45, -61, -124, 16, -122, 102, -61, 8, -72, 17, -1, -1,
                  -1, -62, -61, -101, -62, 28, -4, 123, -60, -109, -105, 51,
                  -68, 44, -17, -1, -1, -1, -2, 24, 97, 23, 97, 30, -50, -31,
                  -29, 18, -18, 25, 22, -62, 12, 71, -1, -1, -1, 33, -121, 11,
                  -121, -116, -117, -95, -36, 48, -49, 103, 121, 62, 95, 46, 19,
                  -1, -1, -1, -30, 69, -77, -66, 66, 57, -36, 50, -28, 16, 65,
                  6, 25, -34, 37, -54, 63, -1, -1, -1, -28, 77, 33, 8, 103, -80,
                  -93, 59, -30, 93, -58, 74, -50, -7, -17, -1, -1, -1, -7, 112,
                  -112, -53, -26, -62, 6, 74, -57, 57, -61, 47, -49, 49, -61,
                  15, -1, -1, -1, -4, -3, -124, 25, -20, -73, -124, 119, 12,
                  114, -20, 32, -93, 55, -120, -1, -1, -1, -1, -1, -105, -28,
                  -84, 68, -13, 60, -62, -62, 44, -25, -29, -33, -1, -1, -1, -1,
                  -61, 59, -119, 46, 45, -62, 46, -16, -30, 95, -62, 10, 119,
                  -1, -1, -1, -1, -15, -31, 6, 123, 60, -61, -120, 99, 46, -53,
                  -27, -15, 46, -53, -111, 118, 23, -1, -1, -1, -4, 120, 70,
                  -15, -111, 108, -18, 33, 14, 93, -105, -61, -98, 7, -1, -1,
                  -1, -120, -120, -120, -120, -120, -113, -1, -1, 0, 16, 1, 10,
                  101, 110, 100, 115, 116, 114, 101, 97, 109, 10, 101, 110, 100,
                  111, 98, 106, 10, 53, 32, 48, 32, 111, 98, 106, 10, 60, 60,
                  47, 76, 101, 110, 103, 116, 104, 32, 50, 48, 57, 52, 47, 70,
                  105, 108, 116, 101, 114, 47, 70, 108, 97, 116, 101, 68, 101,
                  99, 111, 100, 101, 62, 62, 115, 116, 114, 101, 97, 109, 10,
                  120, -100, -51, 90, 91, 115, -38, 62, 22, 127, -25, 83, -24,
                  105, -89, -99, 93, 43, -42, -51, -105, -66, 57, -63, 33, 110,
                  -63, -92, -32, -90, -37, -103, -68, -72, -63, 77, -40, 66, 72,
                  -127, -52, 127, -5, -19, -9, -56, 96, -80, -114, 100, 82, 118,
                  102, 103, -74, -99, -108, -55, 57, 58, -6, -99, -69, -114, 68,
                  127, -11, 126, 17, -58, 21, -15, -31, -81, -2, 20, 62, 9,
                  -103, 79, 30, -106, -28, 98, -66, 124, 100, -92, -65, 34, -97,
                  123, -97, 123, -65, 122, -105, 69, 15, -24, -111, -32, -92,
                  -104, -11, 124, -30, 41, -90, -88, 12, -11, 47, 105, 81, 47,
                  -48, 63, -100, 124, 4, -34, -64, -6, -7, 92, -117, -17, 64, 8,
                  -117, 99, -86, 24, -119, -104, -92, 74, -112, 98, -39, -51,
                  -16, 73, -15, -48, -69, -72, 6, 14, -96, -2, -24, -67, 27,
                  -116, -17, -46, 73, 62, 74, -13, -126, -116, -81, -55, -41,
                  116, 90, -112, -53, 52, 31, 36, -61, -9, -59, -65, 14, -69,
                  -120, 88, 81, 37, -15, 46, 30, -117, 3, -22, 11, 88, 1, 26,
                  31, 0, 3, 70, 89, 72, 34, -33, -89, -52, -44, 4, 51, -22, 61,
                  -34, -11, -45, -37, 100, 82, 52, -8, 55, 105, 50, 44, 110,
                  -56, -33, -56, 117, 50, -54, -122, -33, 64, -97, -31, 117, 50,
                  73, -37, -70, 72, 33, 104, 20, -31, 125, 60, 30, 114, 26, 50,
                  83, 23, 46, 21, 101, 17, 9, 35, 69, 67, 67, 23, -117, -79,
                  -45, 37, -69, 29, -116, -46, 9, -96, 79, -89, -97, 70, 55,
                  -122, 3, 100, 76, -93, 16, 11, 120, -52, -105, 52, -120, 17,
                  40, 7, 59, 3, 18, -122, -116, 10, 19, 20, 51, 118, -96, 9, -3,
                  72, -81, -56, -27, 106, 83, -111, -55, -86, -100, -111, 79,
                  -85, -59, -49, 114, 91, 122, -36, 55, 20, 8, -63, -22, 24, 11,
                  123, 76, -127, -43, 114, -89, 0, -28, -52, 47, 18, 68, -38,
                  48, 45, 19, -124, 84, 17, 25, 51, -22, -125, -95, 1, -89,
                  -112, -120, -5, 12, -12, 119, 25, -40, 74, 31, 115, 89, -77,
                  123, -77, 87, -99, -100, 26, -83, 69, -48, 96, 39, -45, -13,
                  -1, -14, -121, -122, -118, -4, 5, 31, -54, -121, -44, 37, -8,
                  115, 50, -24, -59, 52, 16, 80, -84, 82, 127, 44, 119, -65, 41,
                  -88, 32, -63, -56, -94, 55, -3, 83, -7, -67, -60, -78, -89,
                  32, 93, 68, 116, -34, 14, -90, -52, 97, -113, -67, 78, 103,
                  -19, 97, -38, -47, -34, -63, 106, 31, 74, -57, 61, -120, 67,
                  93, 66, 16, -2, -117, 107, 78, 24, 108, 88, 119, -120, -37,
                  -92, -56, 116, 121, 102, -7, -11, 120, 50, -126, 95, -58, -71,
                  -50, 76, -56, -128, -42, 14, 34, -16, -87, 100, -112, 126,
                  -127, 78, -92, 86, -42, 91, -116, 67, 3, -118, 119, -69, -105,
                  -13, 25, -103, -68, -66, 84, -43, -26, -125, 81, -26, -96,
                  -82, -108, 88, -50, 83, -14, -48, 113, 76, 5, -92, 12, 116,
                  -123, -38, 10, 88, 12, -92, 0, 55, 80, 21, 115, 44, -10, -108,
                  11, 113, -17, -76, 80, -22, 120, -76, 27, 29, -94, 35, -68,
                  -68, 92, 86, -56, 82, 26, 6, 120, -67, -57, 3, -35, -73, 93,
                  -80, -95, 79, 35, -34, 90, -81, -125, 21, -17, 123, -7, -105,
                  73, 114, 73, 46, -109, 60, -99, 124, 76, -45, -18, 40, 89, 58,
                  91, 12, -92, -12, -92, 122, 36, -7, -118, 126, -64, -121, 66,
                  -52, 45, -59, -123, -22, 80, -68, 9, -124, 67, 113, -35, 111,
                  47, 38, 3, -50, 125, -3, -121, 113, 97, -85, -66, -9, 106, 32,
                  -88, 20, 14, 111, 31, -24, 72, -15, 65, -11, 60, -85, -42,
                  -90, -65, 33, -53, 67, 44, -31, 9, 78, 21, 63, -27, 111, 27,
                  25, 51, 16, -12, -88, 92, 84, 109, 92, 22, -5, 84, 88, -21,
                  -31, 16, -91, -50, -12, 106, 66, 98, -31, 90, 12, 59, 86,
                  -108, -12, -53, 45, -54, 50, -65, 94, -114, -47, -91, -96,
                  -66, -45, -20, 38, 90, 22, -68, -59, 64, -16, 76, 121, 62,
                  -121, -45, -117, -101, -123, 21, 115, 26, -37, -24, 65, 71,
                  53, -17, -93, 10, -89, 27, 115, 4, -69, 33, 35, -28, -28, -47,
                  52, 25, 6, 5, 93, 88, -58, 106, -113, 69, 111, -44, -107,
                  -123, -119, -24, 8, 84, -60, -28, -37, 122, 67, 73, 64, 70,
                  -85, -25, -19, -45, -122, 8, -16, -3, -17, 77, 91, 15, 30, 64,
                  47, -73, 20, -119, 35, 61, 82, -99, 8, 60, 86, 4, -45, -111,
                  34, 87, -27, 122, 6, 53, -118, 74, 52, -96, 18, -21, -18, 9,
                  -16, -6, -55, 10, -59, -56, -104, -114, -112, -21, -22, 29,
                  79, -10, -43, -21, 7, -86, -83, -126, 18, -111, 67, 5, -104,
                  55, -44, -87, -90, 42, -31, -112, -117, 28, -111, 63, -48,
                  -15, 41, -14, -76, 122, -82, -80, -11, 42, -44, -117, -111,
                  -116, 39, -71, -98, 97, 79, 36, -128, -115, -115, 25, 8, 60,
                  -114, 66, 41, 35, -26, 7, -46, -120, 58, 7, -87, -64, -126,
                  87, 62, -11, 79, -122, -35, -126, -73, 24, 8, -2, 110, -66,
                  -103, 111, -19, -56, -117, -70, 57, 35, 116, 40, -119, -45,
                  -51, -39, 66, -73, 24, -72, -36, 93, -57, 39, -74, -7, 68,
                  -92, 121, 76, -91, -21, -8, 60, -48, 17, 94, -65, 122, 41,
                  -41, -37, 101, -11, -68, 53, -20, 13, 100, -35, -44, 77, 41,
                  15, -90, -10, -45, 77, -35, 70, -57, 12, 4, -97, -46, -100,
                  22, -44, 108, -21, -127, 30, -55, 49, 52, -17, 58, 6, -101,
                  112, 90, -48, 22, -61, 25, 103, 71, 99, 103, 117, -127, 97,
                  -45, -39, 27, 69, 110, -31, 91, 12, -69, -79, 95, 87, -33, 29,
                  -99, 29, 10, -36, -126, -121, 68, -24, -16, -4, 46, -68, -48,
                  -122, -103, -21, 28, 63, -48, 113, -40, 87, 15, -37, -43, -6,
                  -30, -53, -77, 78, 117, -104, -96, -18, -33, -11, -57, 95,
                  -17, -33, 27, -98, 96, 44, -92, 60, -64, 123, -64, 37, -115,
                  119, -72, -94, 9, -74, -83, 12, 102, 96, 109, -42, 116, 74,
                  63, 81, 50, 120, 90, 109, -98, -52, -94, -113, 104, 36, 45,
                  21, 84, -44, 113, -54, 54, 49, -73, 52, -80, 24, 72, -125, 98,
                  -114, -90, 72, 17, -63, 1, 107, 9, 120, -100, -69, -89, -117,
                  38, -40, 22, -80, -59, -64, 89, -16, -127, -57, -28, 118, 100,
                  100, 64, 4, -125, 77, 108, 65, -21, 94, 115, 42, 5, 124, 0,
                  114, 100, 64, 67, -58, 83, -51, 106, -75, -76, 70, 80, -16,
                  -85, 14, -72, 33, 82, -113, 52, 39, -61, 109, 1, 35, 58, 62,
                  -31, 35, 35, -55, -64, -40, 72, 96, 76, -72, 44, -71, 49,
                  -101, 56, 98, 76, 76, -57, 9, 86, -2, 54, -93, 27, 70, 117,
                  116, 17, 106, 116, 58, -72, 24, 20, -45, 113, 78, -67, 86,
                  -101, 89, -7, -37, 12, 45, -85, 67, 107, -30, 10, -39, -114,
                  -20, -1, -24, 29, -32, 79, -17, -38, -48, -25, -126, -26,
                  -114, 43, -95, -21, -87, -8, -100, -69, -6, 94, -30, 112, -49,
                  62, 107, 7, 83, -90, 117, -33, -81, 117, 58, -13, -66, -33,
                  -74, -93, -67, -125, -5, -82, -82, 32, 33, -72, -93, -127, 30,
                  -23, 120, 60, -68, -55, -46, 107, 114, 53, 30, -35, 14, -109,
                  44, 111, -57, 56, -82, -17, -97, 72, -48, 11, -69, -18, -97,
                  2, 110, 74, 48, -63, -40, 10, 88, 12, -100, 94, -43, 102, 75,
                  30, -98, -26, -43, 15, -14, -80, 90, -66, 44, -54, -7, -77,
                  121, -114, -63, 97, -19, -48, 35, -20, 26, -41, 118, -10, 6,
                  -36, 57, 41, 30, -23, 120, 88, -3, 54, -70, 45, -58, -93, -87,
                  49, 60, 4, -75, 7, 76, -111, -6, 8, 59, -23, 1, 88, 47, 93,
                  14, 104, -24, 120, 116, 40, -41, -28, 5, 25, 45, 2, -91, 7,
                  97, 83, -28, -83, -50, -87, -32, 6, 43, 92, -79, 63, -48, -15,
                  116, -100, 76, 11, 114, -109, 77, -117, -15, -28, -101, 126,
                  101, -51, -122, -61, 60, -99, 26, 46, 96, 112, 109, 15, 99,
                  -68, -123, -57, 96, -120, -19, -72, -91, -20, -115, -75, 116,
                  -79, 24, -8, -3, 3, 38, 117, -61, 5, 74, -44, 46, 64, -56,
                  -68, -53, -5, 123, 91, 69, -13, 84, -39, 69, -57, 15, 1, 105,
                  -98, 78, -110, 33, 25, -91, -3, -20, 10, 62, -9, -18, 48, 124,
                  0, 39, 7, -113, -16, 22, -32, -125, -88, -29, -106, -38, -104,
                  106, -23, 98, 49, -50, 72, 5, -124, -2, 86, 46, -64, -52, -61,
                  92, -7, 127, -96, -29, 62, 48, -52, 114, -19, -128, -117, -31,
                  88, -69, 33, -3, 103, 50, -54, -14, -61, -93, -34, 113, 19,
                  94, -69, -62, -36, -59, 99, 34, 124, -61, 21, -106, 58, 22,
                  -61, -43, 21, -82, 22, -13, -25, -7, 67, -71, -72, 24, -82,
                  -32, 95, -110, -2, -69, 92, -50, -97, -53, -19, 124, 101, 118,
                  8, -72, -48, -7, -95, -83, 20, -116, -38, -18, 43, -43, -34,
                  21, -66, -13, 21, -31, 64, -58, -59, 50, 25, -33, 101, 83,
                  -16, 7, 120, -89, -97, 37, -125, 124, 60, 45, -78, 43, -77,
                  86, -92, 110, 20, -26, 6, 30, -45, 15, 57, 39, 125, -125, -11,
                  -64, 116, -92, -56, 22, 60, 99, 126, 7, 17, -24, 90, -60, -80,
                  -14, 100, -99, -56, -88, -114, -104, 101, -3, -111, -114, 80,
                  -77, -4, 46, 5, -125, 7, 117, 74, -112, -28, 46, -55, -122,
                  -55, -27, 48, -59, -67, 34, -62, 59, -20, 90, -59, -119, -101,
                  -98, -124, 46, -85, 28, 21, 123, -92, -29, -52, -48, -33, 69,
                  37, -3, -69, -20, -54, 64, 15, -91, -98, -7, -112, -108, -89,
                  -30, -82, 1, 108, -25, 100, 25, 50, 26, -69, 106, -12, -56,
                  64, -16, -61, -7, -53, 124, 70, 110, -41, -85, 31, -13, 69,
                  -11, 15, 115, -44, -82, 95, 47, -112, 100, -5, -78, -119, 49,
                  -12, 87, 95, 78, -16, 3, -61, -33, 125, 23, -76, -8, 89, 66,
                  41, 84, -28, 22, 46, 22, 47, 79, -27, -74, -36, -64, 77, 103,
                  90, -83, 95, -105, -9, -17, -15, 69, -37, -113, -80, 124, -99,
                  -125, -89, 74, 65, 15, -128, -66, -93, 91, 28, -23, -56, 9,
                  95, -57, -109, 79, -92, 63, -50, -51, 8, 48, 61, -43, 32, 25,
                  79, 5, -83, 97, -12, -65, -104, 9, -1, 112, 94, -125, 126, 40,
                  100, 51, 39, -23, 72, -56, -24, -100, 121, 111, 47, 113, -104,
                  -43, -50, -38, -63, -108, 57, -50, -116, 59, -99, -50, -101,
                  25, 13, 59, -38, 59, -72, -25, 61, -55, -22, -105, -68, 2,
                  125, 55, 115, 44, 15, 20, 110, -72, -91, 112, -34, 37, 85,
                  -97, -127, 89, -18, -110, -85, -63, -12, -77, 97, -28, 72,
                  -109, 35, 29, 15, 85, 79, -85, -41, -59, -116, 20, -27, -49,
                  -118, 36, -77, -27, 124, -77, 65, -83, -101, -63, 112, 7, -29,
                  5, -38, -64, -117, 101, -57, 116, -63, -32, 54, 43, 67, -104,
                  9, -71, 94, 80, -21, 127, -72, -128, 82, -121, -38, 113, -84,
                  95, -69, -114, -53, 59, 25, -8, -115, -2, -53, -80, -56, -56,
                  93, 86, -24, 83, -112, 100, -7, 71, 74, -18, -33, -115, -18,
                  -78, -5, -9, -100, -24, 63, -36, 122, -52, 21, 74, -22, -121,
                  14, -76, -93, -57, -108, -20, -102, 83, 119, -90, 8, 24, -77,
                  57, 51, 77, -31, -35, -90, 28, -105, 119, 50, -16, -71, 85,
                  -82, -53, -121, 106, 91, 46, 87, 11, 34, 32, 88, -53, 71, -14,
                  119, -110, 125, 127, 125, -127, 14, 86, 61, -125, -62, -66,
                  38, 21, -27, 119, 56, 61, -100, -106, 73, 30, 82, 30, 99, 0,
                  -113, 3, 89, -124, 111, 84, -10, -25, 38, -13, -11, 127, 97,
                  -128, -60, 19, -84, -2, 111, 7, -70, 68, -72, 102, -20, 127,
                  -41, 9, -50, 96, 85, -53, -34, 70, 0, 78, -113, -64, 8, -99,
                  -59, 112, -66, 8, -111, -23, -4, 17, 38, -123, -41, 117, 101,
                  -66, 11, -20, 80, 77, 89, 47, 48, -18, 18, -1, 1, -118, -125,
                  -32, 112, 10, 101, 110, 100, 115, 116, 114, 101, 97, 109, 10,
                  101, 110, 100, 111, 98, 106, 10, 55, 32, 48, 32, 111, 98, 106,
                  10, 60, 60, 47, 84, 121, 112, 101, 47, 80, 97, 103, 101, 47,
                  77, 101, 100, 105, 97, 66, 111, 120, 91, 48, 32, 48, 32, 53,
                  57, 53, 32, 56, 52, 50, 93, 47, 82, 101, 115, 111, 117, 114,
                  99, 101, 115, 60, 60, 47, 70, 111, 110, 116, 60, 60, 47, 70,
                  49, 32, 49, 32, 48, 32, 82, 47, 70, 50, 32, 51, 32, 48, 32,
                  82, 62, 62, 47, 88, 79, 98, 106, 101, 99, 116, 60, 60, 47,
                  105, 109, 103, 48, 32, 50, 32, 48, 32, 82, 47, 105, 109, 103,
                  49, 32, 52, 32, 48, 32, 82, 62, 62, 62, 62, 47, 67, 111, 110,
                  116, 101, 110, 116, 115, 32, 53, 32, 48, 32, 82, 47, 80, 97,
                  114, 101, 110, 116, 32, 54, 32, 48, 32, 82, 62, 62, 10, 101,
                  110, 100, 111, 98, 106, 10, 49, 32, 48, 32, 111, 98, 106, 10,
                  60, 60, 47, 84, 121, 112, 101, 47, 70, 111, 110, 116, 47, 83,
                  117, 98, 116, 121, 112, 101, 47, 84, 121, 112, 101, 49, 47,
                  66, 97, 115, 101, 70, 111, 110, 116, 47, 72, 101, 108, 118,
                  101, 116, 105, 99, 97, 47, 69, 110, 99, 111, 100, 105, 110,
                  103, 47, 87, 105, 110, 65, 110, 115, 105, 69, 110, 99, 111,
                  100, 105, 110, 103, 62, 62, 10, 101, 110, 100, 111, 98, 106,
                  10, 51, 32, 48, 32, 111, 98, 106, 10, 60, 60, 47, 84, 121,
                  112, 101, 47, 70, 111, 110, 116, 47, 83, 117, 98, 116, 121,
                  112, 101, 47, 84, 121, 112, 101, 49, 47, 66, 97, 115, 101, 70,
                  111, 110, 116, 47, 72, 101, 108, 118, 101, 116, 105, 99, 97,
                  45, 66, 111, 108, 100, 47, 69, 110, 99, 111, 100, 105, 110,
                  103, 47, 87, 105, 110, 65, 110, 115, 105, 69, 110, 99, 111,
                  100, 105, 110, 103, 62, 62, 10, 101, 110, 100, 111, 98, 106,
                  10, 54, 32, 48, 32, 111, 98, 106, 10, 60, 60, 47, 84, 121,
                  112, 101, 47, 80, 97, 103, 101, 115, 47, 67, 111, 117, 110,
                  116, 32, 49, 47, 75, 105, 100, 115, 91, 55, 32, 48, 32, 82,
                  93, 62, 62, 10, 101, 110, 100, 111, 98, 106, 10, 56, 32, 48,
                  32, 111, 98, 106, 10, 60, 60, 47, 84, 121, 112, 101, 47, 67,
                  97, 116, 97, 108, 111, 103, 47, 80, 97, 103, 101, 115, 32, 54,
                  32, 48, 32, 82, 62, 62, 10, 101, 110, 100, 111, 98, 106, 10,
                  57, 32, 48, 32, 111, 98, 106, 10, 60, 60, 47, 80, 114, 111,
                  100, 117, 99, 101, 114, 40, 105, 84, 101, 120, 116, 83, 104,
                  97, 114, 112, -110, 32, 53, 46, 53, 46, 49, 51, 46, 50, 32,
                  -87, 50, 48, 48, 48, 45, 50, 48, 50, 48, 32, 105, 84, 101,
                  120, 116, 32, 71, 114, 111, 117, 112, 32, 78, 86, 32, 92, 40,
                  65, 71, 80, 76, 45, 118, 101, 114, 115, 105, 111, 110, 92, 41,
                  41, 47, 67, 114, 101, 97, 116, 105, 111, 110, 68, 97, 116,
                  101, 40, 68, 58, 50, 48, 50, 50, 48, 51, 48, 57, 49, 51, 51,
                  55, 48, 48, 43, 48, 53, 39, 51, 48, 39, 41, 47, 77, 111, 100,
                  68, 97, 116, 101, 40, 68, 58, 50, 48, 50, 50, 48, 51, 48, 57,
                  49, 51, 51, 55, 48, 48, 43, 48, 53, 39, 51, 48, 39, 41, 62,
                  62, 10, 101, 110, 100, 111, 98, 106, 10, 120, 114, 101, 102,
                  10, 48, 32, 49, 48, 10, 48, 48, 48, 48, 48, 48, 48, 48, 48,
                  48, 32, 54, 53, 53, 51, 53, 32, 102, 32, 10, 48, 48, 48, 48,
                  48, 49, 49, 52, 49, 56, 32, 48, 48, 48, 48, 48, 32, 110, 32,
                  10, 48, 48, 48, 48, 48, 48, 48, 48, 49, 53, 32, 48, 48, 48,
                  48, 48, 32, 110, 32, 10, 48, 48, 48, 48, 48, 49, 49, 53, 48,
                  54, 32, 48, 48, 48, 48, 48, 32, 110, 32, 10, 48, 48, 48, 48,
                  48, 48, 55, 56, 50, 50, 32, 48, 48, 48, 48, 48, 32, 110, 32,
                  10, 48, 48, 48, 48, 48, 48, 57, 49, 48, 49, 32, 48, 48, 48,
                  48, 48, 32, 110, 32, 10, 48, 48, 48, 48, 48, 49, 49, 53, 57,
                  57, 32, 48, 48, 48, 48, 48, 32, 110, 32, 10, 48, 48, 48, 48,
                  48, 49, 49, 50, 54, 51, 32, 48, 48, 48, 48, 48, 32, 110, 32,
                  10, 48, 48, 48, 48, 48, 49, 49, 54, 53, 48, 32, 48, 48, 48,
                  48, 48, 32, 110, 32, 10, 48, 48, 48, 48, 48, 49, 49, 54, 57,
                  53, 32, 48, 48, 48, 48, 48, 32, 110, 32, 10, 116, 114, 97,
                  105, 108, 101, 114, 10, 60, 60, 47, 83, 105, 122, 101, 32, 49,
                  48, 47, 82, 111, 111, 116, 32, 56, 32, 48, 32, 82, 47, 73,
                  110, 102, 111, 32, 57, 32, 48, 32, 82, 47, 73, 68, 32, 91, 60,
                  97, 98, 54, 99, 98, 55, 55, 53, 101, 100, 97, 57, 48, 56, 55,
                  98, 48, 101, 102, 52, 97, 55, 98, 98, 52, 54, 97, 51, 52, 101,
                  48, 99, 62, 60, 97, 98, 54, 99, 98, 55, 55, 53, 101, 100, 97,
                  57, 48, 56, 55, 98, 48, 101, 102, 52, 97, 55, 98, 98, 52, 54,
                  97, 51, 52, 101, 48, 99, 62, 93, 62, 62, 10, 37, 105, 84, 101,
                  120, 116, 45, 53, 46, 53, 46, 49, 51, 46, 50, 10, 115, 116,
                  97, 114, 116, 120, 114, 101, 102, 10, 49, 49, 56, 54, 48, 10,
                  37, 37, 69, 79, 70, 10,
                ],
                title: "E-Prescription",
                creation: "null",
              },
            },
          ],
        },
      },
    },
    {
      fullUrl: "Patient/5",
      resource: {
        patient: {
          resourceType: "Patient",
          id: "Patient/5",
          gender: "MALE",
          birthDate: "null",
          meta: {
            lastUpdated: "null",
            profile: [],
          },
          text: {},
          identifier: [],
          name: [
            {
              text: "Animesh",
            },
          ],
          telcom: [],
        },
      },
    },
  ],
};

export const OPCONSULTATION_REPORT = {
  resourceType: "Bundle",
  id: "OPConsultNote-example-05",
  meta: {
    versionId: "1",
    lastUpdated: "Thu Jul 09 15:32:26 IST 2020",
    profile: [
      "https://nrces.in/ndhm/fhir/r4/StructureDefinition/DocumentBundle",
    ],
    security: [
      {
        system: "http://terminology.hl7.org/CodeSystem/v3-Confidentiality",
        code: "V",
        display: "very restricted",
      },
    ],
  },
  identifier: {
    system: "http://hip.in",
    value: "305fecc2-4ba2-46cc-9ccd-efa755aff51d",
  },
  type: "DOCUMENT",
  timestamp: "Thu Jul 09 15:32:26 IST 2020",
  entry: [
    {
      fullUrl: "Composition/1",
      resource: {
        compositon: {
          resourceType: "Composition",
          id: "Composition/1/_history/1",
          status: "FINAL",
          language: "en-IN",
          date: "Thu Jul 09 15:32:26 IST 2020",
          title: "Consultation Report",
          confidentiality: "null",
          meta: {
            versionId: "1",
            lastUpdated: "Thu Jul 09 15:32:26 IST 2020",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/OPConsultRecord",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN"><h4>Narrative with Details</h4><p>This is a OP Consult Note for Patient ABC. Generated Summary: id: 1; Medical Record Number = 1234 (System : {https://healthid.ndhm.gov.in}); active; ABC ; ph: +919818512600(HOME); gender: male; birthDate: 1981-01-12</p></div>',
          },
          identifier: {
            system: "https://ndhm.in/phr",
            value: "645bb0c3-ff7e-4123-bef5-3852a4784813",
          },
          type: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "371530004",
                display: "Clinical consultation report",
              },
            ],
            text: "Clinical Consultation report",
          },
          subject: {
            reference: "Patient/1",
            display: "ABC",
          },
          encounter: {
            reference: "Encounter/1",
          },
          author: [
            {
              reference: "Practitioner/1",
              display: "Dr. DEF",
            },
          ],
          custodian: {
            reference: "Organization/1",
            display: "UVW Hospital",
          },
          section: [
            {
              title: "Chief complaints",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "722446000",
                    display: "Allergy record",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371529009",
                    display: "History and physical report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721963009",
                    display: "Order document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721912009",
                    display: "Medication summary document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371525003",
                    display: "Clinical procedure report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "736271009",
                    display: "Outpatient care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371530004",
                    display: "Clinical consultation report",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/1",
                },
                {
                  reference: "AllergyIntolerance/1",
                },
                {
                  reference: "Condition/2",
                },
                {
                  reference: "ServiceRequest/1",
                },
                {
                  reference: "MedicationStatement/1",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Appointment/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Allergies",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "722446000",
                    display: "Allergy record",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371529009",
                    display: "History and physical report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721963009",
                    display: "Order document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721912009",
                    display: "Medication summary document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371525003",
                    display: "Clinical procedure report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "736271009",
                    display: "Outpatient care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371530004",
                    display: "Clinical consultation report",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/1",
                },
                {
                  reference: "AllergyIntolerance/1",
                },
                {
                  reference: "Condition/2",
                },
                {
                  reference: "ServiceRequest/1",
                },
                {
                  reference: "MedicationStatement/1",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Appointment/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Medical History",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "722446000",
                    display: "Allergy record",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371529009",
                    display: "History and physical report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721963009",
                    display: "Order document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721912009",
                    display: "Medication summary document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371525003",
                    display: "Clinical procedure report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "736271009",
                    display: "Outpatient care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371530004",
                    display: "Clinical consultation report",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/1",
                },
                {
                  reference: "AllergyIntolerance/1",
                },
                {
                  reference: "Condition/2",
                },
                {
                  reference: "ServiceRequest/1",
                },
                {
                  reference: "MedicationStatement/1",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Appointment/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Investigation Advice",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "722446000",
                    display: "Allergy record",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371529009",
                    display: "History and physical report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721963009",
                    display: "Order document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721912009",
                    display: "Medication summary document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371525003",
                    display: "Clinical procedure report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "736271009",
                    display: "Outpatient care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371530004",
                    display: "Clinical consultation report",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/1",
                },
                {
                  reference: "AllergyIntolerance/1",
                },
                {
                  reference: "Condition/2",
                },
                {
                  reference: "ServiceRequest/1",
                },
                {
                  reference: "MedicationStatement/1",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Appointment/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Medications",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "722446000",
                    display: "Allergy record",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371529009",
                    display: "History and physical report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721963009",
                    display: "Order document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721912009",
                    display: "Medication summary document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371525003",
                    display: "Clinical procedure report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "736271009",
                    display: "Outpatient care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371530004",
                    display: "Clinical consultation report",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/1",
                },
                {
                  reference: "AllergyIntolerance/1",
                },
                {
                  reference: "Condition/2",
                },
                {
                  reference: "ServiceRequest/1",
                },
                {
                  reference: "MedicationStatement/1",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Appointment/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Procedure",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "722446000",
                    display: "Allergy record",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371529009",
                    display: "History and physical report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721963009",
                    display: "Order document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721912009",
                    display: "Medication summary document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371525003",
                    display: "Clinical procedure report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "736271009",
                    display: "Outpatient care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371530004",
                    display: "Clinical consultation report",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/1",
                },
                {
                  reference: "AllergyIntolerance/1",
                },
                {
                  reference: "Condition/2",
                },
                {
                  reference: "ServiceRequest/1",
                },
                {
                  reference: "MedicationStatement/1",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Appointment/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Follow Up",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "722446000",
                    display: "Allergy record",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371529009",
                    display: "History and physical report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721963009",
                    display: "Order document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721912009",
                    display: "Medication summary document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371525003",
                    display: "Clinical procedure report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "736271009",
                    display: "Outpatient care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371530004",
                    display: "Clinical consultation report",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/1",
                },
                {
                  reference: "AllergyIntolerance/1",
                },
                {
                  reference: "Condition/2",
                },
                {
                  reference: "ServiceRequest/1",
                },
                {
                  reference: "MedicationStatement/1",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Appointment/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Document Reference",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "722446000",
                    display: "Allergy record",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371529009",
                    display: "History and physical report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721963009",
                    display: "Order document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721912009",
                    display: "Medication summary document",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371525003",
                    display: "Clinical procedure report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "736271009",
                    display: "Outpatient care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "371530004",
                    display: "Clinical consultation report",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/1",
                },
                {
                  reference: "AllergyIntolerance/1",
                },
                {
                  reference: "Condition/2",
                },
                {
                  reference: "ServiceRequest/1",
                },
                {
                  reference: "MedicationStatement/1",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Appointment/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
          ],
        },
      },
    },
    {
      fullUrl: "Practitioner/1",
      resource: {
        practitioner: {
          resourceType: "Practitioner",
          id: "Practitioner/1/_history/1",
          meta: {
            versionId: "1",
            lastUpdated: "Thu Jul 09 15:32:26 IST 2020",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Practitioner",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Dr. DEF, MD (Medicine)</div>',
          },
          identifier: [
            {
              system: "https://doctor.ndhm.gov.in",
              value: "21-1521-3828-3227",
              type: {
                coding: [
                  {
                    system: "http://terminology.hl7.org/CodeSystem/v2-0203",
                    code: "MD",
                    display: "Medical License number",
                  },
                ],
              },
            },
          ],
          name: [
            {
              text: "Dr. DEF",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Organization/1",
      resource: {
        organization: {
          resourceType: "Organization",
          id: "Organization/1",
          name: "UVW Hospital",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Organization",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">UVW Hospital. ph: +91 273 2139 3632, email:<a href="mailto:contact@facility.uvw.org">contact@facility.uvw.org</a></div>',
          },
          identifier: [
            {
              system: "https://facility.ndhm.gov.in",
              value: "4567823",
              type: {
                coding: [
                  {
                    system: "http://terminology.hl7.org/CodeSystem/v2-0203",
                    code: "PRN",
                    display: "Provider number",
                  },
                ],
              },
            },
          ],
          telcom: [
            {
              system: "PHONE",
              value: "+91 273 2139 3632",
              use: "WORK",
            },
            {
              system: "EMAIL",
              value: "contact@facility.uvw.org",
              use: "WORK",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Patient/1",
      resource: {
        patient: {
          resourceType: "Patient",
          id: "Patient/1/_history/1",
          gender: "MALE",
          birthDate: "Mon Jan 12 00:00:00 IST 1981",
          meta: {
            versionId: "1",
            lastUpdated: "Thu Jul 09 14:58:58 IST 2020",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Patient",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">ABC, 41 year, Male</div>',
          },
          identifier: [
            {
              system: "https://healthid.ndhm.gov.in",
              value: "22-7225-4829-5255",
              type: {
                coding: [
                  {
                    system: "http://terminology.hl7.org/CodeSystem/v2-0203",
                    code: "MR",
                    display: "Medical record number",
                  },
                ],
              },
            },
          ],
          name: [
            {
              text: "ABC",
            },
          ],
          telcom: [
            {
              system: "PHONE",
              value: "+919818512600",
              use: "HOME",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Encounter/1",
      resource: {
        encounter: {
          resourceType: "Encounter",
          id: "Encounter/1",
          status: "FINISHED",
          meta: {
            lastUpdated: "Thu Jul 09 14:58:58 IST 2020",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Encounter",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Out Patient Consultation Encounter</div>',
          },
          identifier: [
            {
              system: "https://ndhm.in",
              value: "S100",
              type: {
                coding: [],
              },
            },
          ],
          encounterClass: {
            system: "http://terminology.hl7.org/CodeSystem/v3-ActCode",
            code: "AMB",
            display: "ambulatory",
          },
          subject: {
            reference: "Patient/1",
          },
          period: {
            start: "Thu Jul 09 14:58:58 IST 2020",
            end: "null",
          },
          hospitalization: {
            dischargeDisposition: {
              coding: [],
            },
          },
          diagnosis: [
            {
              condition: {
                reference: "Condition/1",
              },
              use: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "33962009",
                    display: "Chief complaint",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "148006",
                    display: "Preliminary diagnosis",
                  },
                ],
              },
            },
            {
              condition: {
                reference: "Condition/3",
              },
              use: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "33962009",
                    display: "Chief complaint",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "148006",
                    display: "Preliminary diagnosis",
                  },
                ],
              },
            },
          ],
        },
      },
    },
    {
      fullUrl: "AllergyIntolerance/1",
      resource: {
        allergyIntolerance: {
          resourceType: "AllergyIntolerance",
          id: "AllergyIntolerance/1",
          recordedDate: "Fri Jul 10 03:07:31 IST 2020",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/AllergyIntolerance",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">\n      <p>No Known Allergy</p>\n      <p>recordedDate:2015-08-06</p>\n    </div>',
          },
          clinicalStatus: {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/allergyintolerance-clinical",
                code: "active",
                display: "Active",
              },
            ],
          },
          verificationStatus: {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/allergyintolerance-clinical",
                code: "active",
                display: "Active",
              },
            ],
          },
          code: {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/allergyintolerance-clinical",
                code: "active",
                display: "Active",
              },
            ],
          },
          patient: {
            reference: "Patient/1",
          },
          recorder: {
            reference: "Practitioner/1",
          },
          note: [
            {
              text: "The patient reports no other known allergy.",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Appointment/1",
      resource: {
        appointment: {
          resourceType: "Appointment",
          id: "Appointment/1",
          status: "BOOKED",
          description:
            "Discussion on the results of your recent Lab Test and further consultation",
          start: "Sun Jul 12 14:30:00 IST 2020",
          end: "Sun Jul 12 15:00:00 IST 2020",
          created: "Thu Jul 09 14:58:58 IST 2020",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Appointment",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Brian MRI results discussion</div>',
          },
          serviceCategory: [
            {
              coding: [
                {
                  system: "http://snomed.info/sct",
                  code: "408443003",
                  display: "General medical practice",
                },
              ],
            },
          ],
          serviceType: [
            {
              coding: [
                {
                  system: "http://snomed.info/sct",
                  code: "11429006",
                  display: "Consultation",
                },
              ],
            },
          ],
          appointmentType: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "185389009",
                display: "Follow-up visit",
              },
            ],
          },
          reasonReference: [
            {
              reference: "Condition/1",
            },
          ],
          participant: [
            {
              status: "ACCEPTED",
              actor: {
                reference: "org.hl7.fhir.r4.model.Reference@572aba1a",
              },
            },
            {
              status: "ACCEPTED",
              actor: {
                reference: "org.hl7.fhir.r4.model.Reference@6160bc1c",
              },
            },
          ],
        },
      },
    },
    {
      fullUrl: "Condition/1",
      resource: {
        condition: {
          resourceType: "Condition",
          id: "Condition/1",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Condition",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Foot has swollen</div>',
          },
          clinicalStatus: {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/condition-clinical",
                code: "active",
                display: "Active",
              },
            ],
          },
          code: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "297142003",
                display: "Foot swelling",
              },
            ],
            text: "Foot swelling",
          },
          subject: {
            reference: "Patient/1",
          },
        },
      },
    },
    {
      fullUrl: "Condition/2",
      resource: {
        condition: {
          resourceType: "Condition",
          id: "Condition/2",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Condition",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Past Medical Problem of Diabetes mellitus type 1</div>',
          },
          clinicalStatus: {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/condition-clinical",
                code: "recurrence",
                display: "Recurrence",
              },
            ],
          },
          code: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "46635009",
                display: "Diabetes mellitus type 1",
              },
            ],
            text: "Diabetes mellitus type 1",
          },
          subject: {
            reference: "Patient/1",
          },
        },
      },
    },
    {
      fullUrl: "Condition/3",
      resource: {
        condition: {
          resourceType: "Condition",
          id: "Condition/3",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Condition",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Past Medical Problem of Diabetes mellitus type 2</div>',
          },
          clinicalStatus: {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/condition-clinical",
                code: "recurrence",
                display: "Recurrence",
              },
            ],
          },
          code: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "44054006",
                display: "Diabetes mellitus type 2",
              },
            ],
            text: "Diabetes mellitus type 2",
          },
          subject: {
            reference: "Patient/1",
          },
        },
      },
    },
    {
      fullUrl: "Procedure/1",
      resource: {
        procedure: {
          resourceType: "Procedure",
          id: "Procedure/1",
          status: "COMPLETED",
          performedDateTime: "DateTimeType[2019-05-12]",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Procedure",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Assessment of diabetic foot ulcer</div>',
          },
          code: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "713130008",
                display: "Assessment of diabetic foot ulcer",
              },
            ],
            text: "Assessment of diabetic foot ulcer",
          },
          subject: {
            reference: "Patient/1",
          },
          complication: [],
          followUp: [
            {
              coding: [],
            },
          ],
        },
      },
    },
    {
      fullUrl: "ServiceRequest/1",
      resource: {
        serviceRequest: {
          resourceType: "ServiceRequest",
          id: "ServiceRequest/1",
          status: "ACTIVE",
          intent: "ORDER",
          authoredOn: "Thu Jul 09 15:32:26 IST 2020",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/ServiceRequest",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Service Request for fasting lipid profile</div>',
          },
          category: [
            {
              coding: [
                {
                  system: "http://snomed.info/sct",
                  code: "108252007",
                  display: "Laboratory procedure",
                },
              ],
            },
          ],
          code: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "252150008",
                display: "Fasting lipid profile",
              },
            ],
            text: "Fasting lipid profile",
          },
          subject: {
            reference: "Patient/1",
          },
          requester: {
            reference: "Patient/1",
          },
        },
      },
    },
    {
      fullUrl: "MedicationStatement/1",
      resource: {
        medicationStatement: {
          resourceType: "MedicationStatement",
          id: "MedicationStatement/1",
          status: "COMPLETED",
          dateAsserted: "Sun Feb 02 14:58:58 IST 2020",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/MedicationStatement",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Atenolol 500 microgram/mL solution for injection</div>',
          },
          subject: {
            reference: "Patient/1",
          },
          medicationCodeableConcept: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "134463001",
                display: "Telmisartan 20 mg oral tablet",
              },
            ],
          },
        },
      },
    },
    {
      fullUrl: "MedicationRequest/1",
      resource: {
        medicationRequest: {
          resourceType: "MedicationRequest",
          id: "MedicationRequest/1",
          status: "ACTIVE",
          intent: "ORDER",
          authoredOn: "Thu Jul 09 00:00:00 IST 2020",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/MedicationRequest",
            ],
          },
          text: {
            status: "generated",
            div: '<div xmlns="http://www.w3.org/1999/xhtml"><p><b>Generated Narrative</b></p><p><b>status</b>: active</p><p><b>intent</b>: order</p><p><b>medication</b>: <span title="Codes: {http://snomed.info/sct 353231006}">Neomycin 5 microgram/mg cutaneous ointment</span></p><p><b>subject</b>: <a href="#Patient_1">ABC. Generated Summary: Medical record number: 22-7225-4829-5255; ABC; Phone: +919818512600; gender: male; birthDate: 1981-01-12</a></p><p><b>authoredOn</b>: 2020-07-09</p><p><b>requester</b>: <a href="#Practitioner_1">Dr. DEF. Generated Summary: Medical License number: 21-1521-3828-3227; Dr. DEF</a></p><p><b>reasonReference</b>: <a href="#Condition_1">See above (Condition/1)</a></p></div>',
          },
          medicationCodeableConcept: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "353231006",
                display: "Neomycin 5 microgram/mg cutaneous ointment",
              },
            ],
          },
          subject: {
            reference: "Patient/1",
            display: "ABC",
          },
          requester: {
            reference: "Patient/1",
            display: "ABC",
          },
          reasonReference: [
            {
              reference: "Condition/1",
            },
          ],
          dosageInstruction: [
            {
              additionalInstruction: [
                {
                  coding: [
                    {
                      system: "http://snomed.info/sct",
                      code: "229799001",
                      display: "Twice a day",
                    },
                  ],
                },
              ],
              timing: {
                repeat: {
                  frequency: "0",
                  period: "null",
                  periodUnit: "null",
                },
              },
              route: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "6064005",
                    display: "Topical route",
                  },
                ],
              },
              method: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "6064005",
                    display: "Topical route",
                  },
                ],
              },
            },
          ],
        },
      },
    },
  ],
  signature: {
    type: [
      {
        system: "urn:iso-astm:E1762-95:2013",
        code: "1.2.840.10065.1.12.1.1",
        display: "Author's Signature",
      },
    ],
    when: "Thu Jul 09 03:12:33 IST 2020",
    who: {
      reference: "Practitioner/1",
    },
    sigFormat: "image/jpeg",
    data: "[B@466930",
  },
};

export const INSTITUTE_LIST = [
  {
    id: "INST001",
    name: "SSKM HOSPITAL",
    hiuId: "",
    hipId: "SSKM_HIP",
    password: "pass",
  },
  {
    id: "INST002",
    name: "BANKURA HOSPITAL",
    hiuId: "Bankura_HIU",
    hipId: "",
    password: "pass",
  },
];

export const PROFILE = {
  healthIdNumber: "77-4658-1030-7200",
  healthId: "anianim03@sbx",
  mobile: "9433503272",
  firstName: "Animesh",
  middleName: "",
  lastName: "Sanyal",
  name: "Animesh Sanyal",
  yearOfBirth: "1977",
  dayOfBirth: "17",
  monthOfBirth: "1",
  gender: "M",
  email: "anianim03@gmail.com",
  profilePhoto:
    "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",
  stateCode: "19",
  districtCode: "312",
  subDistrictCode: null,
  villageCode: null,
  townCode: null,
  wardCode: null,
  pincode: "712245",
  address: " 216 K.PALLY 1NO. GOVERMENT COLONY Uttarpara Kotrung(M)",
  kycPhoto: null,
  stateName: "WEST BENGAL",
  districtName: "Hooghly",
  subdistrictName: null,
  villageName: null,
  townName: "Uttarpara Kotrung(M)",
  wardName: null,
  authMethods: ["MOBILE_OTP", "AADHAAR_OTP", "DEMOGRAPHICS", "AADHAAR_BIO"],
  tags: {},
  kycVerified: true,
  verificationStatus: null,
  verificationType: null,
  phrAddress: ["anianim03@sbx"],
  emailVerified: false,
  new: false,
};

export const UNLINKED_CARE_CONTEXT = {
  demographic: {
    patientrefno: "Ref001",
    healthid: "santojitg@sbx",
    name: "Santojit Ghosh",
    gender: "M",
    yearofbirth: "1975",
    mobile: "9433503272",
  },
  carecontexts: [
    {
      id: "	SSKM/RG2200000108/001",
      desc: "e prescription",
    },
    {
      id: "	SSKM/RG2200000108/002",
      desc: "Diagnosis Report",
    },
    {
      id: "	SSKM/RG2200000108/003",
      desc: "Diagnosis Report",
    },
  ],
};

export const DISCHARGE_SUMMARY = {
  resourceType: "Bundle",
  id: "DischargeSummary-example-04",
  meta: {
    versionId: "1",
    lastUpdated: "Thu Jul 09 15:32:26 IST 2020",
    profile: [
      "https://nrces.in/ndhm/fhir/r4/StructureDefinition/DocumentBundle",
    ],
    security: [
      {
        system: "http://terminology.hl7.org/CodeSystem/v3-Confidentiality",
        code: "V",
        display: "very restricted",
      },
    ],
  },
  identifier: {
    system: "http://hip.in",
    value: "eba2ef3a-320f-4f16-8789-ed64965943a3",
  },
  type: "DOCUMENT",
  timestamp: "Thu Jul 09 15:32:26 IST 2020",
  entry: [
    {
      fullUrl: "Composition/1",
      resource: {
        compositon: {
          resourceType: "Composition",
          id: "Composition/1/_history/1",
          status: "FINAL",
          language: "en-IN",
          date: "Thu Jul 09 15:32:26 IST 2020",
          title: "Discharge Summary",
          confidentiality: "N",
          meta: {
            versionId: "1",
            lastUpdated: "Thu Jul 09 15:32:26 IST 2020",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/DischargeSummaryRecord",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN"><h4>Narrative with Details</h4><p>This is a Discharge Summary record for Patient ABC. Generated Summary: id: 1; Medical Record Number = 1234 (System : {https://healthid.ndhm.gov.in}); active; ABC ; ph: +919818512600(HOME); gender: male; birthDate: 1981-01-12</p></div>',
          },
          identifier: {},
          type: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "373942005",
                display: "Discharge summary",
              },
            ],
            text: "Discharge Summary",
          },
          subject: {
            reference: "Patient/1",
          },
          encounter: {
            reference: "Encounter/1",
          },
          author: [
            {
              reference: "Practitioner/1",
            },
          ],
          custodian: {
            reference: "Organization/1",
          },
          section: [
            {
              title: "Chief complaints",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003642006",
                    display: "Past medical history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721981007",
                    display: "Diagnostic studies report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003640003",
                    display: "History of past procedure section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003606003",
                    display: "Medication history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "734163000",
                    display: "Care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "373942005",
                    display: "Discharge summary",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/2",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Condition/1",
                },
                {
                  reference: "DiagnosticReport/1",
                },
                {
                  reference: "Procedure/2",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "CarePlan/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Medical History",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003642006",
                    display: "Past medical history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721981007",
                    display: "Diagnostic studies report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003640003",
                    display: "History of past procedure section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003606003",
                    display: "Medication history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "734163000",
                    display: "Care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "373942005",
                    display: "Discharge summary",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/2",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Condition/1",
                },
                {
                  reference: "DiagnosticReport/1",
                },
                {
                  reference: "Procedure/2",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "CarePlan/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Investigations",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003642006",
                    display: "Past medical history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721981007",
                    display: "Diagnostic studies report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003640003",
                    display: "History of past procedure section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003606003",
                    display: "Medication history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "734163000",
                    display: "Care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "373942005",
                    display: "Discharge summary",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/2",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Condition/1",
                },
                {
                  reference: "DiagnosticReport/1",
                },
                {
                  reference: "Procedure/2",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "CarePlan/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Procedures",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003642006",
                    display: "Past medical history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721981007",
                    display: "Diagnostic studies report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003640003",
                    display: "History of past procedure section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003606003",
                    display: "Medication history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "734163000",
                    display: "Care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "373942005",
                    display: "Discharge summary",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/2",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Condition/1",
                },
                {
                  reference: "DiagnosticReport/1",
                },
                {
                  reference: "Procedure/2",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "CarePlan/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Medications",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003642006",
                    display: "Past medical history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721981007",
                    display: "Diagnostic studies report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003640003",
                    display: "History of past procedure section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003606003",
                    display: "Medication history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "734163000",
                    display: "Care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "373942005",
                    display: "Discharge summary",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/2",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Condition/1",
                },
                {
                  reference: "DiagnosticReport/1",
                },
                {
                  reference: "Procedure/2",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "CarePlan/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Care Plan",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003642006",
                    display: "Past medical history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721981007",
                    display: "Diagnostic studies report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003640003",
                    display: "History of past procedure section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003606003",
                    display: "Medication history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "734163000",
                    display: "Care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "373942005",
                    display: "Discharge summary",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/2",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Condition/1",
                },
                {
                  reference: "DiagnosticReport/1",
                },
                {
                  reference: "Procedure/2",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "CarePlan/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
            {
              title: "Document Reference",
              code: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "422843007",
                    display: "Chief complaint section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003642006",
                    display: "Past medical history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "721981007",
                    display: "Diagnostic studies report",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003640003",
                    display: "History of past procedure section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "1003606003",
                    display: "Medication history section",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "734163000",
                    display: "Care plan",
                  },
                  {
                    system: "http://snomed.info/sct",
                    code: "373942005",
                    display: "Discharge summary",
                  },
                ],
              },
              entry: [
                {
                  reference: "Condition/2",
                },
                {
                  reference: "Procedure/1",
                },
                {
                  reference: "Condition/1",
                },
                {
                  reference: "DiagnosticReport/1",
                },
                {
                  reference: "Procedure/2",
                },
                {
                  reference: "MedicationRequest/1",
                },
                {
                  reference: "CarePlan/1",
                },
                {
                  reference: "DocumentReference/1",
                },
              ],
            },
          ],
        },
      },
    },
    {
      fullUrl: "Practitioner/1",
      resource: {
        practitioner: {
          resourceType: "Practitioner",
          id: "Practitioner/1/_history/1",
          meta: {
            versionId: "1",
            lastUpdated: "Thu Jul 09 15:32:26 IST 2020",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Practitioner",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Dr. DEF, MD (Medicine)</div>',
          },
          identifier: [
            {
              system: "https://doctor.ndhm.gov.in",
              value: "21-1521-3828-3227",
              type: {
                coding: [
                  {
                    system: "http://terminology.hl7.org/CodeSystem/v2-0203",
                    code: "MD",
                    display: "Medical License number",
                  },
                ],
              },
            },
          ],
          name: [
            {
              text: "DEF",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Organization/1",
      resource: {
        organization: {
          resourceType: "Organization",
          id: "Organization/1",
          name: "UVW Hospital",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Organization",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">UVW Hospital. ph: +91 273 2139 3632, email:<a href="mailto:contact@facility.uvw.org">contact@facility.uvw.org</a></div>',
          },
          identifier: [
            {
              system: "https://facility.ndhm.gov.in",
              value: "4567823",
              type: {
                coding: [
                  {
                    system: "http://terminology.hl7.org/CodeSystem/v2-0203",
                    code: "PRN",
                    display: "Provider number",
                  },
                ],
              },
            },
          ],
          telcom: [
            {
              system: "PHONE",
              value: "+91 273 2139 3632",
              use: "WORK",
            },
            {
              system: "EMAIL",
              value: "contact@facility.uvw.org",
              use: "WORK",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Organization/2",
      resource: {
        organization: {
          resourceType: "Organization",
          id: "Organization/1",
          name: "XYZ Lab Pvt.Ltd.",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Organization",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">XYZ Lab Pvt.Ltd. ph: +91 243 2634 1234, email:<a href="mailto:contact@labs.xyz.org">contact@labs.xyz.org</a></div>',
          },
          identifier: [
            {
              system: "https://facility.ndhm.gov.in",
              value: "4567878",
              type: {
                coding: [
                  {
                    system: "http://terminology.hl7.org/CodeSystem/v2-0203",
                    code: "PRN",
                    display: "Provider number",
                  },
                ],
              },
            },
          ],
          telcom: [
            {
              system: "PHONE",
              value: "+91 243 2634 1234",
              use: "WORK",
            },
            {
              system: "EMAIL",
              value: "contact@labs.xyz.org",
              use: "WORK",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Patient/1",
      resource: {
        patient: {
          resourceType: "Patient",
          id: "Patient/1/_history/1",
          gender: "MALE",
          birthDate: "Mon Jan 12 00:00:00 IST 1981",
          meta: {
            versionId: "1",
            lastUpdated: "Thu Jul 09 14:58:58 IST 2020",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Patient",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">ABC, 41 year, Male</div>',
          },
          identifier: [
            {
              system: "https://healthid.ndhm.gov.in",
              value: "22-7225-4829-5255",
              type: {
                coding: [
                  {
                    system: "http://terminology.hl7.org/CodeSystem/v2-0203",
                    code: "MR",
                    display: "Medical record number",
                  },
                ],
              },
            },
          ],
          name: [
            {
              text: "ABC",
            },
          ],
          telcom: [
            {
              system: "PHONE",
              value: "+919818512600",
              use: "HOME",
            },
          ],
        },
      },
    },
    {
      fullUrl: "Encounter/1",
      resource: {
        encounter: {
          resourceType: "Encounter",
          id: "Encounter/1",
          status: "FINISHED",
          meta: {
            lastUpdated: "Thu Jul 09 14:58:58 IST 2020",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Encounter",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN"> Admitted to Cardiac Unit,UVW Hospital between June 28 and July 9 2020</div>',
          },
          identifier: [
            {
              system: "https://ndhm.in",
              value: "S100",
              type: {
                coding: [],
              },
            },
          ],
          encounterClass: {
            system: "http://terminology.hl7.org/CodeSystem/v3-ActCode",
            code: "IMP",
            display: "inpatient encounter",
          },
          subject: {
            reference: "Patient/1",
          },
          period: {
            start: "Mon Apr 20 15:32:26 IST 2020",
            end: "Fri May 01 15:32:26 IST 2020",
          },
          hospitalization: {
            dischargeDisposition: {
              coding: [
                {
                  system:
                    "http://terminology.hl7.org/CodeSystem/discharge-disposition",
                  code: "home",
                  display: "Home",
                },
              ],
              text: "Discharged to Home Care",
            },
          },
          diagnosis: [],
        },
      },
    },
    {
      fullUrl: "Appointment/1",
      resource: {
        appointment: {
          resourceType: "Appointment",
          id: "Appointment/1",
          status: "BOOKED",
          description:
            "Discussion on the results of your recent Lab Test and further consultation",
          start: "Sun Jul 12 14:30:00 IST 2020",
          end: "Sun Jul 12 15:00:00 IST 2020",
          created: "Thu Jul 09 14:58:58 IST 2020",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Appointment",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Follow up for further consultation</div>',
          },
          serviceCategory: [
            {
              coding: [
                {
                  system: "http://snomed.info/sct",
                  code: "408443003",
                  display: "General medical practice",
                },
              ],
            },
          ],
          serviceType: [
            {
              coding: [
                {
                  system: "http://snomed.info/sct",
                  code: "11429006",
                  display: "Consultation",
                },
              ],
            },
          ],
          appointmentType: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "185389009",
                display: "Follow-up visit",
              },
            ],
          },
          reasonReference: [
            {
              reference: "Condition/1",
            },
          ],
          participant: [
            {
              status: "ACCEPTED",
              actor: {
                reference: "org.hl7.fhir.r4.model.Reference@493151bd",
              },
            },
            {
              status: "ACCEPTED",
              actor: {
                reference: "org.hl7.fhir.r4.model.Reference@6777b9b7",
              },
            },
          ],
        },
      },
    },
    {
      fullUrl: "Condition/1",
      resource: {
        condition: {
          resourceType: "Condition",
          id: "Condition/1",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Condition",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">History of aortoiliac atherosclerosis</div>',
          },
          clinicalStatus: {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/condition-clinical",
                code: "recurrence",
                display: "Recurrence",
              },
            ],
          },
          code: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "440700005",
                display: "History of aortoiliac atherosclerosis",
              },
            ],
            text: "Patient complained about pain in left arm",
          },
          subject: {
            reference: "Patient/1",
          },
        },
      },
    },
    {
      fullUrl: "Condition/2",
      resource: {
        condition: {
          resourceType: "Condition",
          id: "Condition/2",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Condition",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Myocardial infarction</div>',
          },
          clinicalStatus: {
            coding: [
              {
                system:
                  "http://terminology.hl7.org/CodeSystem/condition-clinical",
                code: "active",
                display: "Active",
              },
            ],
          },
          code: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "22298006",
                display: "Myocardial infarction",
              },
            ],
            text: "pain in the chest, neck, back or arms, as well as fatigue, lightheadedness, abnormal heartbeat and anxiety.",
          },
          subject: {
            reference: "Patient/1",
          },
        },
      },
    },
    {
      fullUrl: "Specimen/1",
      resource: {
        specimen: {
          resourceType: "Specimen",
          id: "Specimen/1",
          receivedTime: "Wed Jul 08 12:10:17 IST 2015",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Specimen",
            ],
          },
          text: {
            status: "generated",
            div: '<div xmlns="http://www.w3.org/1999/xhtml"><p><b>Generated Narrative</b></p><p><b>type</b>: <span title="Codes: {http://snomed.info/sct 119364003}">Serum specimen</span></p><p><b>subject</b>: <a href="#Patient_1">See above (Patient/1)</a></p><p><b>receivedTime</b>: 8 Jul, 2015 12:10:17 PM</p><h3>Collections</h3><table class="grid"><tr><td>-</td><td><b>Collected[x]</b></td></tr><tr><td>*</td><td>8 Jul, 2020 12:10:17 PM</td></tr></table></div>',
          },
          type: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "119364003",
                display: "Serum specimen",
              },
            ],
          },
          subject: {
            reference: "Patient/1",
          },
          collection: {
            collectedDateTime: "DateTimeType[2020-07-08T06:40:17Z]",
          },
        },
      },
    },
    {
      fullUrl: "Observation/cholesterol",
      resource: {
        observation: {
          resourceType: "Observation",
          id: "Observation/cholesterol",
          status: "FINAL",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Observation",
            ],
          },
          text: {
            status: "generated",
            div: "<div xml:lang=\"en-IN\" xmlns=\"http://www.w3.org/1999/xhtml\" lang=\"en-IN\"><p><b>Generated Narrative with Details</b></p><p><b>id</b>: cholesterol</p><p><b>status</b>: final</p><p><b>code</b>: Cholesterol <span>(Details : {LOINC code '35200-5' = 'Cholesterol [Mass or Moles/volume] in Serum or Plasma', given as 'Cholesterol [Moles/​volume] in Serum or Plasma'})</span></p><p><b>subject</b>: <a>ABC</a></p><p><b>performer</b>: <a>XYZ Lab Pvt.Ltd.</a></p><p><b>value</b>: 6.3 mmol/L<span> (Details: UCUM code mmol/L = 'mmol/L')</span></p><h3>ReferenceRanges</h3><table><tr><td>-</td><td><b>High</b></td></tr><tr><td>*</td><td>4.5 mmol/L<span> (Details: UCUM code mmol/L = 'mmol/L')</span></td></tr></table></div>",
          },
          subject: {
            reference: "Patient/1",
          },
          performer: [
            {
              reference: "Organization/2",
            },
          ],
          valueQuantity: {
            value: "6.3",
            unit: "mmol/L",
            system: "http://snomed.info/sct",
            code: "258813002",
          },
          referenceRange: [
            {
              high: {
                value: "4.5",
                unit: "mmol/L",
                system: "http://snomed.info/sct",
                code: "258813002",
              },
            },
          ],
        },
      },
    },
    {
      fullUrl: "Observation/triglyceride",
      resource: {
        observation: {
          resourceType: "Observation",
          id: "Observation/triglyceride",
          status: "FINAL",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Observation",
            ],
          },
          text: {
            status: "generated",
            div: "<div xml:lang=\"en-IN\" xmlns=\"http://www.w3.org/1999/xhtml\" lang=\"en-IN\"><p><b>Generated Narrative with Details</b></p><p><b>id</b>: triglyceride</p><p><b>status</b>: final</p><p><b>code</b>: Triglyceride <span>(Details : {LOINC code '35217-9' = 'Triglyceride [Mass or Moles/volume] in Serum or Plasma', given as 'Triglyceride [Moles/​volume] in Serum or Plasma'})</span></p><p><b>subject</b>: <a>ABC</a></p><p><b>performer</b>: <a>XYZ Lab Pvt.Ltd.</a></p><p><b>value</b>: 1.3 mmol/L<span> (Details: UCUM code mmol/L = 'mmol/L')</span></p><h3>ReferenceRanges</h3><table><tr><td>-</td><td><b>High</b></td></tr><tr><td>*</td><td>2.0 mmol/L<span> (Details: UCUM code mmol/L = 'mmol/L')</span></td></tr></table></div>",
          },
          subject: {
            reference: "Patient/1",
          },
          performer: [
            {
              reference: "Organization/2",
            },
          ],
          valueQuantity: {
            value: "1.3",
            unit: "mmol/L",
            system: "http://snomed.info/sct",
            code: "258813002",
          },
          referenceRange: [
            {
              high: {
                value: "2.0",
                unit: "mmol/L",
                system: "http://snomed.info/sct",
                code: "258813002",
              },
            },
          ],
        },
      },
    },
    {
      fullUrl: "Procedure/1",
      resource: {
        procedure: {
          resourceType: "Procedure",
          id: "Procedure/1",
          status: "COMPLETED",
          performedDateTime: "DateTimeType[2019-05-12]",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Procedure",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Placement of stent in coronary artery</div>',
          },
          code: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "36969009",
                display: "Placement of stent in coronary artery",
              },
            ],
            text: "Placement of stent in coronary artery",
          },
          subject: {
            reference: "Patient/1",
          },
          complication: [
            {
              coding: [
                {
                  system: "http://snomed.info/sct",
                  code: "131148009",
                  display: "Bleeding",
                },
              ],
            },
          ],
          followUp: [],
        },
      },
    },
    {
      fullUrl: "Procedure/2",
      resource: {
        procedure: {
          resourceType: "Procedure",
          id: "Procedure/1",
          status: "COMPLETED",
          performedDateTime: "DateTimeType[2020-07-05]",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/Procedure",
            ],
          },
          text: {
            status: "generated",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Coronary artery bypass grafting</div>',
          },
          code: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "232717009",
                display: "Coronary artery bypass grafting",
              },
            ],
            text: "Coronary artery bypass grafting",
          },
          subject: {
            reference: "Patient/1",
          },
          complication: [],
          followUp: [],
        },
      },
    },
    {
      fullUrl: "MedicationRequest/1",
      resource: {
        medicationRequest: {
          resourceType: "MedicationRequest",
          id: "MedicationRequest/1",
          status: "ACTIVE",
          intent: "ORDER",
          authoredOn: "Thu Jul 09 00:00:00 IST 2020",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/MedicationRequest",
            ],
          },
          text: {
            status: "generated",
            div: '<div xmlns="http://www.w3.org/1999/xhtml"><p><b>Generated Narrative</b></p><p><b>status</b>: active</p><p><b>intent</b>: order</p><p><b>medication</b>: <span title="Codes: {http://snomed.info/sct 765082007}">Nitroglycerin 5 mg buccal tablet</span></p><p><b>subject</b>: <a href="#Patient_1">ABC. Generated Summary: Medical record number: 22-7225-4829-5255; ABC; Phone: +919818512600; gender: male; birthDate: 1981-01-12</a></p><p><b>authoredOn</b>: 2020-07-09</p><p><b>requester</b>: <a href="#Practitioner_1">DEF. Generated Summary: Medical License number: 21-1521-3828-3227; DEF</a></p><p><b>reasonReference</b>: <a href="#Condition_2">See above (Condition/2)</a></p></div>',
          },
          medicationCodeableConcept: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "765082007",
                display: "Nitroglycerin 5 mg buccal tablet",
              },
            ],
          },
          subject: {
            reference: "Patient/1",
            display: "ABC",
          },
          requester: {
            reference: "Patient/1",
            display: "ABC",
          },
          reasonReference: [
            {
              reference: "Condition/2",
            },
          ],
          dosageInstruction: [
            {
              text: "One tablet at once",
              additionalInstruction: [
                {
                  coding: [
                    {
                      system: "http://snomed.info/sct",
                      code: "311504000",
                      display: "With or after food",
                    },
                  ],
                },
              ],
              timing: {
                repeat: {
                  frequency: "1",
                  period: "1",
                  periodUnit: "D",
                },
              },
              route: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "26643006",
                    display: "Oral Route",
                  },
                ],
              },
              method: {
                coding: [
                  {
                    system: "http://snomed.info/sct",
                    code: "26643006",
                    display: "Oral Route",
                  },
                ],
              },
            },
          ],
        },
      },
    },
    {
      fullUrl: "CarePlan/1",
      resource: {
        carePlan: {
          resourceType: "CarePlan",
          id: "CarePlan/1",
          status: "ACTIVE",
          intent: "PLAN",
          description:
            "Treatment of coronary artery and related disease problems",
          title: "Coronary heart disease care plan",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/CarePlan",
            ],
          },
          text: {
            status: "additional",
            div: '<div xml:lang="en-IN" xmlns="http://www.w3.org/1999/xhtml" lang="en-IN">Care Plan</div>',
          },
          category: [
            {
              coding: [
                {
                  system: "http://snomed.info/sct",
                  code: "736368003",
                  display: "Coronary heart disease care plan",
                },
              ],
            },
          ],
          subject: {
            reference: "Patient/1",
            display: "ABC",
          },
          activity: [
            {
              outcomeReference: [
                {
                  reference: "Appointment/1",
                },
              ],
            },
          ],
        },
      },
    },
    {
      fullUrl: "DocumentReference/1",
      resource: {
        documentReference: {
          resourceType: "DocumentReference",
          id: "DocumentReference/1",
          status: "CURRENT",
          docStatus: "FINAL",
          meta: {
            lastUpdated: "null",
            profile: [
              "https://nrces.in/ndhm/fhir/r4/StructureDefinition/DocumentReference",
            ],
          },
          text: {
            status: "generated",
            div: '<div xmlns="http://www.w3.org/1999/xhtml"><p><b>Generated Narrative</b></p><p><b>status</b>: current</p><p><b>docStatus</b>: final</p><p><b>type</b>: <span title="Codes: {http://snomed.info/sct 373942005}">Discharge Summary</span></p><p><b>subject</b>: <a href="#Patient_1">See above (Patient/1)</a></p><blockquote><p><b>content</b></p></blockquote></div>',
          },
          type: {
            coding: [
              {
                system: "http://snomed.info/sct",
                code: "373942005",
                display: "Discharge Summary",
              },
            ],
          },
          subject: {
            reference: "Patient/1",
          },
          content: [
            {
              attachment: {
                contentType: "application/pdf",
                language: "en-IN",
                data: "[B@6ad0a925",
                title: "Discharge Summary",
                creation: "Thu Jul 09 11:46:09 IST 2020",
              },
            },
          ],
        },
      },
    },
  ],
  signature: {
    type: [
      {
        system: "urn:iso-astm:E1762-95:2013",
        code: "1.2.840.10065.1.12.1.1",
        display: "Author's Signature",
      },
    ],
    when: "Thu Jul 09 03:12:33 IST 2020",
    who: {
      reference: "Practitioner/1",
    },
    sigFormat: "image/jpeg",
    data: "[B@59a2b709",
  },
};

export const DISCHARGE_SUMMARY1 = {
  resourceType: "Patient",
  id: "pat3",
  text: {
    status: "generated",
    div: '<div xmlns="http://www.w3.org/1999/xhtml">\n      \n      <p>Patient Simon Notsowell @ Acme Healthcare, Inc. MR = 123457, DECEASED</p>\n    \n    </div>',
  },
  identifier: [
    {
      use: "usual",
      type: {
        coding: [
          {
            system: "http://terminology.hl7.org/CodeSystem/v2-0203",
            code: "MR",
          },
        ],
      },
      system: "urn:oid:0.1.2.3.4.5.6.7",
      value: "123457",
    },
  ],
  active: true,
  name: [
    {
      use: "official",
      family: "Notsowell",
      given: ["Simon"],
    },
  ],
  gender: "male",
  birthDate: "1982-01-23",
  deceasedDateTime: "2015-02-14T13:42:00+10:00",
  managingOrganization: {
    reference: "Organization/1",
    display: "ACME Healthcare, Inc",
  },
};

export const HMIS_DATA = [
  {
    slno: 1,
    CareContextID: 8,
    CareContexNo: "SSKM/RG2200000108/100",
    CareContextDesc: "e prescription",
    NINNumber: "1112423338",
    HospitalCode: "2250",
    RegNo: "SSKM/RG2200000108",
    Regdate: "2022-02-02T17:00:19.78",
    CareContextDate: "2022-02-02T00:00:00",
    CareContextType: "e prescription",
    CareContextRefID: 12,
    HealthID: "kausik.saha@sbx",
    HealthIDNumber: "71-0553-0268-3816",
    IsLinkConfirmed: null,
    LinkConfirmedDateTime: null,
    MobileNo: "7980724867",
    Gender: "M         ",
    BirthYear: 1987,
    Name: "Kausik Saha",
    LinkMode: null,
    LinkBY: null,
  },
];
